(() => {
  // src/lib/klaviyo.ts
  var _a;
  var learnq = window._learnq = (_a = window._learnq) != null ? _a : [];
  var KlaviyoATC = (cart3, item) => {
    const data2 = {
      total_price: cart3.total_price / 100,
      $value: cart3.total_price / 100,
      total_discount: cart3.total_discount,
      original_total_price: cart3.original_total_price / 100,
      items: cart3.items,
      ...item
    };
    learnq.push(["track", "Added to Cart", data2]);
  };
  var cartData = null;
  var KlaviyoHandlers = {
    "add.js": async (response) => {
      if (!response.ok || !cartData) return;
      const { items } = await response.clone().json();
      KlaviyoATC(cartData, items[0]);
    },
    "cart.js": async (response) => {
      if (!response.ok) return;
      cartData = await response.clone().json();
    }
  };
  var originalFetch = window.fetch;
  window.fetch = function(path, ...options2) {
    var _a4, _b2;
    if (typeof path !== "string" || !path.includes("/cart"))
      return originalFetch(path, ...options2);
    const responsePromise = originalFetch(path, ...options2);
    responsePromise.then(
      (_b2 = KlaviyoHandlers[(_a4 = path.split("/cart/")[1]) != null ? _a4 : "cart.js"]) != null ? _b2 : () => {
      }
      // eslint-disable-line @typescript-eslint/no-empty-function
    );
    return responsePromise;
  };

  // node_modules/.pnpm/alpinejs@3.14.9/node_modules/alpinejs/dist/module.esm.js
  var flushPending = false;
  var flushing = false;
  var queue = [];
  var lastFlushedIndex = -1;
  function scheduler(callback) {
    queueJob(callback);
  }
  function queueJob(job) {
    if (!queue.includes(job))
      queue.push(job);
    queueFlush();
  }
  function dequeueJob(job) {
    let index2 = queue.indexOf(job);
    if (index2 !== -1 && index2 > lastFlushedIndex)
      queue.splice(index2, 1);
  }
  function queueFlush() {
    if (!flushing && !flushPending) {
      flushPending = true;
      queueMicrotask(flushJobs);
    }
  }
  function flushJobs() {
    flushPending = false;
    flushing = true;
    for (let i = 0; i < queue.length; i++) {
      queue[i]();
      lastFlushedIndex = i;
    }
    queue.length = 0;
    lastFlushedIndex = -1;
    flushing = false;
  }
  var reactive;
  var effect;
  var release;
  var raw;
  var shouldSchedule = true;
  function disableEffectScheduling(callback) {
    shouldSchedule = false;
    callback();
    shouldSchedule = true;
  }
  function setReactivityEngine(engine) {
    reactive = engine.reactive;
    release = engine.release;
    effect = (callback) => engine.effect(callback, { scheduler: (task) => {
      if (shouldSchedule) {
        scheduler(task);
      } else {
        task();
      }
    } });
    raw = engine.raw;
  }
  function overrideEffect(override) {
    effect = override;
  }
  function elementBoundEffect(el) {
    let cleanup2 = () => {
    };
    let wrappedEffect = (callback) => {
      let effectReference = effect(callback);
      if (!el._x_effects) {
        el._x_effects = /* @__PURE__ */ new Set();
        el._x_runEffects = () => {
          el._x_effects.forEach((i) => i());
        };
      }
      el._x_effects.add(effectReference);
      cleanup2 = () => {
        if (effectReference === void 0)
          return;
        el._x_effects.delete(effectReference);
        release(effectReference);
      };
      return effectReference;
    };
    return [wrappedEffect, () => {
      cleanup2();
    }];
  }
  function watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = effect(() => {
      let value = getter();
      JSON.stringify(value);
      if (!firstTime) {
        queueMicrotask(() => {
          callback(value, oldValue);
          oldValue = value;
        });
      } else {
        oldValue = value;
      }
      firstTime = false;
    });
    return () => release(effectReference);
  }
  var onAttributeAddeds = [];
  var onElRemoveds = [];
  var onElAddeds = [];
  function onElAdded(callback) {
    onElAddeds.push(callback);
  }
  function onElRemoved(el, callback) {
    if (typeof callback === "function") {
      if (!el._x_cleanups)
        el._x_cleanups = [];
      el._x_cleanups.push(callback);
    } else {
      callback = el;
      onElRemoveds.push(callback);
    }
  }
  function onAttributesAdded(callback) {
    onAttributeAddeds.push(callback);
  }
  function onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups)
      el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name])
      el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
  }
  function cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups)
      return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value]) => {
      if (names === void 0 || names.includes(name)) {
        value.forEach((i) => i());
        delete el._x_attributeCleanups[name];
      }
    });
  }
  function cleanupElement(el) {
    var _a4, _b2;
    (_a4 = el._x_effects) == null ? void 0 : _a4.forEach(dequeueJob);
    while ((_b2 = el._x_cleanups) == null ? void 0 : _b2.length)
      el._x_cleanups.pop()();
  }
  var observer = new MutationObserver(onMutate);
  var currentlyObserving = false;
  function startObservingMutations() {
    observer.observe(document, { subtree: true, childList: true, attributes: true, attributeOldValue: true });
    currentlyObserving = true;
  }
  function stopObservingMutations() {
    flushObserver();
    observer.disconnect();
    currentlyObserving = false;
  }
  var queuedMutations = [];
  function flushObserver() {
    let records = observer.takeRecords();
    queuedMutations.push(() => records.length > 0 && onMutate(records));
    let queueLengthWhenTriggered = queuedMutations.length;
    queueMicrotask(() => {
      if (queuedMutations.length === queueLengthWhenTriggered) {
        while (queuedMutations.length > 0)
          queuedMutations.shift()();
      }
    });
  }
  function mutateDom(callback) {
    if (!currentlyObserving)
      return callback();
    stopObservingMutations();
    let result = callback();
    startObservingMutations();
    return result;
  }
  var isCollecting = false;
  var deferredMutations = [];
  function deferMutations() {
    isCollecting = true;
  }
  function flushAndStopDeferringMutations() {
    isCollecting = false;
    onMutate(deferredMutations);
    deferredMutations = [];
  }
  function onMutate(mutations) {
    if (isCollecting) {
      deferredMutations = deferredMutations.concat(mutations);
      return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for (let i = 0; i < mutations.length; i++) {
      if (mutations[i].target._x_ignoreMutationObserver)
        continue;
      if (mutations[i].type === "childList") {
        mutations[i].removedNodes.forEach((node) => {
          if (node.nodeType !== 1)
            return;
          if (!node._x_marker)
            return;
          removedNodes.add(node);
        });
        mutations[i].addedNodes.forEach((node) => {
          if (node.nodeType !== 1)
            return;
          if (removedNodes.has(node)) {
            removedNodes.delete(node);
            return;
          }
          if (node._x_marker)
            return;
          addedNodes.push(node);
        });
      }
      if (mutations[i].type === "attributes") {
        let el = mutations[i].target;
        let name = mutations[i].attributeName;
        let oldValue = mutations[i].oldValue;
        let add2 = () => {
          if (!addedAttributes.has(el))
            addedAttributes.set(el, []);
          addedAttributes.get(el).push({ name, value: el.getAttribute(name) });
        };
        let remove = () => {
          if (!removedAttributes.has(el))
            removedAttributes.set(el, []);
          removedAttributes.get(el).push(name);
        };
        if (el.hasAttribute(name) && oldValue === null) {
          add2();
        } else if (el.hasAttribute(name)) {
          remove();
          add2();
        } else {
          remove();
        }
      }
    }
    removedAttributes.forEach((attrs, el) => {
      cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el) => {
      onAttributeAddeds.forEach((i) => i(el, attrs));
    });
    for (let node of removedNodes) {
      if (addedNodes.some((i) => i.contains(node)))
        continue;
      onElRemoveds.forEach((i) => i(node));
    }
    for (let node of addedNodes) {
      if (!node.isConnected)
        continue;
      onElAddeds.forEach((i) => i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
  }
  function scope(node) {
    return mergeProxies(closestDataStack(node));
  }
  function addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [data2, ...closestDataStack(referenceNode || node)];
    return () => {
      node._x_dataStack = node._x_dataStack.filter((i) => i !== data2);
    };
  }
  function closestDataStack(node) {
    if (node._x_dataStack)
      return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) {
      return closestDataStack(node.host);
    }
    if (!node.parentNode) {
      return [];
    }
    return closestDataStack(node.parentNode);
  }
  function mergeProxies(objects) {
    return new Proxy({ objects }, mergeProxyTrap);
  }
  var mergeProxyTrap = {
    ownKeys({ objects }) {
      return Array.from(
        new Set(objects.flatMap((i) => Object.keys(i)))
      );
    },
    has({ objects }, name) {
      if (name == Symbol.unscopables)
        return false;
      return objects.some(
        (obj) => Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name)
      );
    },
    get({ objects }, name, thisProxy) {
      if (name == "toJSON")
        return collapseProxies;
      return Reflect.get(
        objects.find(
          (obj) => Reflect.has(obj, name)
        ) || {},
        name,
        thisProxy
      );
    },
    set({ objects }, name, value, thisProxy) {
      const target = objects.find(
        (obj) => Object.prototype.hasOwnProperty.call(obj, name)
      ) || objects[objects.length - 1];
      const descriptor = Object.getOwnPropertyDescriptor(target, name);
      if ((descriptor == null ? void 0 : descriptor.set) && (descriptor == null ? void 0 : descriptor.get))
        return descriptor.set.call(thisProxy, value) || true;
      return Reflect.set(target, name, value);
    }
  };
  function collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key3) => {
      acc[key3] = Reflect.get(this, key3);
      return acc;
    }, {});
  }
  function initInterceptors(data2) {
    let isObject2 = (val) => typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "") => {
      Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key3, { value, enumerable }]) => {
        if (enumerable === false || value === void 0)
          return;
        if (typeof value === "object" && value !== null && value.__v_skip)
          return;
        let path = basePath === "" ? key3 : `${basePath}.${key3}`;
        if (typeof value === "object" && value !== null && value._x_interceptor) {
          obj[key3] = value.initialize(data2, path, key3);
        } else {
          if (isObject2(value) && value !== obj && !(value instanceof Element)) {
            recurse(value, path);
          }
        }
      });
    };
    return recurse(data2);
  }
  function interceptor(callback, mutateObj = () => {
  }) {
    let obj = {
      initialValue: void 0,
      _x_interceptor: true,
      initialize(data2, path, key3) {
        return callback(this.initialValue, () => get(data2, path), (value) => set(data2, path, value), path, key3);
      }
    };
    mutateObj(obj);
    return (initialValue) => {
      if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
        let initialize = obj.initialize.bind(obj);
        obj.initialize = (data2, path, key3) => {
          let innerValue = initialValue.initialize(data2, path, key3);
          obj.initialValue = innerValue;
          return initialize(data2, path, key3);
        };
      } else {
        obj.initialValue = initialValue;
      }
      return obj;
    };
  }
  function get(obj, path) {
    return path.split(".").reduce((carry, segment) => carry[segment], obj);
  }
  function set(obj, path, value) {
    if (typeof path === "string")
      path = path.split(".");
    if (path.length === 1)
      obj[path[0]] = value;
    else if (path.length === 0)
      throw error;
    else {
      if (obj[path[0]])
        return set(obj[path[0]], path.slice(1), value);
      else {
        obj[path[0]] = {};
        return set(obj[path[0]], path.slice(1), value);
      }
    }
  }
  var magics = {};
  function magic(name, callback) {
    magics[name] = callback;
  }
  function injectMagics(obj, el) {
    let memoizedUtilities = getUtilities(el);
    Object.entries(magics).forEach(([name, callback]) => {
      Object.defineProperty(obj, `$${name}`, {
        get() {
          return callback(el, memoizedUtilities);
        },
        enumerable: false
      });
    });
    return obj;
  }
  function getUtilities(el) {
    let [utilities, cleanup2] = getElementBoundUtilities(el);
    let utils = { interceptor, ...utilities };
    onElRemoved(el, cleanup2);
    return utils;
  }
  function tryCatch(el, expression, callback, ...args) {
    try {
      return callback(...args);
    } catch (e) {
      handleError(e, el, expression);
    }
  }
  function handleError(error2, el, expression = void 0) {
    error2 = Object.assign(
      error2 != null ? error2 : { message: "No error message given." },
      { el, expression }
    );
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(() => {
      throw error2;
    }, 0);
  }
  var shouldAutoEvaluateFunctions = true;
  function dontAutoEvaluateFunctions(callback) {
    let cache2 = shouldAutoEvaluateFunctions;
    shouldAutoEvaluateFunctions = false;
    let result = callback();
    shouldAutoEvaluateFunctions = cache2;
    return result;
  }
  function evaluate(el, expression, extras = {}) {
    let result;
    evaluateLater(el, expression)((value) => result = value, extras);
    return result;
  }
  function evaluateLater(...args) {
    return theEvaluatorFunction(...args);
  }
  var theEvaluatorFunction = normalEvaluator;
  function setEvaluator(newEvaluator) {
    theEvaluatorFunction = newEvaluator;
  }
  function normalEvaluator(el, expression) {
    let overriddenMagics = {};
    injectMagics(overriddenMagics, el);
    let dataStack = [overriddenMagics, ...closestDataStack(el)];
    let evaluator = typeof expression === "function" ? generateEvaluatorFromFunction(dataStack, expression) : generateEvaluatorFromString(dataStack, expression, el);
    return tryCatch.bind(null, el, expression, evaluator);
  }
  function generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = () => {
    }, { scope: scope2 = {}, params = [] } = {}) => {
      let result = func.apply(mergeProxies([scope2, ...dataStack]), params);
      runIfTypeOfFunction(receiver, result);
    };
  }
  var evaluatorMemo = {};
  function generateFunctionFromString(expression, el) {
    if (evaluatorMemo[expression]) {
      return evaluatorMemo[expression];
    }
    let AsyncFunction = Object.getPrototypeOf(async function() {
    }).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = () => {
      try {
        let func2 = new AsyncFunction(
          ["__self", "scope"],
          `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`
        );
        Object.defineProperty(func2, "name", {
          value: `[Alpine] ${expression}`
        });
        return func2;
      } catch (error2) {
        handleError(error2, el, expression);
        return Promise.resolve();
      }
    };
    let func = safeAsyncFunction();
    evaluatorMemo[expression] = func;
    return func;
  }
  function generateEvaluatorFromString(dataStack, expression, el) {
    let func = generateFunctionFromString(expression, el);
    return (receiver = () => {
    }, { scope: scope2 = {}, params = [] } = {}) => {
      func.result = void 0;
      func.finished = false;
      let completeScope = mergeProxies([scope2, ...dataStack]);
      if (typeof func === "function") {
        let promise = func(func, completeScope).catch((error2) => handleError(error2, el, expression));
        if (func.finished) {
          runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
          func.result = void 0;
        } else {
          promise.then((result) => {
            runIfTypeOfFunction(receiver, result, completeScope, params, el);
          }).catch((error2) => handleError(error2, el, expression)).finally(() => func.result = void 0);
        }
      }
    };
  }
  function runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if (shouldAutoEvaluateFunctions && typeof value === "function") {
      let result = value.apply(scope2, params);
      if (result instanceof Promise) {
        result.then((i) => runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2) => handleError(error2, el, value));
      } else {
        receiver(result);
      }
    } else if (typeof value === "object" && value instanceof Promise) {
      value.then((i) => receiver(i));
    } else {
      receiver(value);
    }
  }
  var prefixAsString = "x-";
  function prefix(subject = "") {
    return prefixAsString + subject;
  }
  function setPrefix(newPrefix) {
    prefixAsString = newPrefix;
  }
  var directiveHandlers = {};
  function directive(name, callback) {
    directiveHandlers[name] = callback;
    return {
      before(directive2) {
        if (!directiveHandlers[directive2]) {
          console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
          return;
        }
        const pos = directiveOrder.indexOf(directive2);
        directiveOrder.splice(pos >= 0 ? pos : directiveOrder.indexOf("DEFAULT"), 0, name);
      }
    };
  }
  function directiveExists(name) {
    return Object.keys(directiveHandlers).includes(name);
  }
  function directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
      let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value]) => ({ name, value }));
      let staticAttributes = attributesOnly(vAttributes);
      vAttributes = vAttributes.map((attribute) => {
        if (staticAttributes.find((attr) => attr.name === attribute.name)) {
          return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
          };
        }
        return attribute;
      });
      attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map(toTransformedAttributes((newName, oldName) => transformedAttributeMap[newName] = oldName)).filter(outNonAlpineAttributes).map(toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort(byPriority);
    return directives2.map((directive2) => {
      return getDirectiveHandler(el, directive2);
    });
  }
  function attributesOnly(attributes) {
    return Array.from(attributes).map(toTransformedAttributes()).filter((attr) => !outNonAlpineAttributes(attr));
  }
  var isDeferringHandlers = false;
  var directiveHandlerStacks = /* @__PURE__ */ new Map();
  var currentHandlerStackKey = Symbol();
  function deferHandlingDirectives(callback) {
    isDeferringHandlers = true;
    let key3 = Symbol();
    currentHandlerStackKey = key3;
    directiveHandlerStacks.set(key3, []);
    let flushHandlers = () => {
      while (directiveHandlerStacks.get(key3).length)
        directiveHandlerStacks.get(key3).shift()();
      directiveHandlerStacks.delete(key3);
    };
    let stopDeferring = () => {
      isDeferringHandlers = false;
      flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
  }
  function getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback) => cleanups.push(callback);
    let [effect3, cleanupEffect] = elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
      Alpine: alpine_default,
      effect: effect3,
      cleanup: cleanup2,
      evaluateLater: evaluateLater.bind(evaluateLater, el),
      evaluate: evaluate.bind(evaluate, el)
    };
    let doCleanup = () => cleanups.forEach((i) => i());
    return [utilities, doCleanup];
  }
  function getDirectiveHandler(el, directive2) {
    let noop = () => {
    };
    let handler4 = directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = getElementBoundUtilities(el);
    onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = () => {
      if (el._x_ignore || el._x_ignoreSelf)
        return;
      handler4.inline && handler4.inline(el, directive2, utilities);
      handler4 = handler4.bind(handler4, el, directive2, utilities);
      isDeferringHandlers ? directiveHandlerStacks.get(currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
  }
  var startingWith = (subject, replacement) => ({ name, value }) => {
    if (name.startsWith(subject))
      name = name.replace(subject, replacement);
    return { name, value };
  };
  var into = (i) => i;
  function toTransformedAttributes(callback = () => {
  }) {
    return ({ name, value }) => {
      let { name: newName, value: newValue } = attributeTransformers.reduce((carry, transform) => {
        return transform(carry);
      }, { name, value });
      if (newName !== name)
        callback(newName, name);
      return { name: newName, value: newValue };
    };
  }
  var attributeTransformers = [];
  function mapAttributes(callback) {
    attributeTransformers.push(callback);
  }
  function outNonAlpineAttributes({ name }) {
    return alpineAttributeRegex().test(name);
  }
  var alpineAttributeRegex = () => new RegExp(`^${prefixAsString}([^:^.]+)\\b`);
  function toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name, value }) => {
      let typeMatch = name.match(alpineAttributeRegex());
      let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
      let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
      let original = originalAttributeOverride || transformedAttributeMap[name] || name;
      return {
        type: typeMatch ? typeMatch[1] : null,
        value: valueMatch ? valueMatch[1] : null,
        modifiers: modifiers.map((i) => i.replace(".", "")),
        expression: value,
        original
      };
    };
  }
  var DEFAULT = "DEFAULT";
  var directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    DEFAULT,
    "teleport"
  ];
  function byPriority(a, b) {
    let typeA = directiveOrder.indexOf(a.type) === -1 ? DEFAULT : a.type;
    let typeB = directiveOrder.indexOf(b.type) === -1 ? DEFAULT : b.type;
    return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
  }
  function dispatch(el, name, detail = {}) {
    el.dispatchEvent(
      new CustomEvent(name, {
        detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
      })
    );
  }
  function walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
      Array.from(el.children).forEach((el2) => walk(el2, callback));
      return;
    }
    let skip = false;
    callback(el, () => skip = true);
    if (skip)
      return;
    let node = el.firstElementChild;
    while (node) {
      walk(node, callback, false);
      node = node.nextElementSibling;
    }
  }
  function warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
  }
  var started = false;
  function start() {
    if (started)
      warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    started = true;
    if (!document.body)
      warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    dispatch(document, "alpine:init");
    dispatch(document, "alpine:initializing");
    startObservingMutations();
    onElAdded((el) => initTree(el, walk));
    onElRemoved((el) => destroyTree(el));
    onAttributesAdded((el, attrs) => {
      directives(el, attrs).forEach((handle) => handle());
    });
    let outNestedComponents = (el) => !closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll(allSelectors().join(","))).filter(outNestedComponents).forEach((el) => {
      initTree(el);
    });
    dispatch(document, "alpine:initialized");
    setTimeout(() => {
      warnAboutMissingPlugins();
    });
  }
  var rootSelectorCallbacks = [];
  var initSelectorCallbacks = [];
  function rootSelectors() {
    return rootSelectorCallbacks.map((fn) => fn());
  }
  function allSelectors() {
    return rootSelectorCallbacks.concat(initSelectorCallbacks).map((fn) => fn());
  }
  function addRootSelector(selectorCallback) {
    rootSelectorCallbacks.push(selectorCallback);
  }
  function addInitSelector(selectorCallback) {
    initSelectorCallbacks.push(selectorCallback);
  }
  function closestRoot(el, includeInitSelectors = false) {
    return findClosest(el, (element) => {
      const selectors = includeInitSelectors ? allSelectors() : rootSelectors();
      if (selectors.some((selector) => element.matches(selector)))
        return true;
    });
  }
  function findClosest(el, callback) {
    if (!el)
      return;
    if (callback(el))
      return el;
    if (el._x_teleportBack)
      el = el._x_teleportBack;
    if (!el.parentElement)
      return;
    return findClosest(el.parentElement, callback);
  }
  function isRoot(el) {
    return rootSelectors().some((selector) => el.matches(selector));
  }
  var initInterceptors2 = [];
  function interceptInit(callback) {
    initInterceptors2.push(callback);
  }
  var markerDispenser = 1;
  function initTree(el, walker = walk, intercept = () => {
  }) {
    if (findClosest(el, (i) => i._x_ignore))
      return;
    deferHandlingDirectives(() => {
      walker(el, (el2, skip) => {
        if (el2._x_marker)
          return;
        intercept(el2, skip);
        initInterceptors2.forEach((i) => i(el2, skip));
        directives(el2, el2.attributes).forEach((handle) => handle());
        if (!el2._x_ignore)
          el2._x_marker = markerDispenser++;
        el2._x_ignore && skip();
      });
    });
  }
  function destroyTree(root, walker = walk) {
    walker(root, (el) => {
      cleanupElement(el);
      cleanupAttributes(el);
      delete el._x_marker;
    });
  }
  function warnAboutMissingPlugins() {
    let pluginDirectives = [
      ["ui", "dialog", ["[x-dialog], [x-popover]"]],
      ["anchor", "anchor", ["[x-anchor]"]],
      ["sort", "sort", ["[x-sort]"]]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors]) => {
      if (directiveExists(directive2))
        return;
      selectors.some((selector) => {
        if (document.querySelector(selector)) {
          warn(`found "${selector}", but missing ${plugin2} plugin`);
          return true;
        }
      });
    });
  }
  var tickStack = [];
  var isHolding = false;
  function nextTick(callback = () => {
  }) {
    queueMicrotask(() => {
      isHolding || setTimeout(() => {
        releaseNextTicks();
      });
    });
    return new Promise((res) => {
      tickStack.push(() => {
        callback();
        res();
      });
    });
  }
  function releaseNextTicks() {
    isHolding = false;
    while (tickStack.length)
      tickStack.shift()();
  }
  function holdNextTicks() {
    isHolding = true;
  }
  function setClasses(el, value) {
    if (Array.isArray(value)) {
      return setClassesFromString(el, value.join(" "));
    } else if (typeof value === "object" && value !== null) {
      return setClassesFromObject(el, value);
    } else if (typeof value === "function") {
      return setClasses(el, value());
    }
    return setClassesFromString(el, value);
  }
  function setClassesFromString(el, classString) {
    let split = (classString2) => classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2) => classString2.split(" ").filter((i) => !el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes) => {
      el.classList.add(...classes);
      return () => {
        el.classList.remove(...classes);
      };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
  }
  function setClassesFromObject(el, classObject) {
    let split = (classString) => classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool]) => bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool]) => !bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i) => {
      if (el.classList.contains(i)) {
        el.classList.remove(i);
        removed.push(i);
      }
    });
    forAdd.forEach((i) => {
      if (!el.classList.contains(i)) {
        el.classList.add(i);
        added.push(i);
      }
    });
    return () => {
      removed.forEach((i) => el.classList.add(i));
      added.forEach((i) => el.classList.remove(i));
    };
  }
  function setStyles(el, value) {
    if (typeof value === "object" && value !== null) {
      return setStylesFromObject(el, value);
    }
    return setStylesFromString(el, value);
  }
  function setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key3, value2]) => {
      previousStyles[key3] = el.style[key3];
      if (!key3.startsWith("--")) {
        key3 = kebabCase(key3);
      }
      el.style.setProperty(key3, value2);
    });
    setTimeout(() => {
      if (el.style.length === 0) {
        el.removeAttribute("style");
      }
    });
    return () => {
      setStyles(el, previousStyles);
    };
  }
  function setStylesFromString(el, value) {
    let cache2 = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return () => {
      el.setAttribute("style", cache2 || "");
    };
  }
  function kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  }
  function once(callback, fallback = () => {
  }) {
    let called = false;
    return function() {
      if (!called) {
        called = true;
        callback.apply(this, arguments);
      } else {
        fallback.apply(this, arguments);
      }
    };
  }
  directive("transition", (el, { value, modifiers, expression }, { evaluate: evaluate2 }) => {
    if (typeof expression === "function")
      expression = evaluate2(expression);
    if (expression === false)
      return;
    if (!expression || typeof expression === "boolean") {
      registerTransitionsFromHelper(el, modifiers, value);
    } else {
      registerTransitionsFromClassString(el, expression, value);
    }
  });
  function registerTransitionsFromClassString(el, classString, stage) {
    registerTransitionObject(el, setClasses, "");
    let directiveStorageMap = {
      "enter": (classes) => {
        el._x_transition.enter.during = classes;
      },
      "enter-start": (classes) => {
        el._x_transition.enter.start = classes;
      },
      "enter-end": (classes) => {
        el._x_transition.enter.end = classes;
      },
      "leave": (classes) => {
        el._x_transition.leave.during = classes;
      },
      "leave-start": (classes) => {
        el._x_transition.leave.start = classes;
      },
      "leave-end": (classes) => {
        el._x_transition.leave.end = classes;
      }
    };
    directiveStorageMap[stage](classString);
  }
  function registerTransitionsFromHelper(el, modifiers, stage) {
    registerTransitionObject(el, setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || ["enter"].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || ["leave"].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) {
      modifiers = modifiers.filter((i, index2) => index2 < modifiers.indexOf("out"));
    }
    if (modifiers.includes("out") && !doesntSpecify) {
      modifiers = modifiers.filter((i, index2) => index2 > modifiers.indexOf("out"));
    }
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay3 = modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
      el._x_transition.enter.during = {
        transformOrigin: origin,
        transitionDelay: `${delay3}s`,
        transitionProperty: property,
        transitionDuration: `${durationIn}s`,
        transitionTimingFunction: easing
      };
      el._x_transition.enter.start = {
        opacity: opacityValue,
        transform: `scale(${scaleValue})`
      };
      el._x_transition.enter.end = {
        opacity: 1,
        transform: `scale(1)`
      };
    }
    if (transitioningOut) {
      el._x_transition.leave.during = {
        transformOrigin: origin,
        transitionDelay: `${delay3}s`,
        transitionProperty: property,
        transitionDuration: `${durationOut}s`,
        transitionTimingFunction: easing
      };
      el._x_transition.leave.start = {
        opacity: 1,
        transform: `scale(1)`
      };
      el._x_transition.leave.end = {
        opacity: opacityValue,
        transform: `scale(${scaleValue})`
      };
    }
  }
  function registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition)
      el._x_transition = {
        enter: { during: defaultValue, start: defaultValue, end: defaultValue },
        leave: { during: defaultValue, start: defaultValue, end: defaultValue },
        in(before = () => {
        }, after = () => {
        }) {
          transition(el, setFunction, {
            during: this.enter.during,
            start: this.enter.start,
            end: this.enter.end
          }, before, after);
        },
        out(before = () => {
        }, after = () => {
        }) {
          transition(el, setFunction, {
            during: this.leave.during,
            start: this.leave.start,
            end: this.leave.end
          }, before, after);
        }
      };
  }
  window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick22 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = () => nextTick22(show);
    if (value) {
      if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) {
        el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
      } else {
        el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
      }
      return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject) => {
      el._x_transition.out(() => {
      }, () => resolve(hide));
      el._x_transitioning && el._x_transitioning.beforeCancel(() => reject({ isFromCancelledTransition: true }));
    }) : Promise.resolve(hide);
    queueMicrotask(() => {
      let closest = closestHide(el);
      if (closest) {
        if (!closest._x_hideChildren)
          closest._x_hideChildren = [];
        closest._x_hideChildren.push(el);
      } else {
        nextTick22(() => {
          let hideAfterChildren = (el2) => {
            let carry = Promise.all([
              el2._x_hidePromise,
              ...(el2._x_hideChildren || []).map(hideAfterChildren)
            ]).then(([i]) => i == null ? void 0 : i());
            delete el2._x_hidePromise;
            delete el2._x_hideChildren;
            return carry;
          };
          hideAfterChildren(el).catch((e) => {
            if (!e.isFromCancelledTransition)
              throw e;
          });
        });
      }
    });
  };
  function closestHide(el) {
    let parent = el.parentNode;
    if (!parent)
      return;
    return parent._x_hidePromise ? parent : closestHide(parent);
  }
  function transition(el, setFunction, { during, start: start2, end } = {}, before = () => {
  }, after = () => {
  }) {
    if (el._x_transitioning)
      el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
      before();
      after();
      return;
    }
    let undoStart, undoDuring, undoEnd;
    performTransition(el, {
      start() {
        undoStart = setFunction(el, start2);
      },
      during() {
        undoDuring = setFunction(el, during);
      },
      before,
      end() {
        undoStart();
        undoEnd = setFunction(el, end);
      },
      after,
      cleanup() {
        undoDuring();
        undoEnd();
      }
    });
  }
  function performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = once(() => {
      mutateDom(() => {
        interrupted = true;
        if (!reachedBefore)
          stages.before();
        if (!reachedEnd) {
          stages.end();
          releaseNextTicks();
        }
        stages.after();
        if (el.isConnected)
          stages.cleanup();
        delete el._x_transitioning;
      });
    });
    el._x_transitioning = {
      beforeCancels: [],
      beforeCancel(callback) {
        this.beforeCancels.push(callback);
      },
      cancel: once(function() {
        while (this.beforeCancels.length) {
          this.beforeCancels.shift()();
        }
        ;
        finish();
      }),
      finish
    };
    mutateDom(() => {
      stages.start();
      stages.during();
    });
    holdNextTicks();
    requestAnimationFrame(() => {
      if (interrupted)
        return;
      let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
      let delay3 = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
      if (duration === 0)
        duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
      mutateDom(() => {
        stages.before();
      });
      reachedBefore = true;
      requestAnimationFrame(() => {
        if (interrupted)
          return;
        mutateDom(() => {
          stages.end();
        });
        releaseNextTicks();
        setTimeout(el._x_transitioning.finish, duration + delay3);
        reachedEnd = true;
      });
    });
  }
  function modifierValue(modifiers, key3, fallback) {
    if (modifiers.indexOf(key3) === -1)
      return fallback;
    const rawValue = modifiers[modifiers.indexOf(key3) + 1];
    if (!rawValue)
      return fallback;
    if (key3 === "scale") {
      if (isNaN(rawValue))
        return fallback;
    }
    if (key3 === "duration" || key3 === "delay") {
      let match = rawValue.match(/([0-9]+)ms/);
      if (match)
        return match[1];
    }
    if (key3 === "origin") {
      if (["top", "right", "left", "center", "bottom"].includes(modifiers[modifiers.indexOf(key3) + 2])) {
        return [rawValue, modifiers[modifiers.indexOf(key3) + 2]].join(" ");
      }
    }
    return rawValue;
  }
  var isCloning = false;
  function skipDuringClone(callback, fallback = () => {
  }) {
    return (...args) => isCloning ? fallback(...args) : callback(...args);
  }
  function onlyDuringClone(callback) {
    return (...args) => isCloning && callback(...args);
  }
  var interceptors = [];
  function interceptClone(callback) {
    interceptors.push(callback);
  }
  function cloneNode(from, to) {
    interceptors.forEach((i) => i(from, to));
    isCloning = true;
    dontRegisterReactiveSideEffects(() => {
      initTree(to, (el, callback) => {
        callback(el, () => {
        });
      });
    });
    isCloning = false;
  }
  var isCloningLegacy = false;
  function clone(oldEl, newEl) {
    if (!newEl._x_dataStack)
      newEl._x_dataStack = oldEl._x_dataStack;
    isCloning = true;
    isCloningLegacy = true;
    dontRegisterReactiveSideEffects(() => {
      cloneTree(newEl);
    });
    isCloning = false;
    isCloningLegacy = false;
  }
  function cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback) => {
      walk(el2, (el3, skip) => {
        if (hasRunThroughFirstEl && isRoot(el3))
          return skip();
        hasRunThroughFirstEl = true;
        callback(el3, skip);
      });
    };
    initTree(el, shallowWalker);
  }
  function dontRegisterReactiveSideEffects(callback) {
    let cache2 = effect;
    overrideEffect((callback2, el) => {
      let storedEffect = cache2(callback2);
      release(storedEffect);
      return () => {
      };
    });
    callback();
    overrideEffect(cache2);
  }
  function bind(el, name, value, modifiers = []) {
    if (!el._x_bindings)
      el._x_bindings = reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? camelCase(name) : name;
    switch (name) {
      case "value":
        bindInputValue(el, value);
        break;
      case "style":
        bindStyles(el, value);
        break;
      case "class":
        bindClasses(el, value);
        break;
      case "selected":
      case "checked":
        bindAttributeAndProperty(el, name, value);
        break;
      default:
        bindAttribute(el, name, value);
        break;
    }
  }
  function bindInputValue(el, value) {
    if (isRadio(el)) {
      if (el.attributes.value === void 0) {
        el.value = value;
      }
      if (window.fromModel) {
        if (typeof value === "boolean") {
          el.checked = safeParseBoolean(el.value) === value;
        } else {
          el.checked = checkedAttrLooseCompare(el.value, value);
        }
      }
    } else if (isCheckbox(el)) {
      if (Number.isInteger(value)) {
        el.value = value;
      } else if (!Array.isArray(value) && typeof value !== "boolean" && ![null, void 0].includes(value)) {
        el.value = String(value);
      } else {
        if (Array.isArray(value)) {
          el.checked = value.some((val) => checkedAttrLooseCompare(val, el.value));
        } else {
          el.checked = !!value;
        }
      }
    } else if (el.tagName === "SELECT") {
      updateSelect(el, value);
    } else {
      if (el.value === value)
        return;
      el.value = value === void 0 ? "" : value;
    }
  }
  function bindClasses(el, value) {
    if (el._x_undoAddedClasses)
      el._x_undoAddedClasses();
    el._x_undoAddedClasses = setClasses(el, value);
  }
  function bindStyles(el, value) {
    if (el._x_undoAddedStyles)
      el._x_undoAddedStyles();
    el._x_undoAddedStyles = setStyles(el, value);
  }
  function bindAttributeAndProperty(el, name, value) {
    bindAttribute(el, name, value);
    setPropertyIfChanged(el, name, value);
  }
  function bindAttribute(el, name, value) {
    if ([null, void 0, false].includes(value) && attributeShouldntBePreservedIfFalsy(name)) {
      el.removeAttribute(name);
    } else {
      if (isBooleanAttr(name))
        value = name;
      setIfChanged(el, name, value);
    }
  }
  function setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) {
      el.setAttribute(attrName, value);
    }
  }
  function setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) {
      el[propName] = value;
    }
  }
  function updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2) => {
      return value2 + "";
    });
    Array.from(el.options).forEach((option) => {
      option.selected = arrayWrappedValue.includes(option.value);
    });
  }
  function camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
  }
  function checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
  }
  function safeParseBoolean(rawValue) {
    if ([1, "1", "true", "on", "yes", true].includes(rawValue)) {
      return true;
    }
    if ([0, "0", "false", "off", "no", false].includes(rawValue)) {
      return false;
    }
    return rawValue ? Boolean(rawValue) : null;
  }
  var booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
  ]);
  function isBooleanAttr(attrName) {
    return booleanAttributes.has(attrName);
  }
  function attributeShouldntBePreservedIfFalsy(name) {
    return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(name);
  }
  function getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0)
      return el._x_bindings[name];
    return getAttributeBinding(el, name, fallback);
  }
  function extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0)
      return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
      let binding = el._x_inlineBindings[name];
      binding.extract = extract;
      return dontAutoEvaluateFunctions(() => {
        return evaluate(el, binding.expression);
      });
    }
    return getAttributeBinding(el, name, fallback);
  }
  function getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null)
      return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "")
      return true;
    if (isBooleanAttr(name)) {
      return !![name, "true"].includes(attr);
    }
    return attr;
  }
  function isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
  }
  function isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
  }
  function debounce(func, wait) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  function throttle(func, limit) {
    let inThrottle;
    return function() {
      let context = this, args = arguments;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
  function entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun2 = true;
    let outerHash;
    let innerHash;
    let reference = effect(() => {
      let outer = outerGet();
      let inner = innerGet();
      if (firstRun2) {
        innerSet(cloneIfObject(outer));
        firstRun2 = false;
      } else {
        let outerHashLatest = JSON.stringify(outer);
        let innerHashLatest = JSON.stringify(inner);
        if (outerHashLatest !== outerHash) {
          innerSet(cloneIfObject(outer));
        } else if (outerHashLatest !== innerHashLatest) {
          outerSet(cloneIfObject(inner));
        } else {
        }
      }
      outerHash = JSON.stringify(outerGet());
      innerHash = JSON.stringify(innerGet());
    });
    return () => {
      release(reference);
    };
  }
  function cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
  }
  function plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [callback];
    callbacks.forEach((i) => i(alpine_default));
  }
  var stores = {};
  var isReactive = false;
  function store(name, value) {
    if (!isReactive) {
      stores = reactive(stores);
      isReactive = true;
    }
    if (value === void 0) {
      return stores[name];
    }
    stores[name] = value;
    initInterceptors(stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") {
      stores[name].init();
    }
  }
  function getStores() {
    return stores;
  }
  var binds = {};
  function bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? () => bindings : bindings;
    if (name instanceof Element) {
      return applyBindingsObject(name, getBindings());
    } else {
      binds[name] = getBindings;
    }
    return () => {
    };
  }
  function injectBindingProviders(obj) {
    Object.entries(binds).forEach(([name, callback]) => {
      Object.defineProperty(obj, name, {
        get() {
          return (...args) => {
            return callback(...args);
          };
        }
      });
    });
    return obj;
  }
  function applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while (cleanupRunners.length)
      cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value]) => ({ name, value }));
    let staticAttributes = attributesOnly(attributes);
    attributes = attributes.map((attribute) => {
      if (staticAttributes.find((attr) => attr.name === attribute.name)) {
        return {
          name: `x-bind:${attribute.name}`,
          value: `"${attribute.value}"`
        };
      }
      return attribute;
    });
    directives(el, attributes, original).map((handle) => {
      cleanupRunners.push(handle.runCleanups);
      handle();
    });
    return () => {
      while (cleanupRunners.length)
        cleanupRunners.pop()();
    };
  }
  var datas = {};
  function data(name, callback) {
    datas[name] = callback;
  }
  function injectDataProviders(obj, context) {
    Object.entries(datas).forEach(([name, callback]) => {
      Object.defineProperty(obj, name, {
        get() {
          return (...args) => {
            return callback.bind(context)(...args);
          };
        },
        enumerable: false
      });
    });
    return obj;
  }
  var Alpine = {
    get reactive() {
      return reactive;
    },
    get release() {
      return release;
    },
    get effect() {
      return effect;
    },
    get raw() {
      return raw;
    },
    version: "3.14.9",
    flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions,
    disableEffectScheduling,
    startObservingMutations,
    stopObservingMutations,
    setReactivityEngine,
    onAttributeRemoved,
    onAttributesAdded,
    closestDataStack,
    skipDuringClone,
    onlyDuringClone,
    addRootSelector,
    addInitSelector,
    interceptClone,
    addScopeToNode,
    deferMutations,
    mapAttributes,
    evaluateLater,
    interceptInit,
    setEvaluator,
    mergeProxies,
    extractProp,
    findClosest,
    onElRemoved,
    closestRoot,
    destroyTree,
    interceptor,
    // INTERNAL: not public API and is subject to change without major release.
    transition,
    // INTERNAL
    setStyles,
    // INTERNAL
    mutateDom,
    directive,
    entangle,
    throttle,
    debounce,
    evaluate,
    initTree,
    nextTick,
    prefixed: prefix,
    prefix: setPrefix,
    plugin,
    magic,
    store,
    start,
    clone,
    // INTERNAL
    cloneNode,
    // INTERNAL
    bound: getBinding,
    $data: scope,
    watch,
    walk,
    data,
    bind: bind2
  };
  var alpine_default = Alpine;
  function makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for (let i = 0; i < list.length; i++) {
      map[list[i]] = true;
    }
    return expectsLowerCase ? (val) => !!map[val.toLowerCase()] : (val) => !!map[val];
  }
  var specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
  var isBooleanAttr2 = /* @__PURE__ */ makeMap(specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
  var EMPTY_OBJ = true ? Object.freeze({}) : {};
  var EMPTY_ARR = true ? Object.freeze([]) : [];
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var hasOwn = (val, key3) => hasOwnProperty.call(val, key3);
  var isArray = Array.isArray;
  var isMap = (val) => toTypeString(val) === "[object Map]";
  var isString = (val) => typeof val === "string";
  var isSymbol = (val) => typeof val === "symbol";
  var isObject = (val) => val !== null && typeof val === "object";
  var objectToString = Object.prototype.toString;
  var toTypeString = (value) => objectToString.call(value);
  var toRawType = (value) => {
    return toTypeString(value).slice(8, -1);
  };
  var isIntegerKey = (key3) => isString(key3) && key3 !== "NaN" && key3[0] !== "-" && "" + parseInt(key3, 10) === key3;
  var cacheStringFunction = (fn) => {
    const cache2 = /* @__PURE__ */ Object.create(null);
    return (str) => {
      const hit = cache2[str];
      return hit || (cache2[str] = fn(str));
    };
  };
  var camelizeRE = /-(\w)/g;
  var camelize = cacheStringFunction((str) => {
    return str.replace(camelizeRE, (_, c) => c ? c.toUpperCase() : "");
  });
  var hyphenateRE = /\B([A-Z])/g;
  var hyphenate = cacheStringFunction((str) => str.replace(hyphenateRE, "-$1").toLowerCase());
  var capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
  var toHandlerKey = cacheStringFunction((str) => str ? `on${capitalize(str)}` : ``);
  var hasChanged = (value, oldValue) => value !== oldValue && (value === value || oldValue === oldValue);
  var targetMap = /* @__PURE__ */ new WeakMap();
  var effectStack = [];
  var activeEffect;
  var ITERATE_KEY = Symbol(true ? "iterate" : "");
  var MAP_KEY_ITERATE_KEY = Symbol(true ? "Map key iterate" : "");
  function isEffect(fn) {
    return fn && fn._isEffect === true;
  }
  function effect2(fn, options2 = EMPTY_OBJ) {
    if (isEffect(fn)) {
      fn = fn.raw;
    }
    const effect3 = createReactiveEffect(fn, options2);
    if (!options2.lazy) {
      effect3();
    }
    return effect3;
  }
  function stop(effect3) {
    if (effect3.active) {
      cleanup(effect3);
      if (effect3.options.onStop) {
        effect3.options.onStop();
      }
      effect3.active = false;
    }
  }
  var uid = 0;
  function createReactiveEffect(fn, options2) {
    const effect3 = function reactiveEffect() {
      if (!effect3.active) {
        return fn();
      }
      if (!effectStack.includes(effect3)) {
        cleanup(effect3);
        try {
          enableTracking();
          effectStack.push(effect3);
          activeEffect = effect3;
          return fn();
        } finally {
          effectStack.pop();
          resetTracking();
          activeEffect = effectStack[effectStack.length - 1];
        }
      }
    };
    effect3.id = uid++;
    effect3.allowRecurse = !!options2.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options2;
    return effect3;
  }
  function cleanup(effect3) {
    const { deps } = effect3;
    if (deps.length) {
      for (let i = 0; i < deps.length; i++) {
        deps[i].delete(effect3);
      }
      deps.length = 0;
    }
  }
  var shouldTrack = true;
  var trackStack = [];
  function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
  }
  function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
  }
  function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
  }
  function track(target, type, key3) {
    if (!shouldTrack || activeEffect === void 0) {
      return;
    }
    let depsMap = targetMap.get(target);
    if (!depsMap) {
      targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    }
    let dep = depsMap.get(key3);
    if (!dep) {
      depsMap.set(key3, dep = /* @__PURE__ */ new Set());
    }
    if (!dep.has(activeEffect)) {
      dep.add(activeEffect);
      activeEffect.deps.push(dep);
      if (activeEffect.options.onTrack) {
        activeEffect.options.onTrack({
          effect: activeEffect,
          target,
          type,
          key: key3
        });
      }
    }
  }
  function trigger(target, type, key3, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) {
      return;
    }
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd) => {
      if (effectsToAdd) {
        effectsToAdd.forEach((effect3) => {
          if (effect3 !== activeEffect || effect3.allowRecurse) {
            effects.add(effect3);
          }
        });
      }
    };
    if (type === "clear") {
      depsMap.forEach(add2);
    } else if (key3 === "length" && isArray(target)) {
      depsMap.forEach((dep, key22) => {
        if (key22 === "length" || key22 >= newValue) {
          add2(dep);
        }
      });
    } else {
      if (key3 !== void 0) {
        add2(depsMap.get(key3));
      }
      switch (type) {
        case "add":
          if (!isArray(target)) {
            add2(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              add2(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          } else if (isIntegerKey(key3)) {
            add2(depsMap.get("length"));
          }
          break;
        case "delete":
          if (!isArray(target)) {
            add2(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              add2(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          }
          break;
        case "set":
          if (isMap(target)) {
            add2(depsMap.get(ITERATE_KEY));
          }
          break;
      }
    }
    const run = (effect3) => {
      if (effect3.options.onTrigger) {
        effect3.options.onTrigger({
          effect: effect3,
          target,
          key: key3,
          type,
          newValue,
          oldValue,
          oldTarget
        });
      }
      if (effect3.options.scheduler) {
        effect3.options.scheduler(effect3);
      } else {
        effect3();
      }
    };
    effects.forEach(run);
  }
  var isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
  var builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key3) => Symbol[key3]).filter(isSymbol));
  var get2 = /* @__PURE__ */ createGetter();
  var readonlyGet = /* @__PURE__ */ createGetter(true);
  var arrayInstrumentations = /* @__PURE__ */ createArrayInstrumentations();
  function createArrayInstrumentations() {
    const instrumentations = {};
    ["includes", "indexOf", "lastIndexOf"].forEach((key3) => {
      instrumentations[key3] = function(...args) {
        const arr = toRaw(this);
        for (let i = 0, l = this.length; i < l; i++) {
          track(arr, "get", i + "");
        }
        const res = arr[key3](...args);
        if (res === -1 || res === false) {
          return arr[key3](...args.map(toRaw));
        } else {
          return res;
        }
      };
    });
    ["push", "pop", "shift", "unshift", "splice"].forEach((key3) => {
      instrumentations[key3] = function(...args) {
        pauseTracking();
        const res = toRaw(this)[key3].apply(this, args);
        resetTracking();
        return res;
      };
    });
    return instrumentations;
  }
  function createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key3, receiver) {
      if (key3 === "__v_isReactive") {
        return !isReadonly;
      } else if (key3 === "__v_isReadonly") {
        return isReadonly;
      } else if (key3 === "__v_raw" && receiver === (isReadonly ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) {
        return target;
      }
      const targetIsArray = isArray(target);
      if (!isReadonly && targetIsArray && hasOwn(arrayInstrumentations, key3)) {
        return Reflect.get(arrayInstrumentations, key3, receiver);
      }
      const res = Reflect.get(target, key3, receiver);
      if (isSymbol(key3) ? builtInSymbols.has(key3) : isNonTrackableKeys(key3)) {
        return res;
      }
      if (!isReadonly) {
        track(target, "get", key3);
      }
      if (shallow) {
        return res;
      }
      if (isRef(res)) {
        const shouldUnwrap = !targetIsArray || !isIntegerKey(key3);
        return shouldUnwrap ? res.value : res;
      }
      if (isObject(res)) {
        return isReadonly ? readonly(res) : reactive2(res);
      }
      return res;
    };
  }
  var set2 = /* @__PURE__ */ createSetter();
  function createSetter(shallow = false) {
    return function set3(target, key3, value, receiver) {
      let oldValue = target[key3];
      if (!shallow) {
        value = toRaw(value);
        oldValue = toRaw(oldValue);
        if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
          oldValue.value = value;
          return true;
        }
      }
      const hadKey = isArray(target) && isIntegerKey(key3) ? Number(key3) < target.length : hasOwn(target, key3);
      const result = Reflect.set(target, key3, value, receiver);
      if (target === toRaw(receiver)) {
        if (!hadKey) {
          trigger(target, "add", key3, value);
        } else if (hasChanged(value, oldValue)) {
          trigger(target, "set", key3, value, oldValue);
        }
      }
      return result;
    };
  }
  function deleteProperty(target, key3) {
    const hadKey = hasOwn(target, key3);
    const oldValue = target[key3];
    const result = Reflect.deleteProperty(target, key3);
    if (result && hadKey) {
      trigger(target, "delete", key3, void 0, oldValue);
    }
    return result;
  }
  function has(target, key3) {
    const result = Reflect.has(target, key3);
    if (!isSymbol(key3) || !builtInSymbols.has(key3)) {
      track(target, "has", key3);
    }
    return result;
  }
  function ownKeys(target) {
    track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
    return Reflect.ownKeys(target);
  }
  var mutableHandlers = {
    get: get2,
    set: set2,
    deleteProperty,
    has,
    ownKeys
  };
  var readonlyHandlers = {
    get: readonlyGet,
    set(target, key3) {
      if (true) {
        console.warn(`Set operation on key "${String(key3)}" failed: target is readonly.`, target);
      }
      return true;
    },
    deleteProperty(target, key3) {
      if (true) {
        console.warn(`Delete operation on key "${String(key3)}" failed: target is readonly.`, target);
      }
      return true;
    }
  };
  var toReactive = (value) => isObject(value) ? reactive2(value) : value;
  var toReadonly = (value) => isObject(value) ? readonly(value) : value;
  var toShallow = (value) => value;
  var getProto = (v) => Reflect.getPrototypeOf(v);
  function get$1(target, key3, isReadonly = false, isShallow = false) {
    target = target[
      "__v_raw"
      /* RAW */
    ];
    const rawTarget = toRaw(target);
    const rawKey = toRaw(key3);
    if (key3 !== rawKey) {
      !isReadonly && track(rawTarget, "get", key3);
    }
    !isReadonly && track(rawTarget, "get", rawKey);
    const { has: has2 } = getProto(rawTarget);
    const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    if (has2.call(rawTarget, key3)) {
      return wrap(target.get(key3));
    } else if (has2.call(rawTarget, rawKey)) {
      return wrap(target.get(rawKey));
    } else if (target !== rawTarget) {
      target.get(key3);
    }
  }
  function has$1(key3, isReadonly = false) {
    const target = this[
      "__v_raw"
      /* RAW */
    ];
    const rawTarget = toRaw(target);
    const rawKey = toRaw(key3);
    if (key3 !== rawKey) {
      !isReadonly && track(rawTarget, "has", key3);
    }
    !isReadonly && track(rawTarget, "has", rawKey);
    return key3 === rawKey ? target.has(key3) : target.has(key3) || target.has(rawKey);
  }
  function size(target, isReadonly = false) {
    target = target[
      "__v_raw"
      /* RAW */
    ];
    !isReadonly && track(toRaw(target), "iterate", ITERATE_KEY);
    return Reflect.get(target, "size", target);
  }
  function add(value) {
    value = toRaw(value);
    const target = toRaw(this);
    const proto = getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
      target.add(value);
      trigger(target, "add", value, value);
    }
    return this;
  }
  function set$1(key3, value) {
    value = toRaw(value);
    const target = toRaw(this);
    const { has: has2, get: get3 } = getProto(target);
    let hadKey = has2.call(target, key3);
    if (!hadKey) {
      key3 = toRaw(key3);
      hadKey = has2.call(target, key3);
    } else if (true) {
      checkIdentityKeys(target, has2, key3);
    }
    const oldValue = get3.call(target, key3);
    target.set(key3, value);
    if (!hadKey) {
      trigger(target, "add", key3, value);
    } else if (hasChanged(value, oldValue)) {
      trigger(target, "set", key3, value, oldValue);
    }
    return this;
  }
  function deleteEntry(key3) {
    const target = toRaw(this);
    const { has: has2, get: get3 } = getProto(target);
    let hadKey = has2.call(target, key3);
    if (!hadKey) {
      key3 = toRaw(key3);
      hadKey = has2.call(target, key3);
    } else if (true) {
      checkIdentityKeys(target, has2, key3);
    }
    const oldValue = get3 ? get3.call(target, key3) : void 0;
    const result = target.delete(key3);
    if (hadKey) {
      trigger(target, "delete", key3, void 0, oldValue);
    }
    return result;
  }
  function clear() {
    const target = toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = true ? isMap(target) ? new Map(target) : new Set(target) : void 0;
    const result = target.clear();
    if (hadItems) {
      trigger(target, "clear", void 0, void 0, oldTarget);
    }
    return result;
  }
  function createForEach(isReadonly, isShallow) {
    return function forEach2(callback, thisArg) {
      const observed = this;
      const target = observed[
        "__v_raw"
        /* RAW */
      ];
      const rawTarget = toRaw(target);
      const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
      !isReadonly && track(rawTarget, "iterate", ITERATE_KEY);
      return target.forEach((value, key3) => {
        return callback.call(thisArg, wrap(value), wrap(key3), observed);
      });
    };
  }
  function createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
      const target = this[
        "__v_raw"
        /* RAW */
      ];
      const rawTarget = toRaw(target);
      const targetIsMap = isMap(rawTarget);
      const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
      const isKeyOnly = method === "keys" && targetIsMap;
      const innerIterator = target[method](...args);
      const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
      !isReadonly && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
      return {
        // iterator protocol
        next() {
          const { value, done } = innerIterator.next();
          return done ? { value, done } : {
            value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
            done
          };
        },
        // iterable protocol
        [Symbol.iterator]() {
          return this;
        }
      };
    };
  }
  function createReadonlyMethod(type) {
    return function(...args) {
      if (true) {
        const key3 = args[0] ? `on key "${args[0]}" ` : ``;
        console.warn(`${capitalize(type)} operation ${key3}failed: target is readonly.`, toRaw(this));
      }
      return type === "delete" ? false : this;
    };
  }
  function createInstrumentations() {
    const mutableInstrumentations2 = {
      get(key3) {
        return get$1(this, key3);
      },
      get size() {
        return size(this);
      },
      has: has$1,
      add,
      set: set$1,
      delete: deleteEntry,
      clear,
      forEach: createForEach(false, false)
    };
    const shallowInstrumentations2 = {
      get(key3) {
        return get$1(this, key3, false, true);
      },
      get size() {
        return size(this);
      },
      has: has$1,
      add,
      set: set$1,
      delete: deleteEntry,
      clear,
      forEach: createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
      get(key3) {
        return get$1(this, key3, true);
      },
      get size() {
        return size(this, true);
      },
      has(key3) {
        return has$1.call(this, key3, true);
      },
      add: createReadonlyMethod(
        "add"
        /* ADD */
      ),
      set: createReadonlyMethod(
        "set"
        /* SET */
      ),
      delete: createReadonlyMethod(
        "delete"
        /* DELETE */
      ),
      clear: createReadonlyMethod(
        "clear"
        /* CLEAR */
      ),
      forEach: createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
      get(key3) {
        return get$1(this, key3, true, true);
      },
      get size() {
        return size(this, true);
      },
      has(key3) {
        return has$1.call(this, key3, true);
      },
      add: createReadonlyMethod(
        "add"
        /* ADD */
      ),
      set: createReadonlyMethod(
        "set"
        /* SET */
      ),
      delete: createReadonlyMethod(
        "delete"
        /* DELETE */
      ),
      clear: createReadonlyMethod(
        "clear"
        /* CLEAR */
      ),
      forEach: createForEach(true, true)
    };
    const iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
    iteratorMethods.forEach((method) => {
      mutableInstrumentations2[method] = createIterableMethod(method, false, false);
      readonlyInstrumentations2[method] = createIterableMethod(method, true, false);
      shallowInstrumentations2[method] = createIterableMethod(method, false, true);
      shallowReadonlyInstrumentations2[method] = createIterableMethod(method, true, true);
    });
    return [
      mutableInstrumentations2,
      readonlyInstrumentations2,
      shallowInstrumentations2,
      shallowReadonlyInstrumentations2
    ];
  }
  var [mutableInstrumentations, readonlyInstrumentations, shallowInstrumentations, shallowReadonlyInstrumentations] = /* @__PURE__ */ createInstrumentations();
  function createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly ? readonlyInstrumentations : mutableInstrumentations;
    return (target, key3, receiver) => {
      if (key3 === "__v_isReactive") {
        return !isReadonly;
      } else if (key3 === "__v_isReadonly") {
        return isReadonly;
      } else if (key3 === "__v_raw") {
        return target;
      }
      return Reflect.get(hasOwn(instrumentations, key3) && key3 in target ? instrumentations : target, key3, receiver);
    };
  }
  var mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
  };
  var readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
  };
  function checkIdentityKeys(target, has2, key3) {
    const rawKey = toRaw(key3);
    if (rawKey !== key3 && has2.call(target, rawKey)) {
      const type = toRawType(target);
      console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
  }
  var reactiveMap = /* @__PURE__ */ new WeakMap();
  var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
  var readonlyMap = /* @__PURE__ */ new WeakMap();
  var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
  function targetTypeMap(rawType) {
    switch (rawType) {
      case "Object":
      case "Array":
        return 1;
      case "Map":
      case "Set":
      case "WeakMap":
      case "WeakSet":
        return 2;
      default:
        return 0;
    }
  }
  function getTargetType(value) {
    return value[
      "__v_skip"
      /* SKIP */
    ] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
  }
  function reactive2(target) {
    if (target && target[
      "__v_isReadonly"
      /* IS_READONLY */
    ]) {
      return target;
    }
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
  }
  function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
  }
  function createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!isObject(target)) {
      if (true) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
      }
      return target;
    }
    if (target[
      "__v_raw"
      /* RAW */
    ] && !(isReadonly && target[
      "__v_isReactive"
      /* IS_REACTIVE */
    ])) {
      return target;
    }
    const existingProxy = proxyMap.get(target);
    if (existingProxy) {
      return existingProxy;
    }
    const targetType = getTargetType(target);
    if (targetType === 0) {
      return target;
    }
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
  }
  function toRaw(observed) {
    return observed && toRaw(observed[
      "__v_raw"
      /* RAW */
    ]) || observed;
  }
  function isRef(r) {
    return Boolean(r && r.__v_isRef === true);
  }
  magic("nextTick", () => nextTick);
  magic("dispatch", (el) => dispatch.bind(dispatch, el));
  magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) => (key3, callback) => {
    let evaluate2 = evaluateLater2(key3);
    let getter = () => {
      let value;
      evaluate2((i) => value = i);
      return value;
    };
    let unwatch = watch(getter, callback);
    cleanup2(unwatch);
  });
  magic("store", getStores);
  magic("data", (el) => scope(el));
  magic("root", (el) => closestRoot(el));
  magic("refs", (el) => {
    if (el._x_refs_proxy)
      return el._x_refs_proxy;
    el._x_refs_proxy = mergeProxies(getArrayOfRefObject(el));
    return el._x_refs_proxy;
  });
  function getArrayOfRefObject(el) {
    let refObjects = [];
    findClosest(el, (i) => {
      if (i._x_refs)
        refObjects.push(i._x_refs);
    });
    return refObjects;
  }
  var globalIdMemo = {};
  function findAndIncrementId(name) {
    if (!globalIdMemo[name])
      globalIdMemo[name] = 0;
    return ++globalIdMemo[name];
  }
  function closestIdRoot(el, name) {
    return findClosest(el, (element) => {
      if (element._x_ids && element._x_ids[name])
        return true;
    });
  }
  function setIdRoot(el, name) {
    if (!el._x_ids)
      el._x_ids = {};
    if (!el._x_ids[name])
      el._x_ids[name] = findAndIncrementId(name);
  }
  magic("id", (el, { cleanup: cleanup2 }) => (name, key3 = null) => {
    let cacheKey = `${name}${key3 ? `-${key3}` : ""}`;
    return cacheIdByNameOnElement(el, cacheKey, cleanup2, () => {
      let root = closestIdRoot(el, name);
      let id2 = root ? root._x_ids[name] : findAndIncrementId(name);
      return key3 ? `${name}-${id2}-${key3}` : `${name}-${id2}`;
    });
  });
  interceptClone((from, to) => {
    if (from._x_id) {
      to._x_id = from._x_id;
    }
  });
  function cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id)
      el._x_id = {};
    if (el._x_id[cacheKey])
      return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(() => {
      delete el._x_id[cacheKey];
    });
    return output;
  }
  magic("el", (el) => el);
  warnMissingPluginMagic("Focus", "focus", "focus");
  warnMissingPluginMagic("Persist", "persist", "persist");
  function warnMissingPluginMagic(name, magicName, slug) {
    magic(magicName, (el) => warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
  }
  directive("modelable", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
    let func = evaluateLater2(expression);
    let innerGet = () => {
      let result;
      func((i) => result = i);
      return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val) => evaluateInnerSet(() => {
    }, { scope: { "__placeholder": val } });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(() => {
      if (!el._x_model)
        return;
      el._x_removeModelListeners["default"]();
      let outerGet = el._x_model.get;
      let outerSet = el._x_model.set;
      let releaseEntanglement = entangle(
        {
          get() {
            return outerGet();
          },
          set(value) {
            outerSet(value);
          }
        },
        {
          get() {
            return innerGet();
          },
          set(value) {
            innerSet(value);
          }
        }
      );
      cleanup2(releaseEntanglement);
    });
  });
  directive("teleport", (el, { modifiers, expression }, { cleanup: cleanup2 }) => {
    if (el.tagName.toLowerCase() !== "template")
      warn("x-teleport can only be used on a <template> tag", el);
    let target = getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) {
      el._x_forwardEvents.forEach((eventName) => {
        clone2.addEventListener(eventName, (e) => {
          e.stopPropagation();
          el.dispatchEvent(new e.constructor(e.type, e));
        });
      });
    }
    addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2) => {
      if (modifiers2.includes("prepend")) {
        target2.parentNode.insertBefore(clone3, target2);
      } else if (modifiers2.includes("append")) {
        target2.parentNode.insertBefore(clone3, target2.nextSibling);
      } else {
        target2.appendChild(clone3);
      }
    };
    mutateDom(() => {
      placeInDom(clone2, target, modifiers);
      skipDuringClone(() => {
        initTree(clone2);
      })();
    });
    el._x_teleportPutBack = () => {
      let target2 = getTarget(expression);
      mutateDom(() => {
        placeInDom(el._x_teleport, target2, modifiers);
      });
    };
    cleanup2(
      () => mutateDom(() => {
        clone2.remove();
        destroyTree(clone2);
      })
    );
  });
  var teleportContainerDuringClone = document.createElement("div");
  function getTarget(expression) {
    let target = skipDuringClone(() => {
      return document.querySelector(expression);
    }, () => {
      return teleportContainerDuringClone;
    })();
    if (!target)
      warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
  }
  var handler = () => {
  };
  handler.inline = (el, { modifiers }, { cleanup: cleanup2 }) => {
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(() => {
      modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
  };
  directive("ignore", handler);
  directive("effect", skipDuringClone((el, { expression }, { effect: effect3 }) => {
    effect3(evaluateLater(el, expression));
  }));
  function on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e) => callback(e);
    let options2 = {};
    let wrapHandler = (callback2, wrapper) => (e) => wrapper(callback2, e);
    if (modifiers.includes("dot"))
      event = dotSyntax(event);
    if (modifiers.includes("camel"))
      event = camelCase2(event);
    if (modifiers.includes("passive"))
      options2.passive = true;
    if (modifiers.includes("capture"))
      options2.capture = true;
    if (modifiers.includes("window"))
      listenerTarget = window;
    if (modifiers.includes("document"))
      listenerTarget = document;
    if (modifiers.includes("debounce")) {
      let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
      let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
      handler4 = debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
      let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
      let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
      handler4 = throttle(handler4, wait);
    }
    if (modifiers.includes("prevent"))
      handler4 = wrapHandler(handler4, (next, e) => {
        e.preventDefault();
        next(e);
      });
    if (modifiers.includes("stop"))
      handler4 = wrapHandler(handler4, (next, e) => {
        e.stopPropagation();
        next(e);
      });
    if (modifiers.includes("once")) {
      handler4 = wrapHandler(handler4, (next, e) => {
        next(e);
        listenerTarget.removeEventListener(event, handler4, options2);
      });
    }
    if (modifiers.includes("away") || modifiers.includes("outside")) {
      listenerTarget = document;
      handler4 = wrapHandler(handler4, (next, e) => {
        if (el.contains(e.target))
          return;
        if (e.target.isConnected === false)
          return;
        if (el.offsetWidth < 1 && el.offsetHeight < 1)
          return;
        if (el._x_isShown === false)
          return;
        next(e);
      });
    }
    if (modifiers.includes("self"))
      handler4 = wrapHandler(handler4, (next, e) => {
        e.target === el && next(e);
      });
    if (isKeyEvent(event) || isClickEvent(event)) {
      handler4 = wrapHandler(handler4, (next, e) => {
        if (isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) {
          return;
        }
        next(e);
      });
    }
    listenerTarget.addEventListener(event, handler4, options2);
    return () => {
      listenerTarget.removeEventListener(event, handler4, options2);
    };
  }
  function dotSyntax(subject) {
    return subject.replace(/-/g, ".");
  }
  function camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
  }
  function isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
  }
  function kebabCase2(subject) {
    if ([" ", "_"].includes(
      subject
    ))
      return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
  }
  function isKeyEvent(event) {
    return ["keydown", "keyup"].includes(event);
  }
  function isClickEvent(event) {
    return ["contextmenu", "click", "mouse"].some((i) => event.includes(i));
  }
  function isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i) => {
      return !["window", "document", "prevent", "stop", "once", "capture", "self", "away", "outside", "passive"].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
      let debounceIndex = keyModifiers.indexOf("debounce");
      keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
      let debounceIndex = keyModifiers.indexOf("throttle");
      keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0)
      return false;
    if (keyModifiers.length === 1 && keyToModifiers(e.key).includes(keyModifiers[0]))
      return false;
    const systemKeyModifiers = ["ctrl", "shift", "alt", "meta", "cmd", "super"];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier) => keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i) => !selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
      const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier) => {
        if (modifier === "cmd" || modifier === "super")
          modifier = "meta";
        return e[`${modifier}Key`];
      });
      if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
        if (isClickEvent(e.type))
          return false;
        if (keyToModifiers(e.key).includes(keyModifiers[0]))
          return false;
      }
    }
    return true;
  }
  function keyToModifiers(key3) {
    if (!key3)
      return [];
    key3 = kebabCase2(key3);
    let modifierToKeyMap = {
      "ctrl": "control",
      "slash": "/",
      "space": " ",
      "spacebar": " ",
      "cmd": "meta",
      "esc": "escape",
      "up": "arrow-up",
      "down": "arrow-down",
      "left": "arrow-left",
      "right": "arrow-right",
      "period": ".",
      "comma": ",",
      "equal": "=",
      "minus": "-",
      "underscore": "_"
    };
    modifierToKeyMap[key3] = key3;
    return Object.keys(modifierToKeyMap).map((modifier) => {
      if (modifierToKeyMap[modifier] === key3)
        return modifier;
    }).filter((modifier) => modifier);
  }
  directive("model", (el, { modifiers, expression }, { effect: effect3, cleanup: cleanup2 }) => {
    let scopeTarget = el;
    if (modifiers.includes("parent")) {
      scopeTarget = el.parentNode;
    }
    let evaluateGet = evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") {
      evaluateSet = evaluateLater(scopeTarget, `${expression} = __placeholder`);
    } else if (typeof expression === "function" && typeof expression() === "string") {
      evaluateSet = evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    } else {
      evaluateSet = () => {
      };
    }
    let getValue = () => {
      let result;
      evaluateGet((value) => result = value);
      return isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value) => {
      let result;
      evaluateGet((value2) => result = value2);
      if (isGetterSetter(result)) {
        result.set(value);
      } else {
        evaluateSet(() => {
        }, {
          scope: { "__placeholder": value }
        });
      }
    };
    if (typeof expression === "string" && el.type === "radio") {
      mutateDom(() => {
        if (!el.hasAttribute("name"))
          el.setAttribute("name", expression);
      });
    }
    var event = el.tagName.toLowerCase() === "select" || ["checkbox", "radio"].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = isCloning ? () => {
    } : on(el, event, modifiers, (e) => {
      setValue(getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
      if ([void 0, null, ""].includes(getValue()) || isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) {
        setValue(
          getInputValue(el, modifiers, { target: el }, getValue())
        );
      }
    }
    if (!el._x_removeModelListeners)
      el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(() => el._x_removeModelListeners["default"]());
    if (el.form) {
      let removeResetListener = on(el.form, "reset", [], (e) => {
        nextTick(() => el._x_model && el._x_model.set(getInputValue(el, modifiers, { target: el }, getValue())));
      });
      cleanup2(() => removeResetListener());
    }
    el._x_model = {
      get() {
        return getValue();
      },
      set(value) {
        setValue(value);
      }
    };
    el._x_forceModelUpdate = (value) => {
      if (value === void 0 && typeof expression === "string" && expression.match(/\./))
        value = "";
      window.fromModel = true;
      mutateDom(() => bind(el, "value", value));
      delete window.fromModel;
    };
    effect3(() => {
      let value = getValue();
      if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el))
        return;
      el._x_forceModelUpdate(value);
    });
  });
  function getInputValue(el, modifiers, event, currentValue) {
    return mutateDom(() => {
      if (event instanceof CustomEvent && event.detail !== void 0)
        return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
      else if (isCheckbox(el)) {
        if (Array.isArray(currentValue)) {
          let newValue = null;
          if (modifiers.includes("number")) {
            newValue = safeParseNumber(event.target.value);
          } else if (modifiers.includes("boolean")) {
            newValue = safeParseBoolean(event.target.value);
          } else {
            newValue = event.target.value;
          }
          return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([newValue]) : currentValue.filter((el2) => !checkedAttrLooseCompare2(el2, newValue));
        } else {
          return event.target.checked;
        }
      } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
        if (modifiers.includes("number")) {
          return Array.from(event.target.selectedOptions).map((option) => {
            let rawValue = option.value || option.text;
            return safeParseNumber(rawValue);
          });
        } else if (modifiers.includes("boolean")) {
          return Array.from(event.target.selectedOptions).map((option) => {
            let rawValue = option.value || option.text;
            return safeParseBoolean(rawValue);
          });
        }
        return Array.from(event.target.selectedOptions).map((option) => {
          return option.value || option.text;
        });
      } else {
        let newValue;
        if (isRadio(el)) {
          if (event.target.checked) {
            newValue = event.target.value;
          } else {
            newValue = currentValue;
          }
        } else {
          newValue = event.target.value;
        }
        if (modifiers.includes("number")) {
          return safeParseNumber(newValue);
        } else if (modifiers.includes("boolean")) {
          return safeParseBoolean(newValue);
        } else if (modifiers.includes("trim")) {
          return newValue.trim();
        } else {
          return newValue;
        }
      }
    });
  }
  function safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return isNumeric2(number) ? number : rawValue;
  }
  function checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
  }
  function isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
  }
  function isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
  }
  directive("cloak", (el) => queueMicrotask(() => mutateDom(() => el.removeAttribute(prefix("cloak")))));
  addInitSelector(() => `[${prefix("init")}]`);
  directive("init", skipDuringClone((el, { expression }, { evaluate: evaluate2 }) => {
    if (typeof expression === "string") {
      return !!expression.trim() && evaluate2(expression, {}, false);
    }
    return evaluate2(expression, {}, false);
  }));
  directive("text", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
    let evaluate2 = evaluateLater2(expression);
    effect3(() => {
      evaluate2((value) => {
        mutateDom(() => {
          el.textContent = value;
        });
      });
    });
  });
  directive("html", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
    let evaluate2 = evaluateLater2(expression);
    effect3(() => {
      evaluate2((value) => {
        mutateDom(() => {
          el.innerHTML = value;
          el._x_ignoreSelf = true;
          initTree(el);
          delete el._x_ignoreSelf;
        });
      });
    });
  });
  mapAttributes(startingWith(":", into(prefix("bind:"))));
  var handler2 = (el, { value, modifiers, expression, original }, { effect: effect3, cleanup: cleanup2 }) => {
    if (!value) {
      let bindingProviders = {};
      injectBindingProviders(bindingProviders);
      let getBindings = evaluateLater(el, expression);
      getBindings((bindings) => {
        applyBindingsObject(el, bindings, original);
      }, { scope: bindingProviders });
      return;
    }
    if (value === "key")
      return storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) {
      return;
    }
    let evaluate2 = evaluateLater(el, expression);
    effect3(() => evaluate2((result) => {
      if (result === void 0 && typeof expression === "string" && expression.match(/\./)) {
        result = "";
      }
      mutateDom(() => bind(el, value, result, modifiers));
    }));
    cleanup2(() => {
      el._x_undoAddedClasses && el._x_undoAddedClasses();
      el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
  };
  handler2.inline = (el, { value, modifiers, expression }) => {
    if (!value)
      return;
    if (!el._x_inlineBindings)
      el._x_inlineBindings = {};
    el._x_inlineBindings[value] = { expression, extract: false };
  };
  directive("bind", handler2);
  function storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
  }
  addRootSelector(() => `[${prefix("data")}]`);
  directive("data", (el, { expression }, { cleanup: cleanup2 }) => {
    if (shouldSkipRegisteringDataDuringClone(el))
      return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    injectMagics(magicContext, el);
    let dataProviderContext = {};
    injectDataProviders(dataProviderContext, magicContext);
    let data2 = evaluate(el, expression, { scope: dataProviderContext });
    if (data2 === void 0 || data2 === true)
      data2 = {};
    injectMagics(data2, el);
    let reactiveData = reactive(data2);
    initInterceptors(reactiveData);
    let undo = addScopeToNode(el, reactiveData);
    reactiveData["init"] && evaluate(el, reactiveData["init"]);
    cleanup2(() => {
      reactiveData["destroy"] && evaluate(el, reactiveData["destroy"]);
      undo();
    });
  });
  interceptClone((from, to) => {
    if (from._x_dataStack) {
      to._x_dataStack = from._x_dataStack;
      to.setAttribute("data-has-alpine-state", true);
    }
  });
  function shouldSkipRegisteringDataDuringClone(el) {
    if (!isCloning)
      return false;
    if (isCloningLegacy)
      return true;
    return el.hasAttribute("data-has-alpine-state");
  }
  directive("show", (el, { modifiers, expression }, { effect: effect3 }) => {
    let evaluate2 = evaluateLater(el, expression);
    if (!el._x_doHide)
      el._x_doHide = () => {
        mutateDom(() => {
          el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
      };
    if (!el._x_doShow)
      el._x_doShow = () => {
        mutateDom(() => {
          if (el.style.length === 1 && el.style.display === "none") {
            el.removeAttribute("style");
          } else {
            el.style.removeProperty("display");
          }
        });
      };
    let hide = () => {
      el._x_doHide();
      el._x_isShown = false;
    };
    let show = () => {
      el._x_doShow();
      el._x_isShown = true;
    };
    let clickAwayCompatibleShow = () => setTimeout(show);
    let toggle = once(
      (value) => value ? show() : hide(),
      (value) => {
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") {
          el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        } else {
          value ? clickAwayCompatibleShow() : hide();
        }
      }
    );
    let oldValue;
    let firstTime = true;
    effect3(() => evaluate2((value) => {
      if (!firstTime && value === oldValue)
        return;
      if (modifiers.includes("immediate"))
        value ? clickAwayCompatibleShow() : hide();
      toggle(value);
      oldValue = value;
      firstTime = false;
    }));
  });
  directive("for", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
    let iteratorNames = parseForExpression(expression);
    let evaluateItems = evaluateLater(el, iteratorNames.items);
    let evaluateKey = evaluateLater(
      el,
      // the x-bind:key expression is stored for our use instead of evaluated.
      el._x_keyExpression || "index"
    );
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(() => loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(() => {
      Object.values(el._x_lookup).forEach((el2) => mutateDom(
        () => {
          destroyTree(el2);
          el2.remove();
        }
      ));
      delete el._x_prevKeys;
      delete el._x_lookup;
    });
  });
  function loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i) => typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items) => {
      if (isNumeric3(items) && items >= 0) {
        items = Array.from(Array(items).keys(), (i) => i + 1);
      }
      if (items === void 0)
        items = [];
      let lookup = el._x_lookup;
      let prevKeys = el._x_prevKeys;
      let scopes = [];
      let keys = [];
      if (isObject2(items)) {
        items = Object.entries(items).map(([key3, value]) => {
          let scope2 = getIterationScopeVariables(iteratorNames, value, key3, items);
          evaluateKey((value2) => {
            if (keys.includes(value2))
              warn("Duplicate key on x-for", el);
            keys.push(value2);
          }, { scope: { index: key3, ...scope2 } });
          scopes.push(scope2);
        });
      } else {
        for (let i = 0; i < items.length; i++) {
          let scope2 = getIterationScopeVariables(iteratorNames, items[i], i, items);
          evaluateKey((value) => {
            if (keys.includes(value))
              warn("Duplicate key on x-for", el);
            keys.push(value);
          }, { scope: { index: i, ...scope2 } });
          scopes.push(scope2);
        }
      }
      let adds = [];
      let moves = [];
      let removes = [];
      let sames = [];
      for (let i = 0; i < prevKeys.length; i++) {
        let key3 = prevKeys[i];
        if (keys.indexOf(key3) === -1)
          removes.push(key3);
      }
      prevKeys = prevKeys.filter((key3) => !removes.includes(key3));
      let lastKey = "template";
      for (let i = 0; i < keys.length; i++) {
        let key3 = keys[i];
        let prevIndex = prevKeys.indexOf(key3);
        if (prevIndex === -1) {
          prevKeys.splice(i, 0, key3);
          adds.push([lastKey, i]);
        } else if (prevIndex !== i) {
          let keyInSpot = prevKeys.splice(i, 1)[0];
          let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
          prevKeys.splice(i, 0, keyForSpot);
          prevKeys.splice(prevIndex, 0, keyInSpot);
          moves.push([keyInSpot, keyForSpot]);
        } else {
          sames.push(key3);
        }
        lastKey = key3;
      }
      for (let i = 0; i < removes.length; i++) {
        let key3 = removes[i];
        if (!(key3 in lookup))
          continue;
        mutateDom(() => {
          destroyTree(lookup[key3]);
          lookup[key3].remove();
        });
        delete lookup[key3];
      }
      for (let i = 0; i < moves.length; i++) {
        let [keyInSpot, keyForSpot] = moves[i];
        let elInSpot = lookup[keyInSpot];
        let elForSpot = lookup[keyForSpot];
        let marker = document.createElement("div");
        mutateDom(() => {
          if (!elForSpot)
            warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
          elForSpot.after(marker);
          elInSpot.after(elForSpot);
          elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
          marker.before(elInSpot);
          elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
          marker.remove();
        });
        elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
      }
      for (let i = 0; i < adds.length; i++) {
        let [lastKey2, index2] = adds[i];
        let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
        if (lastEl._x_currentIfEl)
          lastEl = lastEl._x_currentIfEl;
        let scope2 = scopes[index2];
        let key3 = keys[index2];
        let clone2 = document.importNode(templateEl.content, true).firstElementChild;
        let reactiveScope = reactive(scope2);
        addScopeToNode(clone2, reactiveScope, templateEl);
        clone2._x_refreshXForScope = (newScope) => {
          Object.entries(newScope).forEach(([key22, value]) => {
            reactiveScope[key22] = value;
          });
        };
        mutateDom(() => {
          lastEl.after(clone2);
          skipDuringClone(() => initTree(clone2))();
        });
        if (typeof key3 === "object") {
          warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
        }
        lookup[key3] = clone2;
      }
      for (let i = 0; i < sames.length; i++) {
        lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
      }
      templateEl._x_prevKeys = keys;
    });
  }
  function parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch)
      return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
      res.item = item.replace(forIteratorRE, "").trim();
      res.index = iteratorMatch[1].trim();
      if (iteratorMatch[2]) {
        res.collection = iteratorMatch[2].trim();
      }
    } else {
      res.item = item;
    }
    return res;
  }
  function getIterationScopeVariables(iteratorNames, item, index2, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
      let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i) => i.trim());
      names.forEach((name, i) => {
        scopeVariables[name] = item[i];
      });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
      let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i) => i.trim());
      names.forEach((name) => {
        scopeVariables[name] = item[name];
      });
    } else {
      scopeVariables[iteratorNames.item] = item;
    }
    if (iteratorNames.index)
      scopeVariables[iteratorNames.index] = index2;
    if (iteratorNames.collection)
      scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
  }
  function isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
  }
  function handler3() {
  }
  handler3.inline = (el, { expression }, { cleanup: cleanup2 }) => {
    let root = closestRoot(el);
    if (!root._x_refs)
      root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(() => delete root._x_refs[expression]);
  };
  directive("ref", handler3);
  directive("if", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
    if (el.tagName.toLowerCase() !== "template")
      warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = evaluateLater(el, expression);
    let show = () => {
      if (el._x_currentIfEl)
        return el._x_currentIfEl;
      let clone2 = el.content.cloneNode(true).firstElementChild;
      addScopeToNode(clone2, {}, el);
      mutateDom(() => {
        el.after(clone2);
        skipDuringClone(() => initTree(clone2))();
      });
      el._x_currentIfEl = clone2;
      el._x_undoIf = () => {
        mutateDom(() => {
          destroyTree(clone2);
          clone2.remove();
        });
        delete el._x_currentIfEl;
      };
      return clone2;
    };
    let hide = () => {
      if (!el._x_undoIf)
        return;
      el._x_undoIf();
      delete el._x_undoIf;
    };
    effect3(() => evaluate2((value) => {
      value ? show() : hide();
    }));
    cleanup2(() => el._x_undoIf && el._x_undoIf());
  });
  directive("id", (el, { expression }, { evaluate: evaluate2 }) => {
    let names = evaluate2(expression);
    names.forEach((name) => setIdRoot(el, name));
  });
  interceptClone((from, to) => {
    if (from._x_ids) {
      to._x_ids = from._x_ids;
    }
  });
  mapAttributes(startingWith("@", into(prefix("on:"))));
  directive("on", skipDuringClone((el, { value, modifiers, expression }, { cleanup: cleanup2 }) => {
    let evaluate2 = expression ? evaluateLater(el, expression) : () => {
    };
    if (el.tagName.toLowerCase() === "template") {
      if (!el._x_forwardEvents)
        el._x_forwardEvents = [];
      if (!el._x_forwardEvents.includes(value))
        el._x_forwardEvents.push(value);
    }
    let removeListener = on(el, value, modifiers, (e) => {
      evaluate2(() => {
      }, { scope: { "$event": e }, params: [e] });
    });
    cleanup2(() => removeListener());
  }));
  warnMissingPluginDirective("Collapse", "collapse", "collapse");
  warnMissingPluginDirective("Intersect", "intersect", "intersect");
  warnMissingPluginDirective("Focus", "trap", "focus");
  warnMissingPluginDirective("Mask", "mask", "mask");
  function warnMissingPluginDirective(name, directiveName, slug) {
    directive(directiveName, (el) => warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
  }
  alpine_default.setEvaluator(normalEvaluator);
  alpine_default.setReactivityEngine({ reactive: reactive2, effect: effect2, release: stop, raw: toRaw });
  var src_default = alpine_default;
  var module_default = src_default;

  // src/utilities/transitions.ts
  var slideTransition = {
    "x-transition:enter": "transition ease-in-out duration-300 transform",
    "x-transition:enter-start": "-translate-x-full",
    "x-transition:enter-end": "translate-x-0",
    "x-transition:leave": "transition ease-in-out duration-300 transform",
    "x-transition:leave-start": "translate-x-0",
    "x-transition:leave-end": "-translate-x-full"
  };

  // src/alpine/components/addressSwitch.ts
  var addressSwitch = (Alpine2) => Alpine2.data("addressSwitch", ({ addresses }) => ({
    ...{ addresses, slideTransition },
    visibleForm: false,
    currentlyEditedAddress: null,
    showForm() {
      this.visibleForm = true;
    },
    editAddress(id2) {
      this.visibleForm = true;
      this.currentlyEditedAddress = this.addresses.find(
        (el) => el.id === id2
      );
      this.scrollFormIntoView();
    },
    cancelEdit() {
      this.visibleForm = false;
      this.currentlyEditedAddress = null;
      this.scrollFormIntoView();
    },
    scrollFormIntoView() {
      if (window.matchMedia("(max-width: 1023px)").matches) {
        document.querySelector(".address-form").scrollIntoView({ behavior: "smooth" });
      }
    }
  }));

  // src/alpine/components/announcement.ts
  var announcement = (Alpine2) => Alpine2.data("announcement", (props) => {
    const { settings } = props;
    return {
      current: 0,
      count: props.count,
      init() {
        if (settings.auto_scroll && props.count > 0) {
          setInterval(
            () => this.hasBeenTouched || this.change(this.current + 1),
            settings.delay * 1e3
          );
        }
      },
      hasBeenTouched: false,
      change(index2) {
        this.current = (index2 + props.count) % props.count;
      },
      isCurrent(index2) {
        return this.current === index2;
      },
      isNext(index2) {
        return index2 === (this.current + 1) % props.count;
      },
      isPrevious(index2) {
        return index2 === (this.current + props.count - 1) % props.count;
      },
      isNotNearby(index2) {
        return this.current !== index2 && !this.isNext(index2) && !this.isPrevious(index2);
      },
      scrollThrough() {
        return {
          "x-transition:enter": "delay-200",
          "x-transition:enter-start": "translate-x-1/2 opacity-0",
          "x-transition:enter-end": "translate-x-0",
          "x-transition:leave-start": "translate-x-0",
          "x-transition:leave-end": "-translate-x-1/2 opacity-0 "
        };
      }
    };
  });

  // src/alpine/components/backInStock.ts
  var backInStock = (Alpine2) => {
    Alpine2.data("backInStock", (product, variant) => ({
      open: false,
      sending: false,
      sent: false,
      query: {
        a: "MYmcRb",
        g: "",
        email: "",
        variant,
        product,
        platform: "shopify",
        subscribe_for_newsletter: false
      },
      get emailIsValid() {
        return /.+@.+\..+/.test(this.query.email);
      },
      get buttonLabel() {
        if (this.sending) return "Sending...";
        if (this.sent) return "Sent!";
        return "Join the Waitlist";
      },
      async submit() {
        if (!this.query.email) return;
        const url = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe";
        const options2 = {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: new URLSearchParams(this.query)
        };
        this.sending = true;
        try {
          const response = await fetch(url, options2);
          if (!response.ok) throw new Error("Failed to subscribe");
          const data2 = await response.json();
          if (!data2.success) throw new Error("Failed to subscribe");
        } catch (e) {
          console.error(e);
        }
        this.sending = false;
        this.sent = true;
        setTimeout(() => this.open = false, 2e3);
      }
    }));
  };

  // node_modules/.pnpm/@shopify+theme-currency@4.1.1/node_modules/@shopify/theme-currency/currency.js
  var moneyFormat = "${{amount}}";
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  // src/utilities/formatMoney.ts
  var formatMoney2 = (amount) => formatMoney(
    amount,
    Number(amount) % 100 ? "${{amount}}" : window.NewThink.MONEY_FORMAT
  );

  // node_modules/.pnpm/@shopify+admin-graphql-api-utilities@2.2.0/node_modules/@shopify/admin-graphql-api-utilities/build/esm/index.mjs
  var GID_TYPE_REGEXP = /^gid:\/\/[\w-]+\/([\w-]+)\//;
  var GID_REGEXP = /\/(\w[\w-]*)(?:\?(.*))*$/;
  function parseGidType(gid) {
    const matches2 = GID_TYPE_REGEXP.exec(gid);
    if (matches2 && matches2[1] !== void 0) {
      return matches2[1];
    }
    throw new Error(`Invalid gid: ${gid}`);
  }
  function parseGid(gid) {
    const id2 = `/${gid}`;
    const matches2 = GID_REGEXP.exec(id2);
    if (matches2 && matches2[1] !== void 0) {
      return matches2[1];
    }
    throw new Error(`Invalid gid: ${gid}`);
  }
  function composeGidFactory(namespace) {
    return function composeGid2(key3, id2, params = {}) {
      const gid = `gid://${namespace}/${key3}/${id2}`;
      const paramKeys = Object.keys(params);
      if (paramKeys.length === 0) {
        return gid;
      }
      const paramString = new URLSearchParams(params).toString();
      return `${gid}?${paramString}`;
    };
  }
  var composeGid = composeGidFactory("shopify");
  function isGidFactory(namespace) {
    return function isGid2(gid, key3) {
      if (!gid.startsWith(`gid://${namespace}/`)) {
        return false;
      }
      try {
        if (key3 !== void 0 && parseGidType(gid) !== key3) {
          return false;
        }
      } catch {
        return false;
      }
      const id2 = `/${gid}`;
      return GID_REGEXP.test(id2);
    };
  }
  var isGid = isGidFactory("shopify");

  // src/alpine/components/cartDrawer.ts
  var cartDrawer = (Alpine2) => Alpine2.data("cartDrawer", () => ({
    productPreorder: {},
    variantPreorder: {},
    get title() {
      const count = this.$store.cart.totalItems;
      return `${count} item${count === 1 ? "" : "s"}`;
    },
    get totalPrice() {
      return this.$store.cart.totalPrice;
    },
    get totalPriceAsString() {
      return formatMoney2(this.totalPrice);
    },
    get cartItems() {
      return this.$store.cart.visibleItems;
    },
    init() {
      Alpine2.effect(() => {
        const preorderDates = this.$store.cart.preorderDates;
        if (preorderDates.productPreorder) {
          this.productPreorder = preorderDates.productPreorder.reduce(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (obj, metafield) => {
              if (!(metafield == null ? void 0 : metafield.date)) return obj;
              obj[`${parseGid(metafield.id)}`] = metafield.date.value;
              return obj;
            },
            {}
          );
        }
        if (preorderDates.variantPreorder) {
          this.variantPreorder = preorderDates.variantPreorder.reduce(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (obj, metafield) => {
              if (!(metafield == null ? void 0 : metafield.date)) return obj;
              obj[`${parseGid(metafield.id)}`] = metafield.date.value;
              return obj;
            },
            {}
          );
        }
      });
    },
    itemIsPreorder(vid, pid) {
      const isPreorder = vid in this.variantPreorder || pid in this.productPreorder;
      return isPreorder;
    },
    printPreorderDate(vid, pid) {
      const variantDate = this.variantPreorder[vid];
      const productDate = this.productPreorder[pid];
      const dateString = variantDate || productDate;
      if (!dateString) return;
      const time = "T01:00:00";
      return new Intl.DateTimeFormat("en-us", {
        month: "long",
        day: "numeric"
      }).format(new Date(dateString + time));
    },
    get containsPreorderItems() {
      return this.cartItems.some(
        (item) => this.itemIsPreorder(
          item.variant_id.toString(),
          item.product_id.toString()
        )
      );
    },
    close() {
      this.$store.cart.close();
    },
    removeItem(key3) {
      this.$store.cart.removeItem(key3);
    },
    updateQuantity(key3, quantity2) {
      this.$store.cart.updateItem(key3, { quantity: quantity2 });
    },
    getProperties(object) {
      const props = Object.entries(object).filter(
        ([key3]) => !key3.startsWith("_")
      );
      return props;
    },
    getOptions(item) {
      return item.options_with_values.filter(
        (opt) => !hiddenOptions.includes(opt.name.toLowerCase()) && !opt.value.toLowerCase().includes("default")
      );
    },
    getPrint(item) {
      var _a4, _b2;
      return (_b2 = (_a4 = item.title.match(/-\s([^-]*)\s-/)) == null ? void 0 : _a4[1].trim()) != null ? _b2 : "";
    },
    getItemByKey(key3) {
      return this.cartItems.find((item) => item.key === key3);
    },
    formatMoney: formatMoney2,
    isItemLevelDiscounted(item) {
      return item.line_level_discount_allocations.length > 0;
    }
  }));
  var hiddenOptions = ["material", "color"];

  // node_modules/.pnpm/@shopify+theme-cart@4.1.1/node_modules/@shopify/theme-cart/request.js
  function getDefaultRequestConfig() {
    return JSON.parse(
      JSON.stringify({
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json;"
        }
      })
    );
  }
  function fetchJSON(url, config) {
    return fetch(url, config).then(function(response) {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    });
  }
  function cart() {
    return fetchJSON("/cart.js", getDefaultRequestConfig());
  }
  function cartChange(line, options2) {
    var config = getDefaultRequestConfig();
    options2 = options2 || {};
    config.method = "POST";
    config.body = JSON.stringify({
      line,
      quantity: options2.quantity,
      properties: options2.properties
    });
    return fetchJSON("/cart/change.js", config);
  }
  function cartUpdate(body) {
    var config = getDefaultRequestConfig();
    config.method = "POST";
    config.body = JSON.stringify(body);
    return fetchJSON("/cart/update.js", config);
  }

  // node_modules/.pnpm/@shopify+theme-cart@4.1.1/node_modules/@shopify/theme-cart/validate.js
  function key(key3) {
    if (typeof key3 !== "string" || key3.split(":").length !== 2) {
      throw new TypeError(
        "Theme Cart: Provided key value is not a string with the format xxx:xxx"
      );
    }
  }
  function quantity(quantity2) {
    if (typeof quantity2 !== "number" || isNaN(quantity2)) {
      throw new TypeError(
        "Theme Cart: An object which specifies a quantity or properties value is required"
      );
    }
  }
  function properties(properties2) {
    if (typeof properties2 !== "object") {
      throw new TypeError("Theme Cart: Properties must be an object");
    }
  }
  function options(options2) {
    if (typeof options2 !== "object") {
      throw new TypeError("Theme Cart: Options must be an object");
    }
    if (typeof options2.quantity === "undefined" && typeof options2.properties === "undefined") {
      throw new Error(
        "Theme Cart: You muse define a value for quantity or properties"
      );
    }
    if (typeof options2.quantity !== "undefined") {
      quantity(options2.quantity);
    }
    if (typeof options2.properties !== "undefined") {
      properties(options2.properties);
    }
  }

  // node_modules/.pnpm/@shopify+theme-cart@4.1.1/node_modules/@shopify/theme-cart/theme-cart.js
  function getState() {
    return cart();
  }
  function getItemIndex(key3) {
    key(key3);
    return cart().then(function(state) {
      var index2 = -1;
      state.items.forEach(function(item, i) {
        index2 = item.key === key3 ? i + 1 : index2;
      });
      if (index2 === -1) {
        return Promise.reject(
          new Error("Theme Cart: Unable to match line item with provided key")
        );
      }
      return index2;
    });
  }
  function updateItem(key3, options2) {
    key(key3);
    options(options2);
    return getItemIndex(key3).then(function(line) {
      return cartChange(line, options2);
    });
  }
  function removeItem(key3) {
    key(key3);
    return getItemIndex(key3).then(function(line) {
      return cartChange(line, { quantity: 0 });
    });
  }
  function getAttributes() {
    return cart().then(function(state) {
      return state.attributes;
    });
  }
  function updateAttributes(attributes) {
    return cartUpdate({ attributes });
  }
  function updateNote(note) {
    return cartUpdate({ note });
  }

  // src/alpine/components/cartOptions.ts
  var cartOptions = (Alpine2) => {
    Alpine2.data("cartOptions", ({ giftNote }) => ({
      giftNote,
      updateNote,
      showNote: Boolean(giftNote),
      isGift: true,
      hasGift(id2) {
        return this.$store.cart.items.some(
          (item) => {
            var _a4;
            return item.id === id2 && ((_a4 = item.properties) == null ? void 0 : _a4._gift_option);
          }
        );
      },
      updateGift(id2, val) {
        var _a4;
        if (val === this.hasGift(id2)) return;
        if (val)
          this.$store.cart.addItem({
            id: id2,
            properties: { _gift_option: true }
          });
        else {
          const key3 = (_a4 = this.$store.cart.items.find(
            (item) => {
              var _a5;
              return item.id === id2 && ((_a5 = item.properties) == null ? void 0 : _a5._gift_option);
            }
          )) == null ? void 0 : _a4.key;
          if (key3) this.$store.cart.removeItem(key3);
        }
      },
      get cart() {
        return this.$store.cart;
      },
      async init() {
        var _a4;
        const attributes = await getAttributes();
        this.isGift = JSON.parse((_a4 = attributes.isGift) != null ? _a4 : "false");
        Alpine2.effect(() => {
          updateAttributes({ isGift: this.isGift });
          if (this.isGift) return;
          this.showNote = false;
        });
        Alpine2.effect(() => {
          if (this.showNote) return;
          updateNote("");
          this.giftNote = "";
        });
      },
      get showOptions() {
        return this.isGift;
      },
      postNote() {
        updateNote(this.giftNote);
      }
    }));
  };

  // src/utilities/partition.ts
  var partition = (arr, predicate) => {
    const truthy = [];
    const falsy = [];
    for (const item of arr) {
      if (predicate(item)) truthy.push(item);
      else falsy.push(item);
    }
    return [truthy, falsy];
  };

  // src/utilities/tryOr.ts
  var tryOr = async (fn, fallback) => {
    try {
      return await fn();
    } catch (e) {
      return fallback;
    }
  };

  // src/alpine/components/cartThreshold.ts
  var cartThreshold = (Alpine2) => Alpine2.data("cartThreshold", () => {
    var _a4;
    const manRemoved = Alpine2.reactive(
      new Set(
        ((_a4 = sessionStorage.getItem("manually_removed_gifts")) != null ? _a4 : "").split(",").map(Number)
      )
    );
    Alpine2.effect(
      () => sessionStorage.setItem(
        "manually_removed_gifts",
        [...manRemoved].join(",")
      )
    );
    return {
      thresholds: [],
      giftThresholds: [],
      displayedThresholds: [],
      effects: [],
      async init() {
        const thresholds = await tryOr(
          () => JSON.parse(this.$el.querySelector("#thresholds").textContent),
          []
        );
        this.thresholds = thresholds.filter(Boolean).sort((a, b) => a.threshold - b.threshold);
        this.giftThresholds = this.thresholds.filter(
          ({ productId }) => productId
        );
        this.displayedThresholds = this.thresholds.filter(
          ({ threshold }) => threshold
        );
        this.effects.push(
          Alpine2.effect(async () => {
            const totalPrice = this.totalPrice;
            const [add2, remove] = partition(
              this.giftThresholds,
              ({ threshold }) => totalPrice && threshold <= totalPrice
            ).map((list) => list.map(({ productId }) => productId));
            await Promise.all([
              ...remove.map(this.removeGift.bind(this)),
              ...add2.map(this.addGift.bind(this))
            ]);
          })
        );
      },
      destroy() {
        this.effects.forEach(Alpine2.release);
      },
      get totalPrice() {
        return this.$store.cart.items.reduce(
          (total, item) => {
            var _a5;
            return ((_a5 = item.properties) == null ? void 0 : _a5._gift) ? total : total + item.original_line_price;
          },
          0
        );
      },
      get giftItems() {
        return this.$store.cart.items.filter(isGift());
      },
      get nextThreshold() {
        const totalPrice = this.totalPrice;
        return this.thresholds.find(
          ({ threshold }) => threshold && threshold > totalPrice
        );
      },
      get maxThreshold() {
        return this.thresholds[this.thresholds.length - 1];
      },
      get remaining() {
        const nextThreshold = this.nextThreshold;
        if (!nextThreshold) return 0;
        return nextThreshold.threshold - this.totalPrice;
      },
      get message() {
        var _a5, _b2, _c, _d;
        return ((_d = (_c = (_a5 = this.nextThreshold) == null ? void 0 : _a5.beforeMessage) != null ? _c : (_b2 = this.maxThreshold) == null ? void 0 : _b2.afterMessage) != null ? _d : "").replaceAll("${remaining}", formatMoney2(this.remaining.toString()));
      },
      async addGift(id2) {
        const existingGift = this.$store.cart.items.find(isGift(id2));
        if (existingGift || manRemoved.has(id2)) return;
        await this.$store.cart.addItem({ id: id2, properties: { _gift: true } });
      },
      async removeGift(id2, manual = false) {
        const existingGift = this.$store.cart.items.find(isGift(id2));
        if (!existingGift) return;
        if (manual) manRemoved.add(id2);
        await this.$store.cart.removeItem(existingGift.key);
      }
    };
  });
  var isGift = (id2) => (item) => {
    var _a4;
    return ((_a4 = item.properties) == null ? void 0 : _a4._gift) && (id2 ? item.variant_id === id2 : true);
  };

  // src/alpine/components/header.ts
  var header = (Alpine2) => Alpine2.data("header", () => ({
    /* Fixes for awful iOS Safari behaviors */
    init() {
      const sectionEl = this.$el.closest("section.sticky");
      if (!sectionEl) return;
      sectionEl.style.transitionProperty = "top";
      Alpine2.effect(() => {
        const value = this.$scroll.direction === "down" && !this.$scroll.nearTop && !this.$store.search.isOpen ? `-${this.$el.clientHeight}px` : "0";
        sectionEl.style.setProperty("top", value);
      });
      Alpine2.effect(() => {
        sectionEl.classList.toggle(
          "sticky",
          this.$screen("md") || !this.$store.search.isOpen
        );
      });
    }
  }));

  // src/alpine/components/meganav.ts
  var meganav = (Alpine2) => {
    Alpine2.data("meganav", () => ({
      isVisible: false,
      meganavIndex: 0,
      init() {
        this.meganavIndex = this.$store.meganavState.registerItem();
      },
      show() {
        this.isVisible = true;
        this.$store.meganavState.items[this.meganavIndex] = true;
      },
      hide() {
        this.isVisible = false;
        this.$store.meganavState.items[this.meganavIndex] = false;
      },
      toggle() {
        this.isVisible = !this.isVisible;
        Alpine2.nextTick(() => this.$store.meganavStateIsOpen = this.isVisible);
      },
      expand: {
        ["@mouseover"]() {
          this.show();
        },
        ["@mouseleave"]() {
          this.hide();
        },
        ["@keydown.tab"]() {
          if (this.$event.target.isSameNode(this.$focus.getLast()) && this.isVisible && !this.$event.shiftKey) {
            this.isVisible = false;
          }
        },
        ["@keydown.shift.tab"]() {
          if (this.$event.target.isSameNode(this.$focus.getFirst()) && this.isVisible) {
            this.isVisible = false;
          }
        },
        ["@keydown.esc"]() {
          this.$focus.getFirst().focus();
          this.isVisible = false;
        },
        ["@keydown.down.prevent"]() {
          this.$focus.wrap().next();
        },
        ["@keydown.up.prevent"]() {
          this.$focus.wrap().previous();
        }
      },
      fade: {
        "x-transition:enter": "transition-[top] duration-200",
        "x-transition:enter-start": "top-5",
        "x-transition:enter-end": "top-3",
        "x-transition:leave": "transition-[top] duration-200",
        "x-transition:leave-start": "top-3",
        "x-transition:leave-end": "top-5"
      }
    }));
    Alpine2.store("meganavState", {
      get isOpen() {
        return this.items.length ? this.items.some((bool) => bool) : false;
      },
      items: [],
      registerItem() {
        this.items.push(false);
        return this.items.length - 1;
      }
    });
  };

  // src/alpine/components/mobileMenu.ts
  var mobileMenu = (Alpine2) => Alpine2.data("mobileMenu", () => ({
    get isOpen() {
      return this.$store.mobileMenu.visible;
    },
    open() {
      this.$store.mobileMenu.show();
    },
    close() {
      this.$store.mobileMenu.hide();
    },
    cleanUp() {
      this.$refs.menuDrawerList.querySelectorAll("details").forEach((detail) => detail.removeAttribute("open"));
    }
  }));

  // src/utilities/index.ts
  var productVariantsPreorderDates = `
query variantPreorderDates($pid: ID!) {
    product(id: $pid) {
        metafield(key: "date", namespace: "preorder") {
          value
        }
        variants(first: 10) {
            nodes {
                metafield(key: "date", namespace: "preorder") {
                    value
                }
                id
            }
        }
    }
}`;
  var getManyPreorderDates = `
query getManyPreorderDates($products: [ID!]!, $variants: [ID!]!) {
  productPreorder: nodes(ids: $products) {
    ...on Product {
      id
      date: metafield(key: "date", namespace: "preorder") {
        value
      }
    }
  }
  variantPreorder: nodes(ids: $variants) {
    ...on ProductVariant {
      id
      date: metafield(key: "date", namespace: "preorder") {
        value
      }
    }
  }
}
`;
  async function gqlFetch(body) {
    if (!window.NewThink.STOREFRONT_ACCESS) return {};
    const response = await fetch(
      `https://${window.Shopify.shop}/api/2022-07/graphql.json`,
      {
        method: "POST",
        headers: {
          "X-Shopify-Storefront-Access-Token": window.NewThink.STOREFRONT_ACCESS,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(body)
      }
    );
    return response.json();
  }

  // src/utilities/arrayWrap.ts
  var arrayWrap = (maybeArray) => {
    if (Array.isArray(maybeArray)) return maybeArray;
    return [maybeArray];
  };

  // src/utilities/morphNodes.ts
  var morphNodes = (html, selectors, fullSwap = false) => {
    const newContent = document.createRange().createContextualFragment(html);
    arrayWrap(selectors).forEach((selector) => {
      const newNode = newContent.querySelector(selector);
      if (!newNode) return;
      if (newNode.matches('script:not([type="application/json"])'))
        return new Function(newNode.textContent)();
      const target = document.querySelector(selector);
      if (!target) return;
      if (fullSwap) target.replaceWith(newNode);
      else alpine_default2.morph(target, newNode.outerHTML, morphOptions, true);
    });
  };
  var morphOptions = {
    lookahead: true,
    updating(el, toEl, childrenOnly, skip) {
      const els = [el, toEl];
      el.dispatchEvent(new CustomEvent("morph-updating", { bubbles: false }));
      if (els.every(
        (el2) => el2.nodeType === Node.ELEMENT_NODE && el2.getAttribute("x-skip-morph") !== null
      ))
        skip();
      if (els.some((el2) => el2.nodeType === Node.ELEMENT_NODE) && el.getAttribute("x-replace-morph") !== null) {
        queueMicrotask(() => el.replaceWith(toEl));
        skip();
      }
      if (els.some((el2) => el2.nodeType === Node.ELEMENT_NODE) && el.getAttribute("x-children-morph") !== null)
        childrenOnly();
    }
  };

  // src/utilities/uuid.ts
  var getShopifyUUID = () => {
    var _a4, _b2, _c, _d, _e, _f;
    return (_f = (_e = (_d = (_c = (_b2 = (_a4 = window.ShopifyAnalytics) == null ? void 0 : _a4.lib) == null ? void 0 : _b2.user) == null ? void 0 : _c.call(_b2)) == null ? void 0 : _d.traits) == null ? void 0 : _e.call(_d)) == null ? void 0 : _f.uniqToken;
  };
  var uuidPromise = (async () => {
    let token;
    while (!token) {
      await new Promise((r) => requestAnimationFrame(r));
      token = getShopifyUUID();
    }
    return token;
  })();
  var uuid = () => uuidPromise;

  // src/utilities/rebuyClient.ts
  var _a2;
  var key2 = (_a2 = window.NewThink.REBUY_API_KEY) != null ? _a2 : window.Rebuy.shop.api_key;
  function rebuyClient(type, customId) {
    if (!key2)
      return RebuyInitError(
        "Please configure RebuyApiKey in your Theme settings."
      );
    if (!type)
      return RebuyInitError(
        "Please check that all your Rebuy blocks have a valid type."
      );
    if (type === "custom" && !customId)
      return RebuyInitError(
        "Please check that all your Custom Sourced Rebuy Blocks have valid IDs."
      );
    const endpoint = new URL(
      `${rebuyBaseURL}${rebuyTypeMap[type]}${type === "custom" ? customId : ""}`
    );
    return async (data2) => {
      Object.assign(data2, {
        key: key2,
        metafields: "yes",
        uuid: await uuid()
      });
      endpoint.search = new URLSearchParams(
        data2
      ).toString();
      const response = await fetch(endpoint.toString(), {
        method: "GET",
        headers: {
          Accept: "application/json"
        }
      });
      const results = await response.json();
      return results.data;
    };
  }
  var rebuyViewEvent = async (handle) => {
    if (!key2) return;
    const endpoint = new URL(`${rebuyBaseURL}analytics/event`);
    endpoint.search = new URLSearchParams({
      key: key2,
      uuid: await uuid(),
      subject: "user",
      verb: "viewed",
      noun: "product",
      shopify_product_handle: handle
    }).toString();
    await fetch(endpoint.toString(), {
      method: "POST"
    });
  };
  var RebuyInitError = (message) => {
    console.error(message);
    return () => Promise.resolve([]);
  };
  var rebuyBaseURL = "https://rebuyengine.com/api/v1/";
  var rebuyTypeMap = {
    collections: "products/collections",
    custom: "custom/id/",
    purchased: "products/purchased",
    recommended: "products/recommended",
    search: "products/search",
    similar: "products/similar_products",
    "top-sellers": "products/top_sellers",
    viewed: "products/viewed",
    [""]: "products/recommended"
  };

  // src/alpine/components/page/mainProduct.ts
  var mainProduct = (Alpine2) => Alpine2.data("mainProduct", () => ({
    ...parseProductJSON(),
    updating: false,
    adding: false,
    quantity: 1,
    queryData: null,
    async addToCart(id2) {
      this.adding = true;
      await Alpine2.store("cart").addFromForm(id2);
      this.adding = false;
    },
    // Get either Product or Variant preorder date if set
    // If Product has preorder date return as there is no reason to check variant preorder date
    get preorderDate() {
      var _a4, _b2, _c, _d, _e, _f, _g;
      const variantNodes = (_c = (_b2 = (_a4 = this.queryData) == null ? void 0 : _a4.product) == null ? void 0 : _b2.variants) == null ? void 0 : _c.nodes;
      if (!variantNodes) return null;
      const matchingNode = variantNodes.find(
        (node) => this.currentVariant.id == Number(parseGid(node.id))
      );
      const date = (_d = matchingNode == null ? void 0 : matchingNode.metafield) == null ? void 0 : _d.value;
      if (date) {
        return this.formatDate(date);
      }
      const productDate = (_g = (_f = (_e = this.queryData) == null ? void 0 : _e.product) == null ? void 0 : _f.metafield) == null ? void 0 : _g.value;
      if (productDate) {
        return this.formatDate(productDate);
      }
      return null;
    },
    init() {
      rebuyViewEvent(this.product.handle);
      this.getData();
      this.$watch("selectedOptions", async (options2) => {
        const matchingVariant = this.getVariantFromOptions(options2);
        this.currentVariant = matchingVariant;
        this.updating = true;
        const url = new URL(window.location.href);
        url.searchParams.set("variant", matchingVariant.id.toString());
        await updatePage(url);
        if (matchingVariant !== this.currentVariant) return;
        this.updating = false;
      });
      this.$watch(
        "product",
        () => this.currentVariant = this.selectedOrFirstAvailableVariant(
          this.currentVariant.options
        )
      );
    },
    async getData() {
      const response = await gqlFetch({
        query: productVariantsPreorderDates,
        variables: { pid: `gid://shopify/Product/${this.product.id}` }
      });
      const data2 = response == null ? void 0 : response.data;
      this.queryData = data2;
      return data2;
    },
    get variantDiscount() {
      if (this.onSale) {
        return "Save " + formatMoney2(
          this.currentVariant.compare_at_price - this.currentVariant.price
        );
      }
      return "";
    },
    formatDate(date) {
      const [year, month, day] = date.split("-").map(Number);
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      const monthStr = months[month - 1];
      return `${monthStr} ${day}, ${year}`;
    },
    get compareAtPrice() {
      const compareAtPrice = this.currentVariant.compare_at_price;
      return compareAtPrice ? formatMoney2(compareAtPrice) : "";
    },
    get onSale() {
      var _a4, _b2;
      return ((_a4 = this.currentVariant) == null ? void 0 : _a4.compare_at_price) > ((_b2 = this.currentVariant) == null ? void 0 : _b2.price);
    },
    get variantPrice() {
      return formatMoney2(this.currentVariant.price);
    },
    get variantAvailable() {
      return this.currentVariant.available;
    },
    get productMeta() {
      if (!this.currentVariant.available) {
        return {
          class: "bg-gray-400",
          text: "Sold out"
        };
      }
      if (this.currentVariant.discount) {
        return {
          class: "bg-red-400",
          text: "Save money"
        };
      }
      return null;
    },
    getVariantFromOptions(options2) {
      return this.product.variants.find(
        (variant) => variant.options.every(
          (option, index2) => option === options2[index2]
        )
      );
    },
    isOptionAvailable(index2, value) {
      var _a4, _b2;
      const optionsToCheck = [...this.currentVariant.options];
      optionsToCheck[index2] = value;
      return (_b2 = (_a4 = this.getVariantFromOptions(optionsToCheck)) == null ? void 0 : _a4.available) != null ? _b2 : false;
    },
    colorIsActive(id2) {
      return Number(id2) == this.product.id;
    },
    selectedOrFirstAvailableVariant(selectedOptions) {
      const selectedVariant = this.product.variants.find((variant) => {
        return selectedOptions.every(function(option, index2) {
          return variant.options[index2] === option;
        });
      });
      return selectedVariant || this.product.variants.find((variant) => variant.available);
    },
    async changeVariantProduct(href) {
      const url = new URL(href, window.location.href);
      this.updating = true;
      await updatePage(url);
      Object.assign(
        this,
        JSON.parse(document.querySelector("#product-info").textContent)
      );
      rebuyViewEvent(this.product.handle);
      this.updating = false;
    }
  }));
  var updatePage = async (url, ...selectors) => {
    if (url.href === window.location.href) return;
    history.replaceState(null, "", url.href);
    try {
      const response = await fetch(url);
      if (!response) throw new Error("No response");
      const html = await response.text();
      if (window.location.href !== url.href) return;
      if (window.okeWidgetApi) window.okeWidgetApi.initAllWidgets();
      morphNodes(html, ["main", "title", ...selectors]);
    } catch (e) {
      console.error(e);
    }
  };
  var parseProductJSON = () => {
    var _a4, _b2;
    return JSON.parse(
      (_b2 = (_a4 = document.querySelector("script#product-info")) == null ? void 0 : _a4.textContent) != null ? _b2 : "{}"
    );
  };

  // src/alpine/components/productCard.ts
  var productCard = (Alpine2) => {
    Alpine2.data("productCard", (variant) => ({
      variant,
      get image() {
        return this.variant.featuredImage;
      },
      get currentShade() {
        const { name, description, color } = this.variant;
        return { name, description, color };
      },
      get colorDisplay() {
        const { name, description } = this.variant;
        return `${name && `${name} - `}${description}`;
      },
      get queryString() {
        return `?variant=${this.variant.id}`;
      },
      setShade(variant2) {
        Object.assign(this, {
          variant: variant2
        });
      },
      get isOnSale() {
        var _a4;
        return this.variant.price < ((_a4 = this.variant.compare_at_price) != null ? _a4 : 0);
      },
      formatMoney: formatMoney2
    }));
  };

  // src/alpine/components/productVariantSelector.ts
  var productVariantSelector = (Alpine2) => Alpine2.data("variantSelector", (data2) => ({
    ...typeof data2 === "string" ? JSON.parse(data2) : data2 != null ? data2 : {},
    adding: false,
    quantity: 1,
    async addToCart(id2) {
      this.adding = true;
      await Alpine2.store("cart").addFromForm(id2);
      this.adding = false;
    },
    get compareAtPrice() {
      const compareAtPrice = this.currentVariant.compare_at_price;
      return compareAtPrice ? formatMoney2(compareAtPrice) : false;
    },
    get onSale() {
      var _a4, _b2;
      return ((_a4 = this.currentVariant) == null ? void 0 : _a4.compare_at_price) > ((_b2 = this.currentVariant) == null ? void 0 : _b2.price);
    },
    get variantPrice() {
      return formatMoney2(this.currentVariant.price);
    },
    get variantAvailable() {
      return this.currentVariant.available;
    },
    get currentVariant() {
      var _a4;
      return (_a4 = this.getVariantFromOptions(this.selectedOptions)) != null ? _a4 : {};
    },
    getVariantFromOptions(options2) {
      return this.product.variants.find(
        (variant) => variant.options.every(
          (option, index2) => option === options2[index2]
        )
      );
    },
    isOptionAvailable(index2, value) {
      var _a4, _b2, _c;
      const optionsToCheck = [...(_a4 = this.currentVariant.options) != null ? _a4 : []];
      optionsToCheck[index2] = value;
      return (_c = (_b2 = this.getVariantFromOptions(optionsToCheck)) == null ? void 0 : _b2.available) != null ? _c : false;
    }
  }));

  // src/alpine/components/rebuy.ts
  var rebuy = (Alpine2) => Alpine2.data(
    "rebuy",
    (endpoint = "top-sellers", customId, limit = 4, location2 = "unknown") => {
      const rebuy2 = rebuyClient(endpoint, customId);
      const rebuyTrackingProps = {
        _source: "Rebuy",
        _attribution: location2,
        _widget: endpoint
      };
      const effects = [];
      return {
        get data() {
          const itemIds = {
            shopify_product_ids: [],
            shopify_variant_ids: [],
            limit
          };
          for (const item of this.$store.cart.items) {
            itemIds.shopify_product_ids.push(item.product_id);
            itemIds.shopify_variant_ids.push(item.variant_id);
          }
          return itemIds;
        },
        results: [],
        chunkResults(chunkSize) {
          const results = [...this.results];
          const chunks = [];
          while (results.length) {
            chunks.push(results.splice(0, chunkSize));
          }
          return chunks;
        },
        addFromForm(formId) {
          this.$store.cart.addFromForm(formId);
        },
        init() {
          effects.push(
            Alpine2.effect(
              async () => this.results = (await rebuy2(this.data)).filter(
                (item) => item.image
              )
            )
          );
        },
        destroy() {
          effects.forEach(Alpine2.release);
        },
        async refetch() {
          this.results = (await rebuy2(this.data)).filter((item) => item.image);
        },
        getMetafield(item, namespace, key3) {
          var _a4;
          return (_a4 = item.metafields.find(
            (metafield) => metafield.namespace === namespace && metafield.key === key3
          )) == null ? void 0 : _a4.value;
        },
        getPriceDisplay(item, compareAt) {
          const price = Math.min(
            ...item.variants.map(
              (v) => Number(v[compareAt ? "compare_at_price" : "price"]) || Infinity
            )
          );
          if (price === Infinity) return;
          return formatMoney2(price * 100);
        },
        getOptionPosition(item, key3) {
          var _a4;
          return (_a4 = item.options.find(
            (o) => o.name.toLowerCase() === key3.toLowerCase()
          )) == null ? void 0 : _a4.position;
        },
        getOptions(item, key3) {
          var _a4, _b2;
          return (_b2 = (_a4 = item.options.find((o) => o.name.toLowerCase() === key3.toLowerCase())) == null ? void 0 : _a4.values) != null ? _b2 : [];
        },
        isAvailable(variant) {
          return variant.inventory_quantity > 0 || variant.inventory_policy !== "deny";
        },
        normalize(url) {
          const target = new URL(url);
          return new URL(target.pathname, window.location.origin).href;
        },
        addToCart(id2) {
          this.$store.cart.addItem({
            id: id2,
            quantity: 1,
            properties: rebuyTrackingProps
          });
        },
        viewItem(item) {
          for (const { id: id2 } of item.variants)
            sessionStorage.setItem(
              String(id2),
              JSON.stringify(rebuyTrackingProps)
            );
        }
      };
    }
  );

  // src/alpine/components/sampleDrawer.ts
  var sampleDrawer = (Alpine2) => {
    Alpine2.store("samplesOpen", false);
    Alpine2.data("sampleDrawer", () => ({
      get samples() {
        return Alpine2.store("cart").items.filter((item) => {
          var _a4;
          return (_a4 = item.properties) == null ? void 0 : _a4["_sample"];
        }).flatMap((item) => new Array(item.quantity).fill(item.id));
      },
      get isOpen() {
        return Alpine2.store("samplesOpen");
      },
      close() {
        Alpine2.store("samplesOpen", false);
      },
      get titleMessage() {
        var _a4;
        const count = this.samples.length;
        return (_a4 = ["Pick two samples", "Pick one more sample"][count]) != null ? _a4 : "Two Samples Selected";
      },
      isSelected(id2) {
        return this.samples.includes(id2);
      },
      chooseSample(id2) {
        if (!this.isSelected(id2))
          return Alpine2.store("cart").addItem({
            id: id2,
            quantity: 1,
            properties: { _sample: true }
          });
        const item = Alpine2.store("cart").items.find((item2) => item2.id === id2);
        if (!item) return;
        Alpine2.store("cart").removeItem(item.key);
      }
    }));
  };

  // src/utilities/cacheFetch.ts
  var cache = /* @__PURE__ */ new Map();
  var cacheFetch = async (url) => {
    const key3 = url.toString();
    if (cache.has(key3)) return cache.get(key3);
    const response = await fetch(url);
    cache.set(key3, await response.text());
    return cache.get(key3);
  };

  // src/alpine/components/search.ts
  var search = (Alpine2) => Alpine2.data("search", () => {
    return {
      resultProducts: [],
      formatMoney: formatMoney2,
      get searchTerm() {
        return this.$store.search.query;
      },
      init() {
        Alpine2.effect(this.doSearch.bind(this));
      },
      get searchUrl() {
        return this.$store.search.searchUrl;
      },
      get results() {
        if (this.resultProducts.length) return this.resultProducts;
      },
      get sectionLabel() {
        if (this.resultProducts.length) return `results`;
        return "";
      },
      async doSearch() {
        if (!this.searchTerm) return;
        const url = this.searchUrl;
        url.searchParams.set("view", "ajax-grid");
        const doc = await cacheFetch(url);
        morphNodes(doc, "#ajax-grid", false);
      },
      show() {
        this.$store.search.isOpen = true;
      },
      hide() {
        this.$store.search.isOpen = false;
      },
      fade: {
        "x-transition:enter": "transition-[top] duration-200",
        "x-transition:enter-start": "top-5",
        "x-transition:enter-end": "top-3",
        "x-transition:leave": "transition-[top] duration-200",
        "x-transition:leave-start": "top-3",
        "x-transition:leave-end": "top-5"
      }
    };
  });

  // src/utilities/nextTick.ts
  var nextTick2 = () => new Promise((res) => queueMicrotask(() => setTimeout(res, 0)));

  // src/utilities/wrapNumber.ts
  var wrapNumber = (num, max, min = 0) => (num - min) % (max - min) + min;

  // src/alpine/components/slider.ts
  var slider = (Alpine2) => Alpine2.data(
    "slider",
    ({
      scrollToDepth = 0,
      intoView = false,
      centerVertically = false,
      autoScroll = 0
    } = {}) => {
      const cleanups = [];
      return {
        focusedIndex: 0,
        focusedSize: 0,
        open: false,
        initialized: false,
        touched: false,
        init() {
          const keyHandler = (e) => {
            if (e.key === "Escape") return this.open = false;
            if (e.key === "ArrowLeft")
              this.focusedIndex = Math.max(0, this.focusedIndex - 1);
            if (e.key === "ArrowRight")
              this.focusedIndex = Math.min(
                this.$refs.galleryGrid.children.length - 1,
                this.focusedIndex + 1
              );
          };
          Alpine2.effect(
            () => document[this.open ? "addEventListener" : "removeEventListener"](
              "keydown",
              keyHandler
            )
          );
          if (autoScroll) {
            const autoScroller = setInterval(() => {
              if (this.touched) return clearInterval(autoScroller);
              this.scrollTo(
                wrapNumber(
                  this.focusedIndex + 1,
                  childrenSansPassthrough(this.$refs.galleryGrid).length
                )
              );
            }, autoScroll);
            cleanups.push(() => clearInterval(autoScroller));
          }
        },
        destroy() {
          cleanups.forEach((cleanup2) => cleanup2());
        },
        onLoad(target) {
          var _a4;
          if (this.initialized || isIMGElement(target) && !target.complete)
            return;
          this.focusedIndex = 0;
          this.focusedSize = ((_a4 = this.itemAtIndex(0)) == null ? void 0 : _a4.clientHeight) || 0;
          if (this.$refs.galleryGrid) this.$refs.galleryGrid.scrollLeft = 0;
          this.initialized = true;
        },
        handleIntersect(el) {
          if (!this.initialized) return;
          this.focusedIndex = this.indexOfItem(el);
          this.focusedSize = el.clientHeight;
        },
        itemAtIndex(idx) {
          var _a4;
          if (!this.$refs.galleryGrid) return;
          const children = childrenSansPassthrough(this.$refs.galleryGrid);
          let item = children[clampNumber(idx, 0, children.length)];
          if (item === void 0) return;
          for (let i = 0; i < scrollToDepth; i++)
            item = (_a4 = item == null ? void 0 : item.firstElementChild) != null ? _a4 : item;
          if (item == null ? void 0 : item.closest("template")) return this.itemAtIndex(idx + 1);
          return item;
        },
        indexOfItem(el) {
          const children = childrenSansPassthrough(this.$refs.galleryGrid);
          for (let i = 0; i < children.length; i++) {
            if (children[i].contains(el)) return i;
          }
        },
        isLast() {
          return this.focusedIndex === childrenSansPassthrough(this.$refs.galleryGrid).length - 1;
        },
        isFirst() {
          return this.focusedIndex === 0;
        },
        async scrollTo(target, offset = 0) {
          target = typeof target === "number" ? target | 0 : target;
          const el = target instanceof Element ? target : this.itemAtIndex(target);
          if (!el) return;
          if (!this.initialized) {
            this.initialized = true;
            await nextTick2();
          }
          if (typeof target === "number")
            this.focusedIndex += Math.sign(target - this.focusedIndex);
          window.scrollBy({
            top: 0.5
          });
          if (intoView)
            el.scrollIntoView({
              behavior: "smooth",
              block: centerVertically ? "center" : "nearest",
              inline: "center"
            });
          else
            this.$refs.galleryGrid.scrollLeft = target === 0 ? 0 : el.offsetLeft - offset;
          const thumbnails = this.$refs.thumbnails;
          if (!thumbnails || typeof target !== "number") return;
          const thumb = childrenSansPassthrough(thumbnails)[target];
          if (!thumb) return;
          thumbnails.scrollTo({
            top: thumb.offsetTop - (thumbnails.clientHeight - thumb.clientHeight) / 2,
            left: thumb.offsetLeft - (thumbnails.clientWidth - thumb.clientWidth) / 2,
            behavior: "smooth"
          });
        }
      };
    }
  );
  var isIMGElement = (el) => el instanceof HTMLImageElement;
  var childrenSansPassthrough = (el) => {
    return Array.prototype.flatMap.call(
      el.children,
      (child) => getComputedStyle(child).display === "contents" ? childrenSansPassthrough(child) : child
    ).filter(
      (node) => node.nodeName !== "TEMPLATE" && getComputedStyle(node).display !== "none"
    );
  };
  var clampNumber = (num, min, max) => Math.min(Math.max(num, min), max);

  // src/alpine/components/stickyScroll.ts
  var scrollPadding = 100;
  var stickyScroll = (Alpine2) => Alpine2.data("stickyScroll", () => {
    let height = 0;
    let lastPosition = 0;
    let raf;
    return {
      top: 0,
      init() {
        const resizeHandler = () => height = Math.max(
          0,
          this.$el.clientHeight - window.innerHeight + 2 * scrollPadding
        );
        new ResizeObserver(resizeHandler).observe(this.$el);
        window.addEventListener("resize", resizeHandler);
        const scrollHandler = this.onScroll.bind(this);
        const matches2 = window.matchMedia("(min-width: 1024px)");
        const toggleListener = (force = true) => window[force ? "addEventListener" : "removeEventListener"](
          "scroll",
          scrollHandler,
          { passive: true }
        );
        matches2.addEventListener(
          "change",
          (match) => toggleListener(match.matches)
        );
        toggleListener(matches2.matches);
      },
      get topString() {
        return `top: ${-1 * this.top + scrollPadding}px`;
      },
      onScroll() {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          this.updatePosition();
          raf = null;
        });
      },
      updatePosition() {
        const scrollTop = window.scrollY;
        const diff = scrollTop - lastPosition;
        this.top = Math.min(height, Math.max(0, this.top + diff));
        lastPosition = scrollTop;
      }
    };
  });

  // src/alpine/components/transitions.ts
  var transitions = (Alpine2) => {
    Alpine2.bind("slideTransition", () => ({
      "x-transition:enter": "transition ease-in-out duration-300 transform",
      "x-transition:enter-start": "-translate-x-full",
      "x-transition:enter-end": "translate-x-0",
      "x-transition:leave": "transition ease-in-out duration-300 transform",
      "x-transition:leave-start": "translate-x-0",
      "x-transition:leave-end": "-translate-x-full"
    }));
  };

  // src/utilities/queueBounce.ts
  var queueBounce = (fn) => {
    const queue2 = [];
    let running = false;
    const processQueue = async () => {
      running = true;
      while (queue2.length) {
        await queue2.shift()();
      }
      running = false;
    };
    return (...args) => {
      queue2[0] = () => fn.apply({}, args);
      if (!running) processQueue();
    };
  };

  // src/utilities/updateParams.ts
  var updateParams = (data2, firstRun2 = false) => {
    const url = new URL(window.location.href);
    url.search = new URLSearchParams(data2).toString();
    const samePage = url.toString() === window.location.href;
    const action = firstRun2 || samePage ? "replaceState" : "pushState";
    history[action](JSON.stringify(data2), "", url.toString());
    return url;
  };

  // src/utilities/updateAndReplace.ts
  var firstRun = true;
  var updateAndReplace = queueBounce(
    async (data2, options2 = {}) => {
      alpine_default2.store("isLoading").collection = true;
      const url = updateParams(data2, firstRun);
      if (options2.view) url.searchParams.set("view", options2.view);
      if (!firstRun && options2.selectors) {
        const doc = await cacheFetch(url);
        morphNodes(doc, options2.selectors, options2.fullSwap);
      }
      firstRun = false;
      alpine_default2.store("isLoading").collection = false;
    }
  );

  // src/alpine/components/unifiedFilters.ts
  var unifiedFilters = (Alpine2) => {
    Alpine2.data(
      "unifiedFilters",
      (replacementSelectors, view) => ({
        open: false,
        options: {
          sort_by: "",
          page: 1
        },
        clearFilters() {
          for (const type of Object.keys(this.options)) {
            const option = this.options[type];
            if (Array.isArray(option)) option.length = 0;
          }
        },
        changeOption(name, value, add2) {
          const selected = this.options[name];
          if (!Array.isArray(selected)) {
            if (add2) this.options[name] = value;
            else delete this.options[name];
            return;
          }
          const idx = selected.indexOf(value);
          if (add2 && idx !== -1 || !add2 && idx === -1) return;
          if (add2 && idx === -1) selected.push(value);
          else if (!add2 && idx !== -1) selected.splice(idx, 1);
          this.options.page = 1;
        },
        hasOption(name, value) {
          const selected = this.options[name];
          if (Array.isArray(selected)) return selected.includes(value);
          return selected === value;
        },
        async init() {
          await nextTick2();
          Alpine2.effect(() => this.updatePage());
        },
        updateFromHistory({ state }) {
          const parsed = state ? JSON.parse(state) : [];
          this.options = parsed.reduce((opts, [name, value]) => {
            var _a4;
            if (!isFilterKey(name)) opts[name] = value;
            else {
              (_a4 = opts[name]) != null ? _a4 : opts[name] = [];
              opts[name].push(value);
            }
            return opts;
          }, {});
        },
        updatePage(resetPage = false) {
          var _a4;
          const options2 = [];
          if ("q" in this.options && !this.options.q) return;
          for (const [name, values] of Object.entries(this.options))
            if (!name.includes("price"))
              options2.push(
                ...(Array.isArray(values) ? values : [values]).map((value) => [name, value]).filter(
                  ([name2, value]) => !(name2 === "sort_by" && value === "manual" || name2 === "page" && (resetPage || value === "1"))
                )
              );
          const [min, max] = ((_a4 = this.options["filter.v.price"]) != null ? _a4 : []).reduce(
            minMax,
            [Infinity, -Infinity]
          );
          if (min !== 0 && min !== Infinity)
            options2.push(["filter.v.price.gte", min.toString()]);
          if (max !== Infinity && max !== -Infinity)
            options2.push(["filter.v.price.lte", max.toString()]);
          const fullSwap = "q" in this.options && new URLSearchParams(window.location.search).get("q") !== this.options.q;
          return updateAndReplace(options2, {
            selectors: replacementSelectors,
            view,
            fullSwap
          });
        },
        get activeFilters() {
          return Object.entries(this.options).map(
            ([name, values]) => (Array.isArray(values) ? values : [values]).map(
              (value) => [name, value]
            )
          ).flat().filter(([name]) => !hiddenOptions2.includes(name));
        }
      })
    );
  };
  var hiddenOptions2 = ["sort_by", "page", "q", "type"];
  var minMax = (acc, range) => {
    const nums = range.match(/(\d+)/g).map(Number);
    if (nums.length < 2) {
      if (range.toLowerCase().includes("under")) nums.unshift(0);
      else if (range.toLowerCase().includes("over")) nums.push(Infinity);
      else nums.push(nums[0]);
    }
    acc[0] = Math.min(acc[0], nums[0]);
    acc[1] = Math.max(acc[1], nums[1]);
    return acc;
  };
  var isFilterKey = (key3) => key3.startsWith("filter.");

  // src/alpine/components/utilityComponents/merge.ts
  var merge = (Alpine2) => Alpine2.data(
    "merge",
    (...components) => {
      return components.reduce((acc, obj) => {
        Object.defineProperties(acc, Object.getOwnPropertyDescriptors(obj));
        return acc;
      }, {});
    }
  );

  // src/alpine/components/index.ts
  var Components = [
    addressSwitch,
    announcement,
    backInStock,
    cartDrawer,
    cartOptions,
    cartThreshold,
    header,
    mainProduct,
    meganav,
    merge,
    mobileMenu,
    productCard,
    productVariantSelector,
    rebuy,
    sampleDrawer,
    search,
    slider,
    stickyScroll,
    transitions,
    unifiedFilters
  ];

  // src/alpine/components/headless/animate.ts
  var animate = (Alpine2) => {
    const valueMap = {
      in: animateIn
    };
    const fallBack = (_, { value }) => console.error(`x-animate:${value} is not a valid animation type`);
    Alpine2.directive("animate", (el, directive2, utils) => {
      var _a4;
      ((_a4 = valueMap[directive2.value]) != null ? _a4 : fallBack)(
        el,
        directive2,
        utils
      );
    });
  };
  var animateIn = (el, { expression }, { Alpine: Alpine2, evaluate: evaluate2 }) => {
    const state = Alpine2.reactive({
      active: false
    });
    const classes = evaluate2(expression);
    Alpine2.bind(el, {
      ":class": () => state.active ? classes.active : classes.inactive,
      "x-intersect.enter": () => state.active = true
    });
  };

  // src/alpine/components/headless/matchingOverlay.ts
  var matchingOverlay = (Alpine2) => Alpine2.directive("match-overlay", (el, { expression, value }, utils) => {
    if (!expression)
      return console.warn("Match Overlay requires an expression");
    switch (value) {
      case "root":
        handleMatchRoot(
          el,
          expression,
          utils
        );
        break;
      case "target":
        handleMatchTarget(
          el,
          expression,
          utils
        );
        break;
    }
  });
  var overlayMap = /* @__PURE__ */ new Map();
  var handleMatchRoot = (el, expression, { cleanup: cleanup2, Alpine: Alpine2 }) => {
    if (overlayMap.has(expression))
      return console.error(
        "Match Overlay already exists for this expression:",
        expression,
        "\nPlease check that there are not multiple elements with the same expression"
      );
    const overlayData = Alpine2.reactive({ left: 0, top: 0, active: false });
    overlayMap.set(expression, overlayData);
    Alpine2.bind(el, {
      ":style": () => overlayData.active ? {
        top: `${overlayData.top}px`,
        visibility: "visible"
      } : { visibility: "hidden" }
    });
    cleanup2(() => overlayMap.delete(expression));
  };
  var handleMatchTarget = (el, expression, { Alpine: Alpine2 }) => Alpine2.bind(el, {
    "x-intersect.enter.threshold.60": () => {
      const overlayData = overlayMap.get(expression);
      if (!overlayData)
        return console.error(
          "No matching overlay data found for expression:",
          expression
        );
      Object.assign(overlayData, {
        top: el.offsetTop,
        active: true
      });
    },
    ":class": () => {
      var _a4;
      return {
        invisible: (_a4 = overlayMap.get(expression)) == null ? void 0 : _a4.active
      };
    }
  });

  // src/alpine/components/headless/slider/SliderCTX.ts
  var $slider = Symbol("$slider");
  var hasSlider = (ctx) => $slider in ctx;

  // src/alpine/components/headless/slider/SliderPart.ts
  var SliderPart = (part, el, directive2, { Alpine: Alpine2 }) => {
    const ctx = Alpine2.$data(el);
    if (hasSlider(ctx)) ctx[$slider].components.set(part, el);
    else
      console.error(
        `Element with ${directive2.original} needs to be inside an x-slider element`
      );
  };

  // src/utilities/as.ts
  var as = (struct, item) => item instanceof struct ? item : null;

  // src/utilities/clampNumber.ts
  var clampNumber2 = (num, max, min = 0) => Math.min(Math.max(num, min), max);

  // src/alpine/components/headless/slider/childrenSansPassthrough.ts
  var childrenSansPassthrough2 = (el) => {
    return Array.from(el.children).flatMap(
      (child) => getComputedStyle(child).display === "contents" ? childrenSansPassthrough2(child) : child
    ).filter(
      (node) => node.nodeName !== "TEMPLATE" && getComputedStyle(node).display !== "none"
    );
  };

  // src/alpine/components/headless/slider/utils/isIMGElement.ts
  var isIMGElement2 = (el) => el instanceof HTMLImageElement;

  // src/alpine/components/headless/slider/SliderRoot.ts
  var SliderRoot = (el, { expression }, { evaluate: evaluate2, cleanup: cleanup2, Alpine: Alpine2 }) => {
    const cleanups = [];
    cleanup2(() => cleanups.forEach((cleanup3) => cleanup3()));
    const opts = Object.assign(
      {
        scrollToDepth: 0,
        intoView: false,
        centerVertically: false,
        autoScroll: 0
      },
      expression ? evaluate2(expression) : {}
    );
    const ctx = Alpine2.reactive({
      focusedIndex: 0,
      focusedSize: 0,
      initialized: false,
      touched: false,
      components: /* @__PURE__ */ new Map(),
      init() {
        if (opts.autoScroll) {
          const autoScroller = setInterval(() => {
            if (this.touched) return clearInterval(autoScroller);
            const gallery = this.components.get("gallery");
            if (!gallery) return;
            this.scrollTo(
              wrapNumber(
                this.focusedIndex + 1,
                childrenSansPassthrough2(gallery).length
              )
            );
          }, opts.autoScroll);
          cleanups.push(() => clearInterval(autoScroller));
        }
      },
      onLoad(target) {
        var _a4;
        if (this.initialized || isIMGElement2(target) && !target.complete)
          return;
        this.focusedIndex = 0;
        this.focusedSize = ((_a4 = this.itemAtIndex(0)) == null ? void 0 : _a4.clientHeight) || 0;
        const gallery = this.components.get("gallery");
        if (gallery) gallery.scrollLeft = 0;
        this.initialized = true;
      },
      handleIntersect(el2) {
        var _a4;
        if (!this.initialized) return;
        this.focusedIndex = (_a4 = this.indexOfItem(el2)) != null ? _a4 : 0;
        this.focusedSize = el2.clientHeight;
      },
      itemAtIndex(idx) {
        var _a4;
        const gallery = this.components.get("gallery");
        if (!gallery) return;
        const children = childrenSansPassthrough2(gallery);
        let item = children[clampNumber2(idx, children.length)];
        if (item === void 0) return;
        for (let i = 0; i < opts.scrollToDepth; i++)
          item = (_a4 = item == null ? void 0 : item.firstElementChild) != null ? _a4 : item;
        if (item == null ? void 0 : item.closest("template")) return this.itemAtIndex(idx + 1);
        return item;
      },
      indexOfItem(el2) {
        const gallery = this.components.get("gallery");
        if (!gallery) return;
        const children = childrenSansPassthrough2(gallery);
        for (let i = 0; i < children.length; i++) {
          if (children[i].contains(el2)) return i;
        }
      },
      async scrollTo(target, offset = 0) {
        var _a4, _b2, _c;
        const gallery = this.components.get("gallery");
        if (!gallery) return;
        const el2 = target instanceof Element ? target : this.itemAtIndex(target);
        if (!el2) return;
        const idx = typeof target === "number" ? target : (_a4 = this.indexOfItem(el2)) != null ? _a4 : this.focusedIndex;
        if (!this.initialized) {
          this.initialized = true;
          await nextTick2();
        }
        this.focusedIndex += Math.sign(idx - this.focusedIndex);
        window.scrollBy({
          top: 0.5
        });
        if (opts.intoView)
          el2.scrollIntoView({
            behavior: "smooth",
            block: opts.centerVertically ? "center" : "nearest",
            inline: "center"
          });
        else
          gallery.scrollLeft = target === 0 ? 0 : ((_c = (_b2 = as(HTMLElement, el2)) == null ? void 0 : _b2.offsetLeft) != null ? _c : 0) - offset;
        const thumbnails = this.components.get("thumbnails");
        if (!thumbnails) return;
        const thumb = as(HTMLElement, thumbnails.children[idx]);
        if (!thumb) return;
        thumbnails.scrollTo({
          top: thumb.offsetTop - (thumbnails.clientHeight - thumb.clientHeight) / 2,
          left: thumb.offsetLeft - (thumbnails.clientWidth - thumb.clientWidth) / 2,
          behavior: "smooth"
        });
      },
      get isFirst() {
        return this.focusedIndex === 0;
      },
      get isLast() {
        const gallery = this.components.get("gallery");
        if (!gallery) return true;
        return this.focusedIndex === childrenSansPassthrough2(gallery).length - 1;
      },
      next() {
        this.scrollTo(this.focusedIndex + 1);
      },
      prev() {
        this.scrollTo(this.focusedIndex - 1);
      }
    });
    Alpine2.addScopeToNode(el, { [$slider]: ctx });
  };

  // src/alpine/components/headless/slider/bindings/button.ts
  var nextButton = {
    [":disabled"]() {
      return this[$slider].isLast;
    },
    "x-on:click"() {
      this[$slider].next();
    }
  };
  var prevButton = {
    [":disabled"]() {
      return this[$slider].isFirst;
    },
    "x-on:click"() {
      this[$slider].prev();
    }
  };
  var goTo = (idx) => ({
    [":disabled"]() {
      return this[$slider].focusedIndex === idx;
    },
    "x-on:click"() {
      this[$slider].scrollTo(idx);
    }
  });

  // src/alpine/components/headless/slider/bindings/dynamicHeight.ts
  var dynamicHeight = {
    [":style"]() {
      const height = this[$slider].focusedSize;
      return {
        maxHeight: height ? `${height}px` : "max-content",
        transition: "max-height 300ms"
      };
    }
  };

  // src/alpine/components/headless/slider/bindings/sliderItem.ts
  var sliderItem = (first = false) => ({
    "x-intersect.margin.10%.-49%"() {
      const slider2 = this[$slider];
      slider2.handleIntersect(this.$el);
    },
    "x-init"() {
      if (!first) return;
      const slider2 = this[$slider];
      slider2.onLoad(this.$el);
    },
    "x-on:load"() {
      const slider2 = this[$slider];
      slider2.onLoad(this.$el);
    }
  });

  // src/alpine/components/headless/slider/index.ts
  var Slider = (Alpine2) => {
    Alpine2.directive("slider", (el, directive2, utilities) => {
      if (!directive2.value || directive2.value === "root")
        return SliderRoot(el, directive2, utilities);
      if (directive2.value === "gallery" || directive2.value === "thumbnails") {
        SliderPart(directive2.value, el, directive2, utilities);
      }
    });
    Alpine2.magic("slider", (el) => {
      const ctx = Alpine2.$data(el);
      if (hasSlider(ctx)) return ctx[$slider];
    });
    Alpine2.bind("$sliderDynamicHeight", dynamicHeight);
    Alpine2.bind("$sliderItem", sliderItem);
    Alpine2.bind("$sliderNext", nextButton);
    Alpine2.bind("$sliderPrev", prevButton);
    Alpine2.bind("$sliderGoTo", goTo);
  };

  // src/alpine/components/headless/virtualize.ts
  var virtualize = (Alpine2) => {
    Alpine2.directive("virtualize", (el, _, { cleanup: cleanup2 }) => {
      const children = el.children;
      let timeout = null;
      let running = false;
      const handler4 = () => {
        if (timeout) clearTimeout(timeout);
        if (running) return;
        timeout = setTimeout(() => {
          if (timeout) clearTimeout(timeout);
          timeout = setTimeout(virtualizationHandler, 150);
        }, 0);
      };
      let direction = 1 /* right */;
      const virtualizationHandler = () => {
        var _a4;
        if (el.clientWidth >= el.scrollWidth) return;
        const [firstIndex, lastIndex, imbalance] = getListBalance(
          children,
          direction
        );
        if (Math.abs(imbalance) <= 1) return;
        running = true;
        const mostMiddleElement = getMostMiddleElement(
          children,
          firstIndex,
          lastIndex
        );
        const currentOffset = mostMiddleElement.getBoundingClientRect().left;
        disableSmoothScroll(el);
        direction = (_a4 = balanceElements(el, imbalance)) != null ? _a4 : direction;
        const scrollChange = mostMiddleElement.getBoundingClientRect().left - currentOffset | 0;
        el.scrollBy(scrollChange, 0);
        Alpine2.nextTick(() => {
          running = false;
          dispatchViews(el);
        });
      };
      el.addEventListener("scroll", handler4, { passive: true });
      cleanup2(() => el.removeEventListener("scroll", handler4));
      const amountOutside = Array.prototype.reduce.call(
        el.children,
        (acc, el2) => acc + Number(!isInView(el2)),
        0
      );
      if (amountOutside === 0) return;
      if (amountOutside < 3)
        Alpine2.nextTick(
          () => el.prepend(
            ...Array.prototype.map.call(
              el.children,
              (el2) => el2.cloneNode(true)
            )
          )
        );
    });
    const disableSmoothScroll = (el) => {
      el.style.scrollBehavior = "auto";
      Alpine2.nextTick(() => el.style.scrollBehavior = null);
    };
  };
  var getListBalance = (children, offset) => {
    const firstInView = findIndex.call(children, isInView);
    const lastInView = findLastIndex.call(children, isInView);
    const imbalance = firstInView === -1 || lastInView < firstInView ? 0 : firstInView - (children.length - lastInView - 1) + offset;
    return [firstInView, lastInView, imbalance];
  };
  var getMostMiddleElement = (children, firstIndex, lastIndex) => {
    const mostMiddleIndex = (firstIndex + lastIndex) / 2 | 0;
    return children[mostMiddleIndex];
  };
  var balanceElements = (el, imbalance) => {
    const children = el.children;
    if (Math.abs(imbalance) <= 1) return null;
    if (imbalance < 1) {
      el.prepend(children[children.length - 1]);
      return -1 /* left */;
    } else {
      el.append(children[0]);
      return 1 /* right */;
    }
  };
  var isInView = (el) => {
    const rect = el.getBoundingClientRect();
    const vpWidth = document.documentElement.scrollWidth;
    const vpHeight = document.documentElement.scrollHeight;
    const above = rect.bottom - 10 <= 0;
    const below = rect.top - vpHeight + 10 >= 0;
    const left = rect.right - 10 <= 0;
    const right = rect.left - vpWidth + 10 >= 0;
    return !above && !below && !left && !right;
  };
  var dispatchViews = (el) => Array.prototype.forEach.call(
    el.children,
    (el2) => el2.dispatchEvent(
      new Event(isInView(el2) ? "virtualize:visible" : "virtualize:hidden")
    )
  );
  var findIndex = Array.prototype.findIndex;
  function findLastIndex(predicate) {
    for (let i = this.length - 1; i >= 0; i--) if (predicate(this[i])) return i;
    return -1;
  }

  // src/alpine/components/headless/index.ts
  var Headless = [animate, matchingOverlay, Slider, virtualize];

  // node_modules/.pnpm/@alpinejs+collapse@3.14.9/node_modules/@alpinejs/collapse/dist/module.esm.js
  function src_default2(Alpine2) {
    Alpine2.directive("collapse", collapse);
    collapse.inline = (el, { modifiers }) => {
      if (!modifiers.includes("min"))
        return;
      el._x_doShow = () => {
      };
      el._x_doHide = () => {
      };
    };
    function collapse(el, { modifiers }) {
      let duration = modifierValue2(modifiers, "duration", 250) / 1e3;
      let floor = modifierValue2(modifiers, "min", 0);
      let fullyHide = !modifiers.includes("min");
      if (!el._x_isShown)
        el.style.height = `${floor}px`;
      if (!el._x_isShown && fullyHide)
        el.hidden = true;
      if (!el._x_isShown)
        el.style.overflow = "hidden";
      let setFunction = (el2, styles) => {
        let revertFunction = Alpine2.setStyles(el2, styles);
        return styles.height ? () => {
        } : revertFunction;
      };
      let transitionStyles = {
        transitionProperty: "height",
        transitionDuration: `${duration}s`,
        transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
      };
      el._x_transition = {
        in(before = () => {
        }, after = () => {
        }) {
          if (fullyHide)
            el.hidden = false;
          if (fullyHide)
            el.style.display = null;
          let current = el.getBoundingClientRect().height;
          el.style.height = "auto";
          let full = el.getBoundingClientRect().height;
          if (current === full) {
            current = floor;
          }
          Alpine2.transition(el, Alpine2.setStyles, {
            during: transitionStyles,
            start: { height: current + "px" },
            end: { height: full + "px" }
          }, () => el._x_isShown = true, () => {
            if (Math.abs(el.getBoundingClientRect().height - full) < 1) {
              el.style.overflow = null;
            }
          });
        },
        out(before = () => {
        }, after = () => {
        }) {
          let full = el.getBoundingClientRect().height;
          Alpine2.transition(el, setFunction, {
            during: transitionStyles,
            start: { height: full + "px" },
            end: { height: floor + "px" }
          }, () => el.style.overflow = "hidden", () => {
            el._x_isShown = false;
            if (el.style.height == `${floor}px` && fullyHide) {
              el.style.display = "none";
              el.hidden = true;
            }
          });
        }
      };
    }
  }
  function modifierValue2(modifiers, key3, fallback) {
    if (modifiers.indexOf(key3) === -1)
      return fallback;
    const rawValue = modifiers[modifiers.indexOf(key3) + 1];
    if (!rawValue)
      return fallback;
    if (key3 === "duration") {
      let match = rawValue.match(/([0-9]+)ms/);
      if (match)
        return match[1];
    }
    if (key3 === "min") {
      let match = rawValue.match(/([0-9]+)px/);
      if (match)
        return match[1];
    }
    return rawValue;
  }
  var module_default2 = src_default2;

  // node_modules/.pnpm/@alpinejs+focus@3.14.9/node_modules/@alpinejs/focus/dist/module.esm.js
  var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"];
  var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
  var NoElement = typeof Element === "undefined";
  var matches = NoElement ? function() {
  } : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    return element.getRootNode();
  } : function(element) {
    return element.ownerDocument;
  };
  var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }
    candidates = candidates.filter(filter);
    return candidates;
  };
  var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options2) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while (elementsToCheck.length) {
      var element = elementsToCheck.shift();
      if (element.tagName === "SLOT") {
        var assigned = element.assignedElements();
        var content = assigned.length ? assigned : element.children;
        var nestedCandidates = getCandidatesIteratively2(content, true, options2);
        if (options2.flatten) {
          candidates.push.apply(candidates, nestedCandidates);
        } else {
          candidates.push({
            scope: element,
            candidates: nestedCandidates
          });
        }
      } else {
        var validCandidate = matches.call(element, candidateSelector);
        if (validCandidate && options2.filter(element) && (includeContainer || !elements.includes(element))) {
          candidates.push(element);
        }
        var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
        typeof options2.getShadowRoot === "function" && options2.getShadowRoot(element);
        var validShadowRoot = !options2.shadowRootFilter || options2.shadowRootFilter(element);
        if (shadowRoot && validShadowRoot) {
          var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options2);
          if (options2.flatten) {
            candidates.push.apply(candidates, _nestedCandidates);
          } else {
            candidates.push({
              scope: element,
              candidates: _nestedCandidates
            });
          }
        } else {
          elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
      }
    }
    return candidates;
  };
  var getTabindex = function getTabindex2(node, isScope) {
    if (node.tabIndex < 0) {
      if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) {
        return 0;
      }
    }
    return node.tabIndex;
  };
  var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  };
  var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
  };
  var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
  };
  var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
      return child.tagName === "SUMMARY";
    });
    return r;
  };
  var getCheckedRadio = function getCheckedRadio2(nodes, form2) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form2) {
        return nodes[i];
      }
    }
  };
  var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) {
      return true;
    }
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios2(name) {
      return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
      radioSet = queryRadios(window.CSS.escape(node.name));
    } else {
      try {
        radioSet = queryRadios(node.name);
      } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
      }
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  };
  var isRadio2 = function isRadio22(node) {
    return isInput(node) && node.type === "radio";
  };
  var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio2(node) && !isTabbableRadio(node);
  };
  var isZeroArea = function isZeroArea2(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
  };
  var isHidden = function isHidden2(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (getComputedStyle(node).visibility === "hidden") {
      return true;
    }
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
      return true;
    }
    var nodeRootHost = getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
    if (!displayCheck || displayCheck === "full") {
      if (typeof getShadowRoot === "function") {
        var originalNode = node;
        while (node) {
          var parentElement = node.parentElement;
          var rootNode = getRootNode(node);
          if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
            return isZeroArea(node);
          } else if (node.assignedSlot) {
            node = node.assignedSlot;
          } else if (!parentElement && rootNode !== node.ownerDocument) {
            node = rootNode.host;
          } else {
            node = parentElement;
          }
        }
        node = originalNode;
      }
      if (nodeIsAttached) {
        return !node.getClientRects().length;
      }
    } else if (displayCheck === "non-zero-area") {
      return isZeroArea(node);
    }
    return false;
  };
  var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
      var parentNode = node.parentElement;
      while (parentNode) {
        if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
          for (var i = 0; i < parentNode.children.length; i++) {
            var child = parentNode.children.item(i);
            if (child.tagName === "LEGEND") {
              return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
            }
          }
          return true;
        }
        parentNode = parentNode.parentElement;
      }
    }
    return false;
  };
  var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options2, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options2) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
      return false;
    }
    return true;
  };
  var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options2, node) {
    if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options2, node)) {
      return false;
    }
    return true;
  };
  var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) {
      return true;
    }
    return false;
  };
  var sortByOrder = function sortByOrder2(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
      var isScope = !!item.scope;
      var element = isScope ? item.scope : item;
      var candidateTabindex = getTabindex(element, isScope);
      var elements = isScope ? sortByOrder2(item.candidates) : element;
      if (candidateTabindex === 0) {
        isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          item,
          isScope,
          content: elements
        });
      }
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
      sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
      return acc;
    }, []).concat(regularTabbables);
  };
  var tabbable = function tabbable2(el, options2) {
    options2 = options2 || {};
    var candidates;
    if (options2.getShadowRoot) {
      candidates = getCandidatesIteratively([el], options2.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options2),
        flatten: false,
        getShadowRoot: options2.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
      });
    } else {
      candidates = getCandidates(el, options2.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options2));
    }
    return sortByOrder(candidates);
  };
  var focusable = function focusable2(el, options2) {
    options2 = options2 || {};
    var candidates;
    if (options2.getShadowRoot) {
      candidates = getCandidatesIteratively([el], options2.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options2),
        flatten: true,
        getShadowRoot: options2.getShadowRoot
      });
    } else {
      candidates = getCandidates(el, options2.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options2));
    }
    return candidates;
  };
  var isTabbable = function isTabbable2(node, options2) {
    options2 = options2 || {};
    if (!node) {
      throw new Error("No node provided");
    }
    if (matches.call(node, candidateSelector) === false) {
      return false;
    }
    return isNodeMatchingSelectorTabbable(options2, node);
  };
  var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
  var isFocusable = function isFocusable2(node, options2) {
    options2 = options2 || {};
    if (!node) {
      throw new Error("No node provided");
    }
    if (matches.call(node, focusableCandidateSelector) === false) {
      return false;
    }
    return isNodeMatchingSelectorFocusable(options2, node);
  };
  function ownKeys2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys2(Object(source), true).forEach(function(key3) {
        _defineProperty(target, key3, source[key3]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key3) {
        Object.defineProperty(target, key3, Object.getOwnPropertyDescriptor(source, key3));
      });
    }
    return target;
  }
  function _defineProperty(obj, key3, value) {
    if (key3 in obj) {
      Object.defineProperty(obj, key3, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key3] = value;
    }
    return obj;
  }
  var activeFocusTraps = /* @__PURE__ */ function() {
    var trapQueue = [];
    return {
      activateTrap: function activateTrap(trap) {
        if (trapQueue.length > 0) {
          var activeTrap = trapQueue[trapQueue.length - 1];
          if (activeTrap !== trap) {
            activeTrap.pause();
          }
        }
        var trapIndex = trapQueue.indexOf(trap);
        if (trapIndex === -1) {
          trapQueue.push(trap);
        } else {
          trapQueue.splice(trapIndex, 1);
          trapQueue.push(trap);
        }
      },
      deactivateTrap: function deactivateTrap(trap) {
        var trapIndex = trapQueue.indexOf(trap);
        if (trapIndex !== -1) {
          trapQueue.splice(trapIndex, 1);
        }
        if (trapQueue.length > 0) {
          trapQueue[trapQueue.length - 1].unpause();
        }
      }
    };
  }();
  var isSelectableInput = function isSelectableInput2(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
  };
  var isEscapeEvent = function isEscapeEvent2(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
  };
  var isTabEvent = function isTabEvent2(e) {
    return e.key === "Tab" || e.keyCode === 9;
  };
  var delay = function delay2(fn) {
    return setTimeout(fn, 0);
  };
  var findIndex2 = function findIndex22(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
      if (fn(value)) {
        idx = i;
        return false;
      }
      return true;
    });
    return idx;
  };
  var valueOrHandler = function valueOrHandler2(value) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    return typeof value === "function" ? value.apply(void 0, params) : value;
  };
  var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
  };
  var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = _objectSpread2({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true
    }, userOptions);
    var state = {
      // containers given to createFocusTrap()
      // @type {Array<HTMLElement>}
      containers: [],
      // list of objects identifying tabbable nodes in `containers` in the trap
      // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
      //  is active, but the trap should never get to a state where there isn't at least one group
      //  with at least one tabbable node in it (that would lead to an error condition that would
      //  result in an error being thrown)
      // @type {Array<{
      //   container: HTMLElement,
      //   tabbableNodes: Array<HTMLElement>, // empty if none
      //   focusableNodes: Array<HTMLElement>, // empty if none
      //   firstTabbableNode: HTMLElement|null,
      //   lastTabbableNode: HTMLElement|null,
      //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
      // }>}
      containerGroups: [],
      // same order/length as `containers` list
      // references to objects in `containerGroups`, but only those that actually have
      //  tabbable nodes in them
      // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
      //  the same length
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false,
      // timer ID for when delayInitialFocus is true and initial focus in this trap
      //  has been delayed during activation
      delayInitialFocusTimer: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
      return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var findContainerIndex = function findContainerIndex2(element) {
      return state.containerGroups.findIndex(function(_ref) {
        var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
        return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
        //  web components if the `tabbableOptions.getShadowRoot` option was used for
        //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
        //  look inside web components even if open)
        tabbableNodes.find(function(node) {
          return node === element;
        });
      });
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
      var optionValue = config[optionName];
      if (typeof optionValue === "function") {
        for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          params[_key2 - 1] = arguments[_key2];
        }
        optionValue = optionValue.apply(void 0, params);
      }
      if (optionValue === true) {
        optionValue = void 0;
      }
      if (!optionValue) {
        if (optionValue === void 0 || optionValue === false) {
          return optionValue;
        }
        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
      }
      var node = optionValue;
      if (typeof optionValue === "string") {
        node = doc.querySelector(optionValue);
        if (!node) {
          throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
      }
      return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
      var node = getNodeForOption("initialFocus");
      if (node === false) {
        return false;
      }
      if (node === void 0) {
        if (findContainerIndex(doc.activeElement) >= 0) {
          node = doc.activeElement;
        } else {
          var firstTabbableGroup = state.tabbableGroups[0];
          var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
          node = firstTabbableNode || getNodeForOption("fallbackFocus");
        }
      }
      if (!node) {
        throw new Error("Your focus-trap needs to have at least one focusable element");
      }
      return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
      state.containerGroups = state.containers.map(function(container) {
        var tabbableNodes = tabbable(container, config.tabbableOptions);
        var focusableNodes = focusable(container, config.tabbableOptions);
        return {
          container,
          tabbableNodes,
          focusableNodes,
          firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
          lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
          /**
           * Finds the __tabbable__ node that follows the given node in the specified direction,
           *  in this container, if any.
           * @param {HTMLElement} node
           * @param {boolean} [forward] True if going in forward tab order; false if going
           *  in reverse.
           * @returns {HTMLElement|undefined} The next tabbable node, if any.
           */
          nextTabbableNode: function nextTabbableNode(node) {
            var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var nodeIdx = focusableNodes.findIndex(function(n) {
              return n === node;
            });
            if (nodeIdx < 0) {
              return void 0;
            }
            if (forward) {
              return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                return isTabbable(n, config.tabbableOptions);
              });
            }
            return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }
        };
      });
      state.tabbableGroups = state.containerGroups.filter(function(group) {
        return group.tabbableNodes.length > 0;
      });
      if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
        throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
      }
    };
    var tryFocus = function tryFocus2(node) {
      if (node === false) {
        return;
      }
      if (node === doc.activeElement) {
        return;
      }
      if (!node || !node.focus) {
        tryFocus2(getInitialFocusNode());
        return;
      }
      node.focus({
        preventScroll: !!config.preventScroll
      });
      state.mostRecentlyFocusedNode = node;
      if (isSelectableInput(node)) {
        node.select();
      }
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
      var node = getNodeForOption("setReturnFocus", previousActiveElement);
      return node ? node : node === false ? false : previousActiveElement;
    };
    var checkPointerDown = function checkPointerDown2(e) {
      var target = getActualTarget(e);
      if (findContainerIndex(target) >= 0) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        trap.deactivate({
          // if, on deactivation, we should return focus to the node originally-focused
          //  when the trap was activated (or the configured `setReturnFocus` node),
          //  then assume it's also OK to return focus to the outside node that was
          //  just clicked, causing deactivation, as long as that node is focusable;
          //  if it isn't focusable, then return focus to the original node focused
          //  on activation (or the configured `setReturnFocus` node)
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked, whether it's focusable or not; by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node)
          returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
        });
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(e) {
      var target = getActualTarget(e);
      var targetContained = findContainerIndex(target) >= 0;
      if (targetContained || target instanceof Document) {
        if (targetContained) {
          state.mostRecentlyFocusedNode = target;
        }
      } else {
        e.stopImmediatePropagation();
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    };
    var checkTab = function checkTab2(e) {
      var target = getActualTarget(e);
      updateTabbableNodes();
      var destinationNode = null;
      if (state.tabbableGroups.length > 0) {
        var containerIndex = findContainerIndex(target);
        var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
        if (containerIndex < 0) {
          if (e.shiftKey) {
            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
          } else {
            destinationNode = state.tabbableGroups[0].firstTabbableNode;
          }
        } else if (e.shiftKey) {
          var startOfGroupIndex = findIndex2(state.tabbableGroups, function(_ref2) {
            var firstTabbableNode = _ref2.firstTabbableNode;
            return target === firstTabbableNode;
          });
          if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
            startOfGroupIndex = containerIndex;
          }
          if (startOfGroupIndex >= 0) {
            var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
            var destinationGroup = state.tabbableGroups[destinationGroupIndex];
            destinationNode = destinationGroup.lastTabbableNode;
          }
        } else {
          var lastOfGroupIndex = findIndex2(state.tabbableGroups, function(_ref3) {
            var lastTabbableNode = _ref3.lastTabbableNode;
            return target === lastTabbableNode;
          });
          if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
            lastOfGroupIndex = containerIndex;
          }
          if (lastOfGroupIndex >= 0) {
            var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
            var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
            destinationNode = _destinationGroup.firstTabbableNode;
          }
        }
      } else {
        destinationNode = getNodeForOption("fallbackFocus");
      }
      if (destinationNode) {
        e.preventDefault();
        tryFocus(destinationNode);
      }
    };
    var checkKey = function checkKey2(e) {
      if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
        e.preventDefault();
        trap.deactivate();
        return;
      }
      if (isTabEvent(e)) {
        checkTab(e);
        return;
      }
    };
    var checkClick = function checkClick2(e) {
      var target = getActualTarget(e);
      if (findContainerIndex(target) >= 0) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
      if (!state.active) {
        return;
      }
      activeFocusTraps.activateTrap(trap);
      state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
        tryFocus(getInitialFocusNode());
      }) : tryFocus(getInitialFocusNode());
      doc.addEventListener("focusin", checkFocusIn, true);
      doc.addEventListener("mousedown", checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener("touchstart", checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener("click", checkClick, {
        capture: true,
        passive: false
      });
      doc.addEventListener("keydown", checkKey, {
        capture: true,
        passive: false
      });
      return trap;
    };
    var removeListeners = function removeListeners2() {
      if (!state.active) {
        return;
      }
      doc.removeEventListener("focusin", checkFocusIn, true);
      doc.removeEventListener("mousedown", checkPointerDown, true);
      doc.removeEventListener("touchstart", checkPointerDown, true);
      doc.removeEventListener("click", checkClick, true);
      doc.removeEventListener("keydown", checkKey, true);
      return trap;
    };
    trap = {
      get active() {
        return state.active;
      },
      get paused() {
        return state.paused;
      },
      activate: function activate(activateOptions) {
        if (state.active) {
          return this;
        }
        var onActivate = getOption(activateOptions, "onActivate");
        var onPostActivate = getOption(activateOptions, "onPostActivate");
        var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
        if (!checkCanFocusTrap) {
          updateTabbableNodes();
        }
        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;
        if (onActivate) {
          onActivate();
        }
        var finishActivation = function finishActivation2() {
          if (checkCanFocusTrap) {
            updateTabbableNodes();
          }
          addListeners();
          if (onPostActivate) {
            onPostActivate();
          }
        };
        if (checkCanFocusTrap) {
          checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
          return this;
        }
        finishActivation();
        return this;
      },
      deactivate: function deactivate(deactivateOptions) {
        if (!state.active) {
          return this;
        }
        var options2 = _objectSpread2({
          onDeactivate: config.onDeactivate,
          onPostDeactivate: config.onPostDeactivate,
          checkCanReturnFocus: config.checkCanReturnFocus
        }, deactivateOptions);
        clearTimeout(state.delayInitialFocusTimer);
        state.delayInitialFocusTimer = void 0;
        removeListeners();
        state.active = false;
        state.paused = false;
        activeFocusTraps.deactivateTrap(trap);
        var onDeactivate = getOption(options2, "onDeactivate");
        var onPostDeactivate = getOption(options2, "onPostDeactivate");
        var checkCanReturnFocus = getOption(options2, "checkCanReturnFocus");
        var returnFocus = getOption(options2, "returnFocus", "returnFocusOnDeactivate");
        if (onDeactivate) {
          onDeactivate();
        }
        var finishDeactivation = function finishDeactivation2() {
          delay(function() {
            if (returnFocus) {
              tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
            }
            if (onPostDeactivate) {
              onPostDeactivate();
            }
          });
        };
        if (returnFocus && checkCanReturnFocus) {
          checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
          return this;
        }
        finishDeactivation();
        return this;
      },
      pause: function pause() {
        if (state.paused || !state.active) {
          return this;
        }
        state.paused = true;
        removeListeners();
        return this;
      },
      unpause: function unpause() {
        if (!state.paused || !state.active) {
          return this;
        }
        state.paused = false;
        updateTabbableNodes();
        addListeners();
        return this;
      },
      updateContainerElements: function updateContainerElements(containerElements) {
        var elementsAsArray = [].concat(containerElements).filter(Boolean);
        state.containers = elementsAsArray.map(function(element) {
          return typeof element === "string" ? doc.querySelector(element) : element;
        });
        if (state.active) {
          updateTabbableNodes();
        }
        return this;
      }
    };
    trap.updateContainerElements(elements);
    return trap;
  };
  function src_default3(Alpine2) {
    let lastFocused;
    let currentFocused;
    window.addEventListener("focusin", () => {
      lastFocused = currentFocused;
      currentFocused = document.activeElement;
    });
    Alpine2.magic("focus", (el) => {
      let within = el;
      return {
        __noscroll: false,
        __wrapAround: false,
        within(el2) {
          within = el2;
          return this;
        },
        withoutScrolling() {
          this.__noscroll = true;
          return this;
        },
        noscroll() {
          this.__noscroll = true;
          return this;
        },
        withWrapAround() {
          this.__wrapAround = true;
          return this;
        },
        wrap() {
          return this.withWrapAround();
        },
        focusable(el2) {
          return isFocusable(el2);
        },
        previouslyFocused() {
          return lastFocused;
        },
        lastFocused() {
          return lastFocused;
        },
        focused() {
          return currentFocused;
        },
        focusables() {
          if (Array.isArray(within))
            return within;
          return focusable(within, { displayCheck: "none" });
        },
        all() {
          return this.focusables();
        },
        isFirst(el2) {
          let els = this.all();
          return els[0] && els[0].isSameNode(el2);
        },
        isLast(el2) {
          let els = this.all();
          return els.length && els.slice(-1)[0].isSameNode(el2);
        },
        getFirst() {
          return this.all()[0];
        },
        getLast() {
          return this.all().slice(-1)[0];
        },
        getNext() {
          let list = this.all();
          let current = document.activeElement;
          if (list.indexOf(current) === -1)
            return;
          if (this.__wrapAround && list.indexOf(current) === list.length - 1) {
            return list[0];
          }
          return list[list.indexOf(current) + 1];
        },
        getPrevious() {
          let list = this.all();
          let current = document.activeElement;
          if (list.indexOf(current) === -1)
            return;
          if (this.__wrapAround && list.indexOf(current) === 0) {
            return list.slice(-1)[0];
          }
          return list[list.indexOf(current) - 1];
        },
        first() {
          this.focus(this.getFirst());
        },
        last() {
          this.focus(this.getLast());
        },
        next() {
          this.focus(this.getNext());
        },
        previous() {
          this.focus(this.getPrevious());
        },
        prev() {
          return this.previous();
        },
        focus(el2) {
          if (!el2)
            return;
          setTimeout(() => {
            if (!el2.hasAttribute("tabindex"))
              el2.setAttribute("tabindex", "0");
            el2.focus({ preventScroll: this.__noscroll });
          });
        }
      };
    });
    Alpine2.directive("trap", Alpine2.skipDuringClone(
      (el, { expression, modifiers }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
        let evaluator = evaluateLater2(expression);
        let oldValue = false;
        let options2 = {
          escapeDeactivates: false,
          allowOutsideClick: true,
          fallbackFocus: () => el
        };
        if (modifiers.includes("noautofocus")) {
          options2.initialFocus = false;
        } else {
          let autofocusEl = el.querySelector("[autofocus]");
          if (autofocusEl)
            options2.initialFocus = autofocusEl;
        }
        let trap = createFocusTrap(el, options2);
        let undoInert = () => {
        };
        let undoDisableScrolling = () => {
        };
        const releaseFocus = () => {
          undoInert();
          undoInert = () => {
          };
          undoDisableScrolling();
          undoDisableScrolling = () => {
          };
          trap.deactivate({
            returnFocus: !modifiers.includes("noreturn")
          });
        };
        effect3(() => evaluator((value) => {
          if (oldValue === value)
            return;
          if (value && !oldValue) {
            if (modifiers.includes("noscroll"))
              undoDisableScrolling = disableScrolling();
            if (modifiers.includes("inert"))
              undoInert = setInert(el);
            setTimeout(() => {
              trap.activate();
            }, 15);
          }
          if (!value && oldValue) {
            releaseFocus();
          }
          oldValue = !!value;
        }));
        cleanup2(releaseFocus);
      },
      // When cloning, we only want to add aria-hidden attributes to the
      // DOM and not try to actually trap, as trapping can mess with the
      // live DOM and isn't just isolated to the cloned DOM.
      (el, { expression, modifiers }, { evaluate: evaluate2 }) => {
        if (modifiers.includes("inert") && evaluate2(expression))
          setInert(el);
      }
    ));
  }
  function setInert(el) {
    let undos = [];
    crawlSiblingsUp(el, (sibling) => {
      let cache2 = sibling.hasAttribute("aria-hidden");
      sibling.setAttribute("aria-hidden", "true");
      undos.push(() => cache2 || sibling.removeAttribute("aria-hidden"));
    });
    return () => {
      while (undos.length)
        undos.pop()();
    };
  }
  function crawlSiblingsUp(el, callback) {
    if (el.isSameNode(document.body) || !el.parentNode)
      return;
    Array.from(el.parentNode.children).forEach((sibling) => {
      if (sibling.isSameNode(el)) {
        crawlSiblingsUp(el.parentNode, callback);
      } else {
        callback(sibling);
      }
    });
  }
  function disableScrolling() {
    let overflow = document.documentElement.style.overflow;
    let paddingRight = document.documentElement.style.paddingRight;
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    return () => {
      document.documentElement.style.overflow = overflow;
      document.documentElement.style.paddingRight = paddingRight;
    };
  }
  var module_default3 = src_default3;

  // node_modules/.pnpm/@alpinejs+intersect@3.14.9/node_modules/@alpinejs/intersect/dist/module.esm.js
  function src_default4(Alpine2) {
    Alpine2.directive("intersect", Alpine2.skipDuringClone((el, { value, expression, modifiers }, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
      let evaluate2 = evaluateLater2(expression);
      let options2 = {
        rootMargin: getRootMargin(modifiers),
        threshold: getThreshold(modifiers)
      };
      let observer3 = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting === (value === "leave"))
            return;
          evaluate2();
          modifiers.includes("once") && observer3.disconnect();
        });
      }, options2);
      observer3.observe(el);
      cleanup2(() => {
        observer3.disconnect();
      });
    }));
  }
  function getThreshold(modifiers) {
    if (modifiers.includes("full"))
      return 0.99;
    if (modifiers.includes("half"))
      return 0.5;
    if (!modifiers.includes("threshold"))
      return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100")
      return 1;
    if (threshold === "0")
      return 0;
    return Number(`.${threshold}`);
  }
  function getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
  }
  function getRootMargin(modifiers) {
    const key3 = "margin";
    const fallback = "0px 0px 0px 0px";
    const index2 = modifiers.indexOf(key3);
    if (index2 === -1)
      return fallback;
    let values = [];
    for (let i = 1; i < 5; i++) {
      values.push(getLengthValue(modifiers[index2 + i] || ""));
    }
    values = values.filter((v) => v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
  }
  var module_default4 = src_default4;

  // node_modules/.pnpm/@alpinejs+mask@3.14.9/node_modules/@alpinejs/mask/dist/module.esm.js
  function src_default5(Alpine2) {
    Alpine2.directive("mask", (el, { value, expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
      let templateFn = () => expression;
      let lastInputValue = "";
      queueMicrotask(() => {
        if (["function", "dynamic"].includes(value)) {
          let evaluator = evaluateLater2(expression);
          effect3(() => {
            templateFn = (input) => {
              let result;
              Alpine2.dontAutoEvaluateFunctions(() => {
                evaluator((value2) => {
                  result = typeof value2 === "function" ? value2(input) : value2;
                }, { scope: {
                  // These are "magics" we'll make available to the x-mask:function:
                  "$input": input,
                  "$money": formatMoney3.bind({ el })
                } });
              });
              return result;
            };
            processInputValue(el, false);
          });
        } else {
          processInputValue(el, false);
        }
        if (el._x_model) {
          if (el._x_model.get() === el.value)
            return;
          if (el._x_model.get() === null && el.value === "")
            return;
          el._x_model.set(el.value);
        }
      });
      const controller = new AbortController();
      cleanup2(() => {
        controller.abort();
      });
      el.addEventListener("input", () => processInputValue(el), {
        signal: controller.signal,
        // Setting this as a capture phase listener to ensure it runs
        // before wire:model or x-model added as a latent binding...
        capture: true
      });
      el.addEventListener("blur", () => processInputValue(el, false), { signal: controller.signal });
      function processInputValue(el2, shouldRestoreCursor = true) {
        let input = el2.value;
        let template = templateFn(input);
        if (!template || template === "false")
          return false;
        if (lastInputValue.length - el2.value.length === 1) {
          return lastInputValue = el2.value;
        }
        let setInput = () => {
          lastInputValue = el2.value = formatInput(input, template);
        };
        if (shouldRestoreCursor) {
          restoreCursorPosition(el2, template, () => {
            setInput();
          });
        } else {
          setInput();
        }
      }
      function formatInput(input, template) {
        if (input === "")
          return "";
        let strippedDownInput = stripDown(template, input);
        let rebuiltInput = buildUp(template, strippedDownInput);
        return rebuiltInput;
      }
    }).before("model");
  }
  function restoreCursorPosition(el, template, callback) {
    let cursorPosition = el.selectionStart;
    let unformattedValue = el.value;
    callback();
    let beforeLeftOfCursorBeforeFormatting = unformattedValue.slice(0, cursorPosition);
    let newPosition = buildUp(
      template,
      stripDown(
        template,
        beforeLeftOfCursorBeforeFormatting
      )
    ).length;
    el.setSelectionRange(newPosition, newPosition);
  }
  function stripDown(template, input) {
    let inputToBeStripped = input;
    let output = "";
    let regexes = {
      "9": /[0-9]/,
      "a": /[a-zA-Z]/,
      "*": /[a-zA-Z0-9]/
    };
    let wildcardTemplate = "";
    for (let i = 0; i < template.length; i++) {
      if (["9", "a", "*"].includes(template[i])) {
        wildcardTemplate += template[i];
        continue;
      }
      for (let j = 0; j < inputToBeStripped.length; j++) {
        if (inputToBeStripped[j] === template[i]) {
          inputToBeStripped = inputToBeStripped.slice(0, j) + inputToBeStripped.slice(j + 1);
          break;
        }
      }
    }
    for (let i = 0; i < wildcardTemplate.length; i++) {
      let found = false;
      for (let j = 0; j < inputToBeStripped.length; j++) {
        if (regexes[wildcardTemplate[i]].test(inputToBeStripped[j])) {
          output += inputToBeStripped[j];
          inputToBeStripped = inputToBeStripped.slice(0, j) + inputToBeStripped.slice(j + 1);
          found = true;
          break;
        }
      }
      if (!found)
        break;
    }
    return output;
  }
  function buildUp(template, input) {
    let clean = Array.from(input);
    let output = "";
    for (let i = 0; i < template.length; i++) {
      if (!["9", "a", "*"].includes(template[i])) {
        output += template[i];
        continue;
      }
      if (clean.length === 0)
        break;
      output += clean.shift();
    }
    return output;
  }
  function formatMoney3(input, delimiter = ".", thousands, precision = 2) {
    if (input === "-")
      return "-";
    if (/^\D+$/.test(input))
      return "9";
    if (thousands === null || thousands === void 0) {
      thousands = delimiter === "," ? "." : ",";
    }
    let addThousands = (input2, thousands2) => {
      let output = "";
      let counter = 0;
      for (let i = input2.length - 1; i >= 0; i--) {
        if (input2[i] === thousands2)
          continue;
        if (counter === 3) {
          output = input2[i] + thousands2 + output;
          counter = 0;
        } else {
          output = input2[i] + output;
        }
        counter++;
      }
      return output;
    };
    let minus = input.startsWith("-") ? "-" : "";
    let strippedInput = input.replaceAll(new RegExp(`[^0-9\\${delimiter}]`, "g"), "");
    let template = Array.from({ length: strippedInput.split(delimiter)[0].length }).fill("9").join("");
    template = `${minus}${addThousands(template, thousands)}`;
    if (precision > 0 && input.includes(delimiter))
      template += `${delimiter}` + "9".repeat(precision);
    queueMicrotask(() => {
      if (this.el.value.endsWith(delimiter))
        return;
      if (this.el.value[this.el.selectionStart - 1] === delimiter) {
        this.el.setSelectionRange(this.el.selectionStart - 1, this.el.selectionStart - 1);
      }
    });
    return template;
  }
  var module_default5 = src_default5;

  // node_modules/.pnpm/@alpinejs+morph@3.14.9/node_modules/@alpinejs/morph/dist/module.esm.js
  function morph(from, toHtml, options2) {
    monkeyPatchDomSetAttributeToAllowAtSymbols();
    let fromEl;
    let toEl;
    let key3, lookahead, updating, updated, removing, removed, adding, added;
    function assignOptions(options22 = {}) {
      let defaultGetKey = (el) => el.getAttribute("key");
      let noop = () => {
      };
      updating = options22.updating || noop;
      updated = options22.updated || noop;
      removing = options22.removing || noop;
      removed = options22.removed || noop;
      adding = options22.adding || noop;
      added = options22.added || noop;
      key3 = options22.key || defaultGetKey;
      lookahead = options22.lookahead || false;
    }
    function patch(from2, to) {
      if (differentElementNamesTypesOrKeys(from2, to)) {
        return swapElements(from2, to);
      }
      let updateChildrenOnly = false;
      let skipChildren = false;
      if (shouldSkipChildren(updating, () => skipChildren = true, from2, to, () => updateChildrenOnly = true))
        return;
      if (from2.nodeType === 1 && window.Alpine) {
        window.Alpine.cloneNode(from2, to);
        if (from2._x_teleport && to._x_teleport) {
          patch(from2._x_teleport, to._x_teleport);
        }
      }
      if (textOrComment(to)) {
        patchNodeValue(from2, to);
        updated(from2, to);
        return;
      }
      if (!updateChildrenOnly) {
        patchAttributes(from2, to);
      }
      updated(from2, to);
      if (!skipChildren) {
        patchChildren(from2, to);
      }
    }
    function differentElementNamesTypesOrKeys(from2, to) {
      return from2.nodeType != to.nodeType || from2.nodeName != to.nodeName || getKey(from2) != getKey(to);
    }
    function swapElements(from2, to) {
      if (shouldSkip(removing, from2))
        return;
      let toCloned = to.cloneNode(true);
      if (shouldSkip(adding, toCloned))
        return;
      from2.replaceWith(toCloned);
      removed(from2);
      added(toCloned);
    }
    function patchNodeValue(from2, to) {
      let value = to.nodeValue;
      if (from2.nodeValue !== value) {
        from2.nodeValue = value;
      }
    }
    function patchAttributes(from2, to) {
      if (from2._x_transitioning)
        return;
      if (from2._x_isShown && !to._x_isShown) {
        return;
      }
      if (!from2._x_isShown && to._x_isShown) {
        return;
      }
      let domAttributes = Array.from(from2.attributes);
      let toAttributes = Array.from(to.attributes);
      for (let i = domAttributes.length - 1; i >= 0; i--) {
        let name = domAttributes[i].name;
        if (!to.hasAttribute(name)) {
          from2.removeAttribute(name);
        }
      }
      for (let i = toAttributes.length - 1; i >= 0; i--) {
        let name = toAttributes[i].name;
        let value = toAttributes[i].value;
        if (from2.getAttribute(name) !== value) {
          from2.setAttribute(name, value);
        }
      }
    }
    function patchChildren(from2, to) {
      let fromKeys = keyToMap(from2.children);
      let fromKeyHoldovers = {};
      let currentTo = getFirstNode(to);
      let currentFrom = getFirstNode(from2);
      while (currentTo) {
        seedingMatchingId(currentTo, currentFrom);
        let toKey = getKey(currentTo);
        let fromKey = getKey(currentFrom);
        if (!currentFrom) {
          if (toKey && fromKeyHoldovers[toKey]) {
            let holdover = fromKeyHoldovers[toKey];
            from2.appendChild(holdover);
            currentFrom = holdover;
            fromKey = getKey(currentFrom);
          } else {
            if (!shouldSkip(adding, currentTo)) {
              let clone2 = currentTo.cloneNode(true);
              from2.appendChild(clone2);
              added(clone2);
            }
            currentTo = getNextSibling(to, currentTo);
            continue;
          }
        }
        let isIf = (node) => node && node.nodeType === 8 && node.textContent === "[if BLOCK]><![endif]";
        let isEnd = (node) => node && node.nodeType === 8 && node.textContent === "[if ENDBLOCK]><![endif]";
        if (isIf(currentTo) && isIf(currentFrom)) {
          let nestedIfCount = 0;
          let fromBlockStart = currentFrom;
          while (currentFrom) {
            let next = getNextSibling(from2, currentFrom);
            if (isIf(next)) {
              nestedIfCount++;
            } else if (isEnd(next) && nestedIfCount > 0) {
              nestedIfCount--;
            } else if (isEnd(next) && nestedIfCount === 0) {
              currentFrom = next;
              break;
            }
            currentFrom = next;
          }
          let fromBlockEnd = currentFrom;
          nestedIfCount = 0;
          let toBlockStart = currentTo;
          while (currentTo) {
            let next = getNextSibling(to, currentTo);
            if (isIf(next)) {
              nestedIfCount++;
            } else if (isEnd(next) && nestedIfCount > 0) {
              nestedIfCount--;
            } else if (isEnd(next) && nestedIfCount === 0) {
              currentTo = next;
              break;
            }
            currentTo = next;
          }
          let toBlockEnd = currentTo;
          let fromBlock = new Block(fromBlockStart, fromBlockEnd);
          let toBlock = new Block(toBlockStart, toBlockEnd);
          patchChildren(fromBlock, toBlock);
          continue;
        }
        if (currentFrom.nodeType === 1 && lookahead && !currentFrom.isEqualNode(currentTo)) {
          let nextToElementSibling = getNextSibling(to, currentTo);
          let found = false;
          while (!found && nextToElementSibling) {
            if (nextToElementSibling.nodeType === 1 && currentFrom.isEqualNode(nextToElementSibling)) {
              found = true;
              currentFrom = addNodeBefore(from2, currentTo, currentFrom);
              fromKey = getKey(currentFrom);
            }
            nextToElementSibling = getNextSibling(to, nextToElementSibling);
          }
        }
        if (toKey !== fromKey) {
          if (!toKey && fromKey) {
            fromKeyHoldovers[fromKey] = currentFrom;
            currentFrom = addNodeBefore(from2, currentTo, currentFrom);
            fromKeyHoldovers[fromKey].remove();
            currentFrom = getNextSibling(from2, currentFrom);
            currentTo = getNextSibling(to, currentTo);
            continue;
          }
          if (toKey && !fromKey) {
            if (fromKeys[toKey]) {
              currentFrom.replaceWith(fromKeys[toKey]);
              currentFrom = fromKeys[toKey];
              fromKey = getKey(currentFrom);
            }
          }
          if (toKey && fromKey) {
            let fromKeyNode = fromKeys[toKey];
            if (fromKeyNode) {
              fromKeyHoldovers[fromKey] = currentFrom;
              currentFrom.replaceWith(fromKeyNode);
              currentFrom = fromKeyNode;
              fromKey = getKey(currentFrom);
            } else {
              fromKeyHoldovers[fromKey] = currentFrom;
              currentFrom = addNodeBefore(from2, currentTo, currentFrom);
              fromKeyHoldovers[fromKey].remove();
              currentFrom = getNextSibling(from2, currentFrom);
              currentTo = getNextSibling(to, currentTo);
              continue;
            }
          }
        }
        let currentFromNext = currentFrom && getNextSibling(from2, currentFrom);
        patch(currentFrom, currentTo);
        currentTo = currentTo && getNextSibling(to, currentTo);
        currentFrom = currentFromNext;
      }
      let removals = [];
      while (currentFrom) {
        if (!shouldSkip(removing, currentFrom))
          removals.push(currentFrom);
        currentFrom = getNextSibling(from2, currentFrom);
      }
      while (removals.length) {
        let domForRemoval = removals.shift();
        domForRemoval.remove();
        removed(domForRemoval);
      }
    }
    function getKey(el) {
      return el && el.nodeType === 1 && key3(el);
    }
    function keyToMap(els) {
      let map = {};
      for (let el of els) {
        let theKey = getKey(el);
        if (theKey) {
          map[theKey] = el;
        }
      }
      return map;
    }
    function addNodeBefore(parent, node, beforeMe) {
      if (!shouldSkip(adding, node)) {
        let clone2 = node.cloneNode(true);
        parent.insertBefore(clone2, beforeMe);
        added(clone2);
        return clone2;
      }
      return node;
    }
    assignOptions(options2);
    fromEl = from;
    toEl = typeof toHtml === "string" ? createElement(toHtml) : toHtml;
    if (window.Alpine && window.Alpine.closestDataStack && !from._x_dataStack) {
      toEl._x_dataStack = window.Alpine.closestDataStack(from);
      toEl._x_dataStack && window.Alpine.cloneNode(from, toEl);
    }
    patch(from, toEl);
    fromEl = void 0;
    toEl = void 0;
    return from;
  }
  morph.step = () => {
  };
  morph.log = () => {
  };
  function shouldSkip(hook, ...args) {
    let skip = false;
    hook(...args, () => skip = true);
    return skip;
  }
  function shouldSkipChildren(hook, skipChildren, ...args) {
    let skip = false;
    hook(...args, () => skip = true, skipChildren);
    return skip;
  }
  var patched = false;
  function createElement(html) {
    const template = document.createElement("template");
    template.innerHTML = html;
    return template.content.firstElementChild;
  }
  function textOrComment(el) {
    return el.nodeType === 3 || el.nodeType === 8;
  }
  var Block = class {
    constructor(start2, end) {
      this.startComment = start2;
      this.endComment = end;
    }
    get children() {
      let children = [];
      let currentNode = this.startComment.nextSibling;
      while (currentNode && currentNode !== this.endComment) {
        children.push(currentNode);
        currentNode = currentNode.nextSibling;
      }
      return children;
    }
    appendChild(child) {
      this.endComment.before(child);
    }
    get firstChild() {
      let first = this.startComment.nextSibling;
      if (first === this.endComment)
        return;
      return first;
    }
    nextNode(reference) {
      let next = reference.nextSibling;
      if (next === this.endComment)
        return;
      return next;
    }
    insertBefore(newNode, reference) {
      reference.before(newNode);
      return newNode;
    }
  };
  function getFirstNode(parent) {
    return parent.firstChild;
  }
  function getNextSibling(parent, reference) {
    let next;
    if (parent instanceof Block) {
      next = parent.nextNode(reference);
    } else {
      next = reference.nextSibling;
    }
    return next;
  }
  function monkeyPatchDomSetAttributeToAllowAtSymbols() {
    if (patched)
      return;
    patched = true;
    let original = Element.prototype.setAttribute;
    let hostDiv = document.createElement("div");
    Element.prototype.setAttribute = function newSetAttribute(name, value) {
      if (!name.includes("@")) {
        return original.call(this, name, value);
      }
      hostDiv.innerHTML = `<span ${name}="${value}"></span>`;
      let attr = hostDiv.firstElementChild.getAttributeNode(name);
      hostDiv.firstElementChild.removeAttributeNode(attr);
      this.setAttributeNode(attr);
    };
  }
  function seedingMatchingId(to, from) {
    let fromId = from && from._x_bindings && from._x_bindings.id;
    if (!fromId)
      return;
    if (!to.setAttribute)
      return;
    to.setAttribute("id", fromId);
    to.id = fromId;
  }
  function src_default6(Alpine2) {
    Alpine2.morph = morph;
  }
  var module_default6 = src_default6;

  // node_modules/.pnpm/@alpinejs+persist@3.14.9/node_modules/@alpinejs/persist/dist/module.esm.js
  function src_default7(Alpine2) {
    let persist = () => {
      let alias;
      let storage;
      try {
        storage = localStorage;
      } catch (e) {
        console.error(e);
        console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
        let dummy = /* @__PURE__ */ new Map();
        storage = {
          getItem: dummy.get.bind(dummy),
          setItem: dummy.set.bind(dummy)
        };
      }
      return Alpine2.interceptor((initialValue, getter, setter, path, key3) => {
        let lookup = alias || `_x_${path}`;
        let initial = storageHas(lookup, storage) ? storageGet(lookup, storage) : initialValue;
        setter(initial);
        Alpine2.effect(() => {
          let value = getter();
          storageSet(lookup, value, storage);
          setter(value);
        });
        return initial;
      }, (func) => {
        func.as = (key3) => {
          alias = key3;
          return func;
        }, func.using = (target) => {
          storage = target;
          return func;
        };
      });
    };
    Object.defineProperty(Alpine2, "$persist", { get: () => persist() });
    Alpine2.magic("persist", persist);
    Alpine2.persist = (key3, { get: get3, set: set3 }, storage = localStorage) => {
      let initial = storageHas(key3, storage) ? storageGet(key3, storage) : get3();
      set3(initial);
      Alpine2.effect(() => {
        let value = get3();
        storageSet(key3, value, storage);
        set3(value);
      });
    };
  }
  function storageHas(key3, storage) {
    return storage.getItem(key3) !== null;
  }
  function storageGet(key3, storage) {
    let value = storage.getItem(key3, storage);
    if (value === void 0)
      return;
    return JSON.parse(value);
  }
  function storageSet(key3, value, storage) {
    storage.setItem(key3, JSON.stringify(value));
  }
  var module_default7 = src_default7;

  // node_modules/.pnpm/@ekwoka+x-rias@1.3.1_alpinejs@3.14.9/node_modules/@ekwoka/x-rias/dist/resizeObserver.js
  var debounceObserver = (fn, delay3) => {
    let timer;
    const allElements = /* @__PURE__ */ new Set();
    return function(entries, observer22) {
      if (timer)
        clearTimeout(timer);
      entries.forEach(({ target }) => allElements.add(target));
      timer = setTimeout(() => {
        fn(allElements, observer22);
        timer = null;
      }, delay3);
    };
  };
  var observerCB = (els) => {
    els.forEach((el) => resize(el));
    els.clear();
  };
  var resize = (el) => {
    const setSize = (width2) => el.setAttribute("sizes", (width2 | 0) + "px");
    let width = 0;
    let height = 0;
    let parent = el;
    while (width < 100 && parent) {
      width = parent.offsetWidth;
      height = parent.offsetHeight;
      parent = parent.parentNode;
    }
    const objectFit = getComputedStyle(el).objectFit;
    if (objectFit !== "cover")
      return setSize(width);
    const imageRatio = Number(el.getAttribute("width")) / Number(el.getAttribute("height"));
    if (!imageRatio)
      return setSize(width);
    const displayedRatio = width / height;
    if (displayedRatio >= imageRatio + 0.1)
      return setSize(width);
    const newWidth = height * imageRatio;
    setSize(newWidth);
  };
  var observer2 = new ResizeObserver(debounceObserver(observerCB, 800));

  // node_modules/.pnpm/@ekwoka+x-rias@1.3.1_alpinejs@3.14.9/node_modules/@ekwoka/x-rias/dist/utils.js
  var getURLMaker = (value, onShopify, cloudURL) => {
    if (onShopify)
      return getShopifyUrl(value);
    if (cloudURL)
      return getCloudinaryUrl(value, cloudURL);
    throw new TypeError("Invalid options");
  };
  var getCloudinaryUrl = (value, cloudURL) => {
    value = new URL(value, document.baseURI).href;
    if (value.includes("localhost"))
      return () => value;
    return (v) => (cloudURL + value).replace("{width}", String(v));
  };
  var getShopifyUrl = (value) => {
    if (value.includes("{width}"))
      return (v) => value.replaceAll("{width}", String(v));
    if (regexp.test(value)) {
      const modified = value.replace(regexp, "_{width}x$1");
      return (v) => modified.replaceAll("{width}", String(v));
    }
    return (v) => {
      const url = new URL(value, document.baseURI);
      url.searchParams.set("width", String(v));
      return url.href;
    };
  };
  var widths = [
    180,
    360,
    540,
    720,
    900,
    1080,
    1296,
    1512,
    1728,
    1944,
    2160,
    2376,
    2592,
    2808,
    3024
  ];
  var makeSrcSet = (urlGenerator, maxSize = Infinity) => {
    return widths.filter((w) => w <= maxSize).map((w) => `${urlGenerator(w)} ${w}w`).join(",");
  };
  var regexp = /_\d+x(\.jpg|\.png)/;

  // node_modules/.pnpm/@ekwoka+x-rias@1.3.1_alpinejs@3.14.9/node_modules/@ekwoka/x-rias/dist/index.js
  function index(OPTIONS) {
    var _a4;
    const {
      autoSize = true,
      shopify = false,
      maxSize = 0,
      cloudURL = ""
    } = (_a4 = parseOptions(OPTIONS)) != null ? _a4 : {};
    return (Alpine2) => {
      Alpine2.directive(
        "rias",
        (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
          if (!(el instanceof HTMLImageElement))
            return console.warn("x-rias only works on img elements");
          cleanup2(() => observer2.unobserve(el));
          if (!expression)
            return autoSize && observer2.observe(el);
          const evaluate2 = evaluateLater2(expression);
          effect3(() => {
            evaluate2((value) => {
              if (!value || typeof value !== "string")
                return;
              const makeImg = getURLMaker(value, shopify, cloudURL);
              const max = maxSize || Number(el.dataset.maxSize) || Infinity;
              const src = makeImg(Math.min(max, 360));
              const srcset = makeSrcSet(makeImg, max);
              Alpine2.mutateDom(() => {
                el.src = src;
                el.srcset = srcset;
                el.loading = el.loading == "eager" ? "eager" : "lazy";
                if (autoSize || el.dataset.sizes == "auto")
                  observer2.observe(el);
              });
            });
          });
        }
      );
      const $rias = {
        srcset(value) {
          return makeSrcSet(
            getURLMaker(value, shopify, cloudURL),
            maxSize || Infinity
          );
        },
        observe: observer2.observe.bind(observer2),
        unobserve: observer2.unobserve.bind(observer2)
      };
      Alpine2.magic("rias", () => $rias);
    };
  }
  var parseOptions = (OPTIONS) => {
    if (typeof OPTIONS === "string") {
      const cloudURL = `https://res.cloudinary.com/${OPTIONS}/image/fetch/f_auto,q_80,w_{width}/`;
      return { cloudURL };
    }
    if (typeof OPTIONS === "object") {
      return {
        ...OPTIONS,
        cloudURL: OPTIONS.key ? `https://res.cloudinary.com/${OPTIONS.key}/image/fetch/f_auto,q_80,w_{width}/` : ""
      };
    }
  };

  // node_modules/.pnpm/@newthink+clickable@0.0.1_alpinejs@3.14.9/node_modules/@newthink/clickable/dist/Clickable.js
  var Clickable = (Alpine2) => Alpine2.directive("clickable", (el, { expression: selector }) => {
    const clickable = el.querySelector(
      selector || "a, button"
    );
    if (!clickable)
      return console.warn(
        `x-clickable: No target found for selector ${selector || "a, button"}`
      );
    const handler4 = function() {
      var _a4;
      const target = this.$event.target;
      const boundary = Alpine2.findClosest(
        target,
        (testEl) => testEl.matches(`a, button, input, select`) || testEl === el
      );
      if (boundary !== el)
        return;
      const { metaKey, ctrlKey, altKey, shiftKey, button } = this.$event;
      clickable.dispatchEvent(
        new ((_a4 = this.$event.constructor) != null ? _a4 : MouseEvent)("click", {
          metaKey,
          ctrlKey,
          altKey,
          shiftKey,
          button
        })
      );
    };
    Alpine2.bind(el, {
      "@click": handler4,
      "@auxclick": handler4
    });
  });

  // node_modules/.pnpm/@newthink+ui@0.4.2_@alpinejs+focus@3.14.9_alpinejs@3.14.9/node_modules/@newthink/ui/dist/headless/headless.js
  var headless = (name, rootHandler, handlers) => {
    const headlessMap = /* @__PURE__ */ new WeakMap();
    return (Alpine2) => {
      const getHeadlessComponentState = (el) => {
        const root = Alpine2.findClosest(el, headlessMap.has.bind(headlessMap));
        if (!root)
          return console.error(`Could not find root for ${name} component`, el);
        return headlessMap.get(root);
      };
      Alpine2.magic(name, (el) => getHeadlessComponentState(el));
      Alpine2.directive(name, (el, directive2, utils) => {
        if (!directive2.value)
          return headlessMap.set(el, rootHandler(el, directive2, utils));
        const headlessState = getHeadlessComponentState(el);
        if (!headlessState)
          return missingState(name, el);
        ((handlers == null ? void 0 : handlers[directive2.value]) || failback(name))(headlessState, el, directive2, utils);
      });
    };
  };
  var failback = (name) => (_, el, directive2) => {
    console.error(`Alpine ${name}: Invalid directive value`, el, directive2.original);
  };
  var missingState = (name, el) => console.error(`Could not find root for ${name} component`, el);

  // node_modules/.pnpm/@newthink+ui@0.4.2_@alpinejs+focus@3.14.9_alpinejs@3.14.9/node_modules/@newthink/ui/dist/headless/accordion.js
  var groupMap = /* @__PURE__ */ new WeakMap();
  var getGroup = (el, Alpine2) => {
    const root = Alpine2.findClosest(el, groupMap.has.bind(groupMap));
    return groupMap.get(root);
  };
  var handleAccordionGroup = (el, _, { Alpine: Alpine2, effect: effect3 }) => {
    const groupData = Alpine2.reactive({
      active: null,
      id: 0,
      addAccordion(initial) {
        const thisId = this.id++;
        const accordionInstance = Alpine2.reactive({
          active: initial
        });
        effect3(() => {
          if (accordionInstance.active) {
            this.active = thisId;
          } else if (this.active === thisId) {
            this.active = null;
          }
        });
        effect3(() => {
          if (this.active === thisId) {
            accordionInstance.active = true;
          } else {
            accordionInstance.active = false;
          }
        });
        return accordionInstance;
      }
    });
    groupMap.set(el, groupData);
    return groupData;
  };
  var accordionGroup = (Alpine2) => Alpine2.directive("accordion-group", handleAccordionGroup);
  var handleAccordionRoot = (el, { modifiers: [initialState = "closed"] }, { Alpine: Alpine2 }) => {
    var _a4, _b2;
    return (_b2 = (_a4 = getGroup(el, Alpine2)) == null ? void 0 : _a4.addAccordion(initialState === "open")) != null ? _b2 : Alpine2.reactive({
      active: initialState === "open"
    });
  };
  var controlForce = {
    open: true,
    close: false,
    toggle: null
  };
  var handleAccordionControl = (accordionData, el, { modifiers: [force = "toggle"] }, { Alpine: Alpine2 }) => {
    Alpine2.bind(el, {
      "x-on:click": () => {
        var _a4;
        accordionData.active = (_a4 = controlForce[force]) != null ? _a4 : !accordionData.active;
      },
      ":aria-expanded": () => accordionData.active
    });
  };
  var handleAccordionContainer = (accordionData, el, _, { Alpine: Alpine2 }) => {
    Alpine2.bind(el, {
      "x-show": () => accordionData.active
    });
  };
  var accordionHandlers = {
    control: handleAccordionControl,
    container: handleAccordionContainer
  };
  var accordion = headless("accordion", handleAccordionRoot, accordionHandlers);
  var accordions = (Alpine2) => {
    accordionGroup(Alpine2);
    accordion(Alpine2);
  };

  // node_modules/.pnpm/@newthink+ui@0.4.2_@alpinejs+focus@3.14.9_alpinejs@3.14.9/node_modules/@newthink/ui/dist/headless/dragScroll.js
  var resizeCenterer = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const el = entry.target;
      if (!(el instanceof HTMLElement))
        continue;
      center(el);
    }
  });
  var center = async (el) => {
    await module_default.nextTick();
    el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
    el.scrollTop = (el.scrollHeight - el.clientHeight) / 2;
  };
  var forEach = Array.prototype.forEach;
  var dragScroll = (Alpine2) => Alpine2.directive("dragscroll", (el, { modifiers }, { cleanup: cleanup2 }) => {
    const autoCenter = modifiers.includes("center");
    cleanup2(registerDragScroll(el));
    el.classList.add("overscroll-contain", "cursor-grab");
    if (!autoCenter)
      return;
    forEach.call(el.children, (el2) => resizeCenterer.observe(el2));
    cleanup2(() => forEach.call(el.children, (el2) => resizeCenterer.unobserve(el2)));
  });
  var preventStop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  var cancelEvents = ["pointerup", "mouseup", "touchend"];
  var registerDragScroll = (el) => {
    const moveHandler = (e) => {
      preventStop(e);
      el.scrollLeft -= e.movementX;
      el.scrollTop -= e.movementY;
    };
    const upHandler = async (e) => {
      preventStop(e);
      document.removeEventListener("pointermove", moveHandler, true);
      document.body.classList.remove("!cursor-grabbing", "[&>*]:pointer-events-none");
      el.classList.add("cursor-grab");
      await module_default.nextTick();
      document.removeEventListener("click", preventStop, true);
      cancelEvents.forEach((event) => document.removeEventListener(event, upHandler, {
        capture: true
      }));
    };
    const downHandler = (e) => {
      if (isTouch(e))
        return;
      if (e.button === 2)
        return;
      preventStop(e);
      el.classList.remove("cursor-grab");
      document.body.classList.add("!cursor-grabbing", "[&>*]:pointer-events-none");
      document.addEventListener("pointermove", moveHandler, { capture: true });
      cancelEvents.forEach((event) => document.addEventListener(event, upHandler, {
        capture: true
      }));
      document.addEventListener("click", preventStop, { capture: true });
    };
    el.addEventListener("pointerdown", downHandler);
    return () => el.removeEventListener("pointerdown", downHandler);
  };
  var isTouch = (e) => e instanceof TouchEvent || e instanceof PointerEvent && e.pointerType === "touch";

  // node_modules/.pnpm/@newthink+ui@0.4.2_@alpinejs+focus@3.14.9_alpinejs@3.14.9/node_modules/@newthink/ui/dist/headless/panel.js
  var handleRoot = (el, _, { Alpine: Alpine2 }) => {
    const panelState = Alpine2.reactive({
      isOpen: false,
      open() {
        this.isOpen = true;
      },
      close() {
        this.isOpen = false;
      },
      toggle() {
        return this.isOpen ? this.close() : this.open();
      }
    });
    Alpine2.bind(el, {
      "x-id": () => ["x-panel"]
    });
    return panelState;
  };
  var panel = headless("panel", handleRoot, {
    summary: (panelState, el, _, { Alpine: Alpine2 }) => {
      Alpine2.bind(el, {
        ":aria-expanded": () => panelState.isOpen,
        ":aria-controls": '$id("x-panel")'
      });
    },
    content: (panelState, el, _, { Alpine: Alpine2 }) => {
      Alpine2.bind(el, {
        "x-show": () => panelState.isOpen
      });
    }
  });

  // node_modules/.pnpm/@newthink+ui@0.4.2_@alpinejs+focus@3.14.9_alpinejs@3.14.9/node_modules/@newthink/ui/dist/headless/tabs.js
  var tabs = headless("tabs", (_el, _directive, { Alpine: Alpine2, evaluate: evaluate2 }) => {
    const tabGroup = Alpine2.reactive({
      activeTab: 0,
      isSelected($el) {
        return this.tabs[this.activeTab] === $el;
      },
      tabs: [],
      panels: [],
      $focus: evaluate2("$focus")
    });
    return tabGroup;
  }, {
    list: (tabGroup, el, _directive, { Alpine: Alpine2 }) => {
      const focusNext = () => tabGroup.$focus.wrap().next();
      const focusPrevious = () => tabGroup.$focus.wrap().previous();
      Alpine2.bind(el, {
        ":role": () => "tablist",
        "@keydown.arrow-left.stop.prevent": focusPrevious,
        "@keydown.arrow-right.stop.prevent": focusNext,
        "@keydown.arrow-up.stop.prevent": focusPrevious,
        "@keydown.arrow-down.stop.prevent": focusNext
      });
    },
    tab: (tabGroup, el, _directive, { Alpine: Alpine2 }) => {
      const tabIndex = tabGroup.tabs.push(el) - 1;
      Alpine2.bind(el, {
        ":tabindex": () => Number(tabIndex === tabGroup.activeTab) - 1,
        ":aria-selected": () => tabIndex === tabGroup.activeTab,
        "@click": () => tabGroup.$focus.focus(el),
        "@focus": () => tabGroup.activeTab = tabIndex
      });
    },
    panel: (tabGroup, el, _directive, { Alpine: Alpine2 }) => {
      const panelIndex = tabGroup.panels.push(el) - 1;
      Alpine2.bind(el, {
        "x-show": () => panelIndex === tabGroup.activeTab,
        ":hidden": () => panelIndex !== tabGroup.activeTab,
        ":aria-hidden": () => panelIndex !== tabGroup.activeTab
      });
    }
  });

  // node_modules/.pnpm/@newthink+ui@0.4.2_@alpinejs+focus@3.14.9_alpinejs@3.14.9/node_modules/@newthink/ui/dist/headless/swipeDetect.js
  var SwipeDirection;
  (function(SwipeDirection2) {
    SwipeDirection2[SwipeDirection2["None"] = 0] = "None";
    SwipeDirection2[SwipeDirection2["Left"] = 1] = "Left";
    SwipeDirection2[SwipeDirection2["Right"] = 2] = "Right";
    SwipeDirection2[SwipeDirection2["Up"] = 4] = "Up";
    SwipeDirection2[SwipeDirection2["Down"] = 8] = "Down";
  })(SwipeDirection || (SwipeDirection = {}));
  var swipableMap = /* @__PURE__ */ new WeakMap();
  var hasSwipe = swipableMap.has.bind(swipableMap);
  var swipeDetect = (Alpine2) => Alpine2.directive("swipe", (el, _, { cleanup: cleanup2 }) => {
    const swipeData = {
      dispatch: (dir) => {
        const direction = Object.entries(SwipeDirection).filter(([, v]) => typeof v === "number" && v && (dir & v) === v).map(([k]) => k.toLowerCase());
        el.dispatchEvent(new CustomEvent("swipe", {
          detail: direction.join("-")
        }));
        el.dispatchEvent(new CustomEvent(`swipe${direction.join("")}`, {
          detail: direction.join("-")
        }));
      }
    };
    swipableMap.set(el, swipeData);
    el.addEventListener("touchstart", touchDown);
    cleanup2(() => el.removeEventListener("touchstart", touchDown));
  });
  var touchDown = (ev) => {
    var _a4;
    const swipeData = swipableMap.get(ev.currentTarget);
    if (!swipeData)
      return;
    const touch = ev.touches[0];
    const { clientX, clientY } = touch;
    (_a4 = swipeData.start) != null ? _a4 : swipeData.start = { x: clientX, y: clientY };
    document.addEventListener("touchend", touchUp, { once: true });
  };
  var touchUp = (ev) => {
    const target = ev.target;
    if (!target)
      return;
    const swipeData = swipableMap.get(findNearest(target, hasSwipe));
    if (!(swipeData == null ? void 0 : swipeData.start))
      return;
    const touch = ev.changedTouches[0];
    const { clientX, clientY } = touch;
    const direction = getDirection(swipeData.start, { x: clientX, y: clientY });
    if (direction === SwipeDirection.None)
      return;
    swipeData.dispatch(direction);
    delete swipeData.start;
  };
  var findNearest = (el, predicate) => {
    if (predicate(el))
      return el;
    if (!el.parentElement)
      return null;
    return findNearest(el.parentElement, predicate);
  };
  var getDirection = (start2, end) => {
    const vector = [end.x - start2.x, end.y - start2.y];
    if (vector.every((v) => Math.abs(v) < 50))
      return SwipeDirection.None;
    const magnitude = Math.sqrt(vector[0] * vector[0] + vector[1] * vector[1]);
    const [x, y] = vector.map((v) => v / magnitude);
    const direction = getDirectionSign(x) | getDirectionSign(y) << 2;
    return direction;
  };
  var getDirectionSign = (offset) => {
    if (offset > 0.5)
      return 2;
    if (offset < -0.5)
      return 1;
    return 0;
  };

  // node_modules/.pnpm/@newthink+ui@0.4.2_@alpinejs+focus@3.14.9_alpinejs@3.14.9/node_modules/@newthink/ui/dist/magics/screen.js
  var screen = (Alpine2) => {
    Alpine2.magic("screen", () => (breakpoint) => {
      var _a4;
      const breakSize = typeof breakpoint === "number" ? breakpoint : (_a4 = breakpoints[breakpoint]) != null ? _a4 : Number(breakpoint);
      if (!breakSize) {
        console.error(`Invalid breakpoint: $screen(${JSON.stringify(breakpoint)})`);
        return false;
      }
      const signal = getMediaSignal(breakSize, Alpine2);
      return signal.value;
    });
  };
  var defaultBreakpoints = {
    xs: 320,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536
  };
  var breakpoints = defaultBreakpoints;
  var mediaSignals = {};
  var getMediaSignal = (breakpoint, Alpine2) => {
    var _a4;
    return (_a4 = mediaSignals[breakpoint]) != null ? _a4 : createMediaSignal(breakpoint, Alpine2);
  };
  var createMediaSignal = (breakpoint, Alpine2) => {
    const mediaMatch = window.matchMedia(`(min-width: ${breakpoint}px)`);
    const signal = Alpine2.reactive({
      value: mediaMatch.matches
    });
    mediaSignals[breakpoint] = signal;
    mediaMatch.addEventListener("change", (e) => {
      signal.value = e.matches;
    });
    return signal;
  };

  // node_modules/.pnpm/@newthink+ui@0.4.2_@alpinejs+focus@3.14.9_alpinejs@3.14.9/node_modules/@newthink/ui/dist/index.js
  var NTMagics = (Alpine2) => Alpine2.plugin([screen]);
  var UI = (Alpine2) => Alpine2.plugin([accordions, dragScroll, panel, swipeDetect, tabs, NTMagics]);
  var dist_default = UI;

  // src/alpine/plugins/scroll.ts
  var scroll = (Alpine2) => {
    const scrollHandlers = /* @__PURE__ */ new Set();
    const scrollState = Alpine2.reactive({
      previous: window.scrollY,
      current: window.scrollY,
      nearTop: window.scrollY < 120,
      direction: "up" /* Up */,
      onScroll: (handler4) => {
        scrollHandlers.add(handler4);
        return () => scrollHandlers.delete(handler4);
      }
    });
    let updateTimeout;
    scrollState.onScroll((state) => {
      const direction = state.current > state.previous ? "down" /* Down */ : "up" /* Up */;
      if (direction !== scrollState.direction)
        updateTimeout != null ? updateTimeout : updateTimeout = setTimeout(
          () => scrollState.direction = direction,
          200
        );
      else {
        clearTimeout(updateTimeout);
        updateTimeout = null;
      }
    });
    window.addEventListener(
      "scroll",
      () => {
        scrollState.previous = scrollState.current;
        scrollState.current = window.scrollY;
        scrollState.nearTop = window.scrollY <= 90 ? true : window.scrollY >= 120 ? false : scrollState.nearTop;
        scrollHandlers.forEach((handler4) => handler4(scrollState));
      },
      { passive: true }
    );
    Alpine2.magic("scroll", () => scrollState);
  };

  // src/alpine/plugins/index.ts
  var Plugins = [
    Clickable,
    module_default2,
    module_default3,
    module_default4,
    module_default5,
    module_default6,
    module_default7,
    index({ shopify: true, autoSize: true }),
    scroll,
    dist_default
  ];

  // src/utilities/cartFunctions.ts
  var addItem = async (item) => {
    const body = createBody(item);
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
      });
      if (!res.ok) return res;
      const data2 = await res.json();
      return data2;
    } catch (e) {
      console.error(e);
    }
    return null;
  };
  var getItemFromFormData = (formData) => {
    var _a4, _b2;
    const item = {
      id: Number(formData.get("id")),
      quantity: Number((_a4 = formData.get("quantity")) != null ? _a4 : 1),
      properties: getStoredProps(Number(formData.get("id")))
    };
    for (const [key3, value] of formData.entries()) {
      if (key3.startsWith("properties")) {
        const property = (_b2 = key3.match(/\[(.*)\]/)) == null ? void 0 : _b2[1];
        if (property)
          item.properties[property] = String(value).replace("Offset ", "");
      }
    }
    return item;
  };
  var createBody = (item) => {
    const generated = arrayWrap(item).map((item2) => {
      var _a4;
      const generated2 = typeof item2 === "object" ? {
        quantity: 1,
        ...item2,
        properties: Object.assign(
          getStoredProps(item2.id),
          (_a4 = item2.properties) != null ? _a4 : {}
        )
      } : { id: item2, quantity: 1, properties: getStoredProps(item2) };
      return generated2;
    });
    return {
      items: generated
    };
  };
  var getStoredProps = (id2) => {
    const stored = sessionStorage.getItem(String(id2));
    if (!stored) return {};
    try {
      const props = JSON.parse(stored);
      if (props._attribution) props._attribution += " Discovery";
      return props;
    } catch (e) {
      return {};
    }
  };

  // src/utilities/workerQueue.ts
  var workerQueue = (workers = 1) => {
    const queue2 = [];
    let active = 0;
    const doWork = () => {
      const iter = arrayIntoIterMut(queue2);
      for (active; active < workers; active++)
        spawnWorker(iter).then(() => active--).catch(() => active--);
    };
    let isDone;
    return {
      push(work) {
        return new Promise((res, reject) => {
          queue2.push(async () => {
            try {
              res(await work());
            } catch (e) {
              reject(e);
            }
          });
          queueMicrotask(doWork);
        });
      },
      done(action) {
        return isDone != null ? isDone : isDone = new Promise((res) => {
          const checkDone = () => {
            if (!queue2.length) {
              isDone = void 0;
              action();
              res(true);
            } else this.push(checkDone);
          };
          this.push(checkDone);
        });
      }
    };
  };
  function* arrayIntoIterMut(arr) {
    while (arr.length) {
      const item = arr.shift();
      if (item) yield item;
    }
  }
  var spawnWorker = async (iter) => {
    for (const work of iter) await work();
  };

  // src/alpine/store/cart.ts
  var _a3, _b;
  var cartStore = module_default.reactive({
    name: "cart",
    section: "cart-drawer",
    isOpen: new URLSearchParams(location.search).get("cart") === "true",
    updating: true,
    error: "",
    async displayError(message) {
      message = await message;
      if (!message) return;
      this.error = message;
      setTimeout(() => this.error === message && (this.error = ""), 1e4);
    },
    preorderDates: {},
    data: JSON.parse(
      (_b = (_a3 = document.querySelector("script#cart-data")) == null ? void 0 : _a3.textContent) != null ? _b : "{}"
    ),
    items: [],
    get visibleItems() {
      return this.items.filter(
        (item) => {
          var _a4, _b2;
          return !(((_a4 = item.properties) == null ? void 0 : _a4._gift_option) || ((_b2 = item.properties) == null ? void 0 : _b2._gift));
        }
      );
    },
    async update(action, retry = true) {
      try {
        this.updating = true;
        await cartUpdateQueue.push(action);
        await cartUpdateQueue.done(() => {
          this.load();
          this.updating = false;
          this.items = JSON.parse(JSON.stringify(this.data.items));
        });
      } catch (e) {
        console.error(e);
        this.displayError(errorMessageFromError(e));
        return this.update(
          retry ? action : async () => {
            var _a4;
            return this.data = (_a4 = await this.getState()) != null ? _a4 : this.data;
          },
          false
        );
      }
    },
    get totalItems() {
      return this.visibleItems.reduce((total, next) => total + next.quantity, 0);
    },
    get totalPrice() {
      return this.data.total_price;
    },
    init() {
      module_default.effect(() => {
        this.data.items.length;
        this.update(async () => {
          const preorders = await getPreorderDates(this.items);
          if (!preorders) return;
          this.preorderDates = preorders;
        });
      });
      window.addEventListener("rebuy.beforeAdd", () => this.updating = true);
      window.addEventListener(
        "rebuy.add",
        () => this.update(
          async () => {
            var _a4;
            return this.data = (_a4 = await this.getState()) != null ? _a4 : this.data;
          }
        )
      );
      this.updating = false;
    },
    toggle() {
      this.isOpen = !this.isOpen;
    },
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    load() {
      module_default.nextTick(() => {
        var _a4, _b2;
        return (_b2 = (_a4 = window.Rebuy) == null ? void 0 : _a4.init) == null ? void 0 : _b2.call(_a4);
      });
    },
    addItem(item) {
      return this.update(async () => {
        var _a4;
        await addItem(item);
        this.data = (_a4 = await this.getState()) != null ? _a4 : this.data;
      });
    },
    removeItem(key3) {
      return this.update(async () => {
        const indexToRemove = this.data.items.findIndex(
          (item) => item.key === key3
        );
        if (indexToRemove >= 0) this.data.items.splice(indexToRemove, 1);
        this.data = await removeItem(key3);
      });
    },
    updateItem(key3, data2) {
      if (data2.quantity === 0) this.removeItem(key3);
      else
        this.update(async () => {
          var _a4;
          const currentItem = this.items.find((item) => item.key === key3);
          const updatedItem = this.data.items.find((item) => item.key === key3);
          if (!currentItem) return;
          if (!currentItem.quantity || currentItem.quantity === (updatedItem == null ? void 0 : updatedItem.quantity))
            return;
          data2.quantity = currentItem.quantity;
          this.data = (_a4 = await updateItem(key3, data2)) != null ? _a4 : this.data;
        });
    },
    async addFromForm(formSelector) {
      this.error = "";
      const forms = document.querySelectorAll(
        formSelector.startsWith("form") ? formSelector : "form#" + formSelector
      );
      if (!forms.length)
        return console.warn("Form not found for selector:", formSelector);
      const itemData = Array.prototype.map.call(forms, (form2) => {
        if (!form2.reportValidity()) return console.warn("Form is invalid");
        return getItemFromFormData(new FormData(form2));
      }).filter(Boolean);
      await this.update(async () => {
        const data2 = await addItem(itemData);
        if (!data2 || data2 instanceof Response) throw data2;
        const { items } = data2;
        items.forEach((item) => {
          const indexOfItem = this.data.items.findIndex(
            (i) => i.key === item.key
          );
          if (indexOfItem > -1) this.data.items[indexOfItem] = item;
          else this.data.items.unshift(item);
        });
        this.open();
        await this.load();
      });
      await this.update(
        async () => {
          var _a4;
          return this.data = (_a4 = await this.getState()) != null ? _a4 : this.data;
        }
      );
    },
    getState() {
      return getState();
    }
  });
  var cart2 = (Alpine2) => Alpine2.store("cart", cartStore);
  var preorderDataCache = /* @__PURE__ */ new Map();
  var getPreorderDates = async (items) => {
    if (items.length > 0) {
      const allProducts = partition(
        items.map((item) => composeGid("Product", item.product_id)),
        (gid) => preorderDataCache.has(gid)
      );
      const allVariants = partition(
        items.map((item) => composeGid("ProductVariant", item.variant_id)),
        (gid) => preorderDataCache.has(gid)
      );
      if (allProducts[1].length + allVariants[1].length)
        try {
          const preorderDates = await gqlFetch({
            query: getManyPreorderDates,
            variables: { products: allProducts[1], variants: allVariants[1] }
          });
          if (!(preorderDates == null ? void 0 : preorderDates.data)) return;
          const data2 = preorderDates.data;
          Object.values(data2).flat().forEach((item) => preorderDataCache.set(item.id, item));
        } catch (e) {
          console.error("error at gql fetch", e);
        }
      return {
        productPreorder: allProducts.flat().map((gid) => preorderDataCache.get(gid)),
        variantPreorder: allVariants.flat().map((gid) => preorderDataCache.get(gid))
      };
    }
  };
  var cartUpdateQueue = workerQueue(1);
  var errorMessageFromError = async (e) => {
    var _a4;
    if (e instanceof Response)
      if (e.status === 422) {
        const errorData = await e.json();
        return (_a4 = errorData.description) != null ? _a4 : errorData.message;
      } else return e.statusText;
    if (e instanceof Error) {
      const message = e.message;
      if (message.includes("Theme Cart:")) return "";
      return message;
    }
    return "";
  };

  // src/alpine/store/mobileMenu.ts
  var mobileMenu2 = (Alpine2) => Alpine2.store("mobileMenu", {
    visible: false,
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    toggle() {
      this.visible = !this.visible;
    }
  });

  // src/alpine/store/modal.ts
  var modal = (Alpine2) => Alpine2.store("modal", {
    isOpen: false,
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    }
  });

  // src/alpine/store/searchStore.ts
  var searchStore = (Alpine2) => {
    Alpine2.store("search", {
      isOpen: false,
      query: "",
      get searchUrl() {
        const url = new URL("/search", window.location.origin);
        url.search = new URLSearchParams({
          q: this.query,
          type: "product"
        }).toString();
        return url;
      }
    });
  };

  // src/alpine/store/index.ts
  var simpleStores = (Alpine2) => {
    Alpine2.store("isLoading", {
      collection: false,
      cart: false,
      product: false
    });
  };
  var Stores = [cart2, simpleStores, mobileMenu2, modal, searchStore];

  // src/alpine/index.ts
  window.Alpine = module_default;
  [...Headless, ...Plugins, ...Stores, ...Components].forEach(module_default.plugin);
  var alpine_default2 = module_default;

  // src/index.ts
  alpine_default2.start();
  new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList)
      if (mutation.target === document.body) {
        if (document.body.style.overflow === "auto")
          document.body.style.overflow = null;
      }
  }).observe(document.body, { attributes: true });
})();
/*! Bundled license information:

@alpinejs/focus/dist/module.esm.js:
  (*! Bundled license information:
  
  tabbable/dist/index.esm.js:
    (*!
    * tabbable 5.3.3
    * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
    *)
  
  focus-trap/dist/focus-trap.esm.js:
    (*!
    * focus-trap 6.9.4
    * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
    *)
  *)
*/
